export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  DateTime: string
  Upload: any
}

export type AccessGroup = {
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  entityId: Scalars['ID']
  entityType: AccessGroupEntityType
  id: Scalars['ID']
  info?: Maybe<Scalars['String']>
  name: Scalars['String']
  networkId: Scalars['ID']
  type: Scalars['String']
}

export enum AccessGroupEntityType {
  network = 'network',
  post = 'post',
  space = 'space',
}

export type Action = {
  status: ActionStatus
}

export type ActionPermissions = {
  inputPermissions: Array<InputPathPermissions>
  isAuthorized: IsAuthorized
  name: Scalars['String']
  outputPermissions: Array<PathPermissions>
}

export enum ActionStatus {
  failed = 'failed',
  succeeded = 'succeeded',
}

export type ActiveSso = {
  logoutUrl?: Maybe<Scalars['String']>
  settingsUrl?: Maybe<Scalars['String']>
}

export type AddAppCollaboratorInput = {
  email: Scalars['String']
}

export type AddMediasInput = {
  contentTypes: Array<Scalars['String']>
}

export type AddMembersToGroupInput = {
  /** Member IDs to add to the group. Only 10 members can be added at a time. This limit does not apply to staff members. */
  memberIds: Array<Scalars['String']>
}

export type AddNetworkInput = {
  description?: InputMaybe<Scalars['String']>
  domain?: InputMaybe<Scalars['String']>
  entrancePage?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['String']>
  gclid?: InputMaybe<Scalars['String']>
  industry?: InputMaybe<NetworkIndustryType>
  name: Scalars['String']
  owner: JoinNetworkInput
  primaryMembers?: InputMaybe<NetworkPrimaryMembersType>
  promoCode?: InputMaybe<Scalars['String']>
  referrer?: InputMaybe<Scalars['String']>
  timeframe?: InputMaybe<NetworkTimeframeType>
  utmCampaign?: InputMaybe<Scalars['String']>
  utmContent?: InputMaybe<Scalars['String']>
  utmMedium?: InputMaybe<Scalars['String']>
  utmSource?: InputMaybe<Scalars['String']>
  utmTerm?: InputMaybe<Scalars['String']>
  visibility?: NetworkVisibility
}

export type AddReactionInput = {
  overrideSingleChoiceReactions?: InputMaybe<Scalars['Boolean']>
  participantId?: InputMaybe<Scalars['ID']>
  reaction: Scalars['String']
}

export type AddSpaceMemberInput = {
  memberId: Scalars['ID']
  roleId?: InputMaybe<Scalars['ID']>
}

export type AddedParticipantsMetadata = {
  addedParticipants: Array<ChatParticipant>
  type: ChatLogType
}

export type AddonInformation = {
  priceId: Scalars['String']
  productId: Scalars['String']
  quantity: Scalars['Float']
}

export type AdvanceReadMessageOffsetInput = {
  messageId: Scalars['String']
  pageId: Scalars['String']
  /** The address signature of the message that was provided as part of the server response. The operation will fail if signature is invalid. */
  signature: Scalars['String']
}

export type AdvanceReadMessageOffsetResult = {
  /** Whether the operation changed the offset or not. It will be false, if client tries to backdate the offset. */
  changed: Scalars['Boolean']
  /** The ID of the chat */
  chatId: Scalars['String']
  /** Number of unread message in the chat after the advancing the offset. */
  count?: Maybe<Scalars['Int']>
}

export type AnalyticsLimits = {
  /** @deprecated This resolver will be removed in the next version */
  planLimits?: Maybe<Array<AnalyticsPlanLimits>>
}

export type AnalyticsPlanLimits = {
  /** @deprecated This field will be removed in the next version */
  daysLimitation?: Maybe<Scalars['Float']>
  /** @deprecated This field will be removed in the next version */
  plan?: Maybe<Scalars['String']>
}

export type AnalyticsQueryTimeframe = {
  from: Scalars['Float']
  to: Scalars['Float']
}

export type AnalyticsResponse = {
  maxCacheTime: Scalars['Float']
  query: Scalars['String']
  records: Array<ReportRecord>
  timeframe: AnalyticsQueryTimeframe
}

export type ApiRateLimitStat = {
  consumableType: ApiRequestLimitType
  consumedPoints: Scalars['Float']
  duration: Scalars['Float']
  limit: Scalars['Float']
  remainingPoints: Scalars['Float']
  resetsAt: Scalars['DateTime']
}

export type ApiRequestLimit = {
  consumableType: ApiRequestLimitType
  duration: Scalars['Float']
  limit: Scalars['Float']
}

export enum ApiRequestLimitType {
  Complexity = 'Complexity',
  Request = 'Request',
}

export type App = {
  about?: Maybe<Scalars['String']>
  authMemberInstallation?: Maybe<AppInstallation>
  authorName?: Maybe<Scalars['String']>
  authorUrl?: Maybe<Scalars['String']>
  banner?: Maybe<Media>
  bannerId?: Maybe<Scalars['ID']>
  clientId?: Maybe<Scalars['String']>
  clientSecret?: Maybe<Scalars['String']>
  comingSoon: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<Member>
  createdById?: Maybe<Scalars['ID']>
  customCodes?: Maybe<AppCustomCodes>
  description?: Maybe<Scalars['String']>
  docsUrl?: Maybe<Scalars['String']>
  dynamicBlocks?: Maybe<Array<DynamicBlock>>
  embedIds: Array<Scalars['ID']>
  embeds?: Maybe<Array<Embed>>
  /** @deprecated Apps will be only installed on the network level */
  enabledContexts?: Maybe<Array<PermissionContext>>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  federatedSearchEnabled: Scalars['Boolean']
  globalBanner?: Maybe<Media>
  globalEmbeds?: Maybe<Array<Embed>>
  globalFavicon?: Maybe<Media>
  globalImage?: Maybe<Media>
  globalImages?: Maybe<Array<Media>>
  /** @deprecated Use the global gateway instead */
  globalNetwork?: Maybe<PluralNetwork>
  id: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  imageIds: Array<Scalars['ID']>
  images?: Maybe<Array<Media>>
  installed?: Maybe<Scalars['Boolean']>
  /** Whether the app is a consent management platform */
  isConsentManagementPlatform?: Maybe<Scalars['Boolean']>
  locked: Scalars['Boolean']
  name: Scalars['String']
  network?: Maybe<Network>
  networkId: Scalars['ID']
  onFreePlan?: Maybe<Scalars['Boolean']>
  privacyPolicyUrl?: Maybe<Scalars['String']>
  privatelyPublished?: Maybe<Scalars['Boolean']>
  requiredPermissions: Array<PrimaryScopes>
  secretToken?: Maybe<Scalars['String']>
  settingsBlock?: Maybe<DynamicBlock>
  slug: Scalars['String']
  standing: StoreItemStanding
  status: StoreItemStatus
  termsOfServiceUrl?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  updatedBy?: Maybe<Member>
  updatedById?: Maybe<Scalars['ID']>
  webhookSignSecret?: Maybe<Scalars['String']>
  webhookSubscriptions?: Maybe<Array<Scalars['String']>>
  webhookUrl?: Maybe<Scalars['String']>
}

export type AppAction = {
  data?: Maybe<Scalars['String']>
  status: ActionStatus
}

export type AppCollaborator = {
  addedById?: Maybe<Scalars['ID']>
  /** @deprecated Use the global gateway instead */
  app?: Maybe<App>
  appId: Scalars['ID']
  createdAt: Scalars['DateTime']
  email: Scalars['String']
  id: Scalars['ID']
  type: AppCollaboratorType
}

export enum AppCollaboratorType {
  COLLABORATOR = 'COLLABORATOR',
  OWNER = 'OWNER',
}

export type AppCustomCodes = {
  body?: Maybe<Scalars['String']>
  head?: Maybe<Scalars['String']>
}

export type AppEdge = {
  cursor: Scalars['String']
  node: App
}

export type AppInstallation = {
  app?: Maybe<App>
  appVersion?: Maybe<Scalars['String']>
  /** @deprecated Apps will be only installed on the network level */
  context?: Maybe<PermissionContext>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  installedAt: Scalars['DateTime']
  installedBy?: Maybe<Member>
  network?: Maybe<Network>
  permissions: Array<Scalars['String']>
  status: AppInstallationStatus
  /** @deprecated This field is unused and will be removed in future versions. */
  templatesMappings?: Maybe<AppInstallationTemplatesMappings>
  updatedAt: Scalars['DateTime']
}

export type AppInstallationEdge = {
  cursor: Scalars['String']
  node: AppInstallation
}

export enum AppInstallationStatus {
  DELETED = 'DELETED',
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

/** No longer supported. Will be removed in future releases. */
export type AppInstallationTemplatesMappings = {
  /** @deprecated No longer supported. Will be removed in future releases. */
  member?: Maybe<Array<TemplatesMapping>>
  /** @deprecated No longer supported. Will be removed in future releases. */
  postTypes?: Maybe<Array<TemplatesMapping>>
}

/** No longer supported. Will be removed in future releases. */
export type AppInstallationTemplatesMappingsInput = {
  memberTypes?: InputMaybe<Array<TemplatesMappingInput>>
  postTypes?: InputMaybe<Array<TemplatesMappingInput>>
}

export type AppInteraction = {
  appId: Scalars['String']
  interactionId: Scalars['String']
  props?: Maybe<Scalars['String']>
  slate?: Maybe<Slate>
  type: AppInteractionType
}

export enum AppInteractionType {
  Close = 'Close',
  Data = 'Data',
  OpenModal = 'OpenModal',
  OpenToast = 'OpenToast',
  Redirect = 'Redirect',
  Reload = 'Reload',
  Show = 'Show',
}

export type AppPublication = {
  addedById?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  itemId: Scalars['String']
  networkId: Scalars['String']
}

export type AppSetting = {
  appId: Scalars['String']
  context: PermissionContext
  entityId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  networkId: Scalars['String']
  settings: Scalars['String']
}

export type AppToken = {
  accessToken: Scalars['String']
  gatewayUrl?: Maybe<Scalars['String']>
}

export enum AskAiAvailability {
  disabled = 'disabled',
  everyone = 'everyone',
  staffOnly = 'staffOnly',
}

export type AssignOrRevokeBadgeInput = {
  memberId: Scalars['String']
}

export type AttachmentPreview = {
  /** Extension of the attachment */
  extension: Scalars['String']
  /** ID of the attachment */
  id: Scalars['ID']
  /** Name of the attachment */
  name?: Maybe<Scalars['String']>
  /** Size of the attachment */
  size?: Maybe<Scalars['String']>
}

export type AuthInfoWithOtp = {
  member: Member
  network: Network
  otp: Scalars['String']
  role?: Maybe<Role>
}

export type AuthToken = {
  accessToken: Scalars['String']
  member: Member
  network?: Maybe<Network>
  networkPublicInfo: NetworkPublicInfo
  /** Refresh token to obtain new access tokens. This token may get rotated based on a combination of policies when a new access token is issued. You should always store and use the latest refresh token provided. Guest sessions don’t receive a refresh token. */
  refreshToken: Scalars['String']
  role: Role
}

export type AuthTokenWithOtp = {
  accessToken: Scalars['String']
  member: Member
  network?: Maybe<Network>
  networkPublicInfo: NetworkPublicInfo
  otp: Scalars['String']
  /** Refresh token to obtain new access tokens. This token may get rotated based on a combination of policies when a new access token is issued. You should always store and use the latest refresh token provided. Guest sessions don’t receive a refresh token. */
  refreshToken: Scalars['String']
  role: Role
}

/** Input for autocompleting physical location suggestions. */
export type AutocompletePhysicalLocationInput = {
  /** The text string on which to search */
  input: Scalars['String']
  /** Session token for grouping autocomplete queries */
  sessionToken?: InputMaybe<Scalars['String']>
}

/** Result from autocompleting physical location. */
export type AutocompletePhysicalLocationResult = {
  /** Session token for grouping autocomplete queries */
  sessionToken: Scalars['String']
  /** Array of physical location suggestions */
  suggestions: Array<AutocompletePhysicalLocationSuggestion>
}

/** A physical location suggestion from autocomplete. */
export type AutocompletePhysicalLocationSuggestion = {
  /** Main text of the suggestion */
  mainText: Scalars['String']
  /** Place ID that can be used to get place details */
  placeId: Scalars['String']
  /** Secondary text of the suggestion (usually the address) */
  secondaryText: Scalars['String']
}

export type AvailableSearchSources = {
  /** Whether members are enabled for search. */
  members: Scalars['Boolean']
  /** Whether spaces are enabled for search. */
  spaces: Scalars['Boolean']
}

export type Badge = {
  active: Scalars['Boolean']
  backgroundColor?: Maybe<Scalars['String']>
  daysUntilExpired?: Maybe<Scalars['Float']>
  id: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  longDescription?: Maybe<Scalars['String']>
  name: Scalars['String']
  networkId: Scalars['ID']
  settings?: Maybe<Array<BadgeSettings>>
  shortDescription: Scalars['String']
  text?: Maybe<Scalars['String']>
  textColor?: Maybe<Scalars['String']>
  type: BadgeType
}

export type BadgeSettings = {
  key: Scalars['String']
  value: Scalars['String']
}

export type BadgeSettingsInput = {
  key: Scalars['String']
  value: Scalars['String']
}

export enum BadgeType {
  Manual = 'Manual',
  NewMember = 'NewMember',
  Role = 'Role',
  SuspendedMember = 'SuspendedMember',
}

export type BaseCustomFieldSchema = {
  archived?: Maybe<Scalars['Boolean']>
  description?: Maybe<Scalars['String']>
  externalKeys?: Maybe<Array<Scalars['String']>>
  items?: Maybe<BaseCustomFieldSchema>
  key: Scalars['String']
  name: Scalars['String']
  properties?: Maybe<Array<BaseCustomFieldSchema>>
  required?: Maybe<Scalars['Boolean']>
  type: CustomFieldType
  typeOptions?: Maybe<CustomFieldTypeOptions>
  validators?: Maybe<Array<CustomFieldValidator>>
}

export type BaseCustomFieldSchemaInput = {
  archived?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  externalKeys?: InputMaybe<Array<Scalars['String']>>
  items?: InputMaybe<BaseCustomFieldSchemaInput>
  key: Scalars['String']
  name: Scalars['String']
  properties?: InputMaybe<Array<BaseCustomFieldSchemaInput>>
  required?: InputMaybe<Scalars['Boolean']>
  type: CustomFieldType
  typeOptions?: InputMaybe<CustomFieldTypeOptionsInput>
  validators?: InputMaybe<Array<CustomFieldValidatorInput>>
}

export type BiDirectionalPageInfo = {
  endCursor?: Maybe<Scalars['String']>
  hasNextPage: Scalars['Boolean']
  hasPreviousPage: Scalars['Boolean']
  startCursor?: Maybe<Scalars['String']>
}

export type BillingPortalSession = {
  url: Scalars['String']
}

export type BillingPrice = {
  amount: Scalars['Float']
  default: Scalars['Boolean']
  id: Scalars['String']
  interval: BillingPriceInterval
}

export enum BillingPriceInterval {
  Month = 'Month',
  Year = 'Year',
}

export type BillingProduct = {
  app?: Maybe<App>
  appId?: Maybe<Scalars['String']>
  categories: Array<Scalars['String']>
  description?: Maybe<Scalars['String']>
  downgradable: Scalars['Boolean']
  features: Array<Scalars['String']>
  hubContent?: Maybe<HubContent>
  hubContentId?: Maybe<Scalars['String']>
  id: Scalars['String']
  imageUrls: Array<Scalars['String']>
  isEnterprise: Scalars['Boolean']
  name: Scalars['String']
  order?: Maybe<Scalars['Float']>
  popular: Scalars['Boolean']
  prices: Array<BillingPrice>
  public: Scalars['Boolean']
  purchasable: Scalars['Boolean']
  purchaseLimit?: Maybe<Scalars['Float']>
  requiredPlanOrder?: Maybe<Scalars['Float']>
}

export type BillingProducts = {
  addons: Array<BillingProduct>
  plans: Array<BillingProduct>
}

export type Block = {
  children?: Maybe<Scalars['String']>
  extraProps?: Maybe<Scalars['String']>
  id: Scalars['String']
  name: Scalars['String']
  output?: Maybe<Scalars['String']>
  props?: Maybe<Scalars['String']>
}

export type BlockInput = {
  children?: InputMaybe<Scalars['String']>
  extraProps?: InputMaybe<Scalars['String']>
  id: Scalars['String']
  name: Scalars['String']
  output?: InputMaybe<Scalars['String']>
  props?: InputMaybe<Scalars['String']>
}

export type By = Member

/** Structured calendar invite data. */
export type CalendarInviteData = {
  /** The description of the event. */
  description: Scalars['String']
  /** The end time of the event as a Unix timestamp in milliseconds. */
  end: Scalars['Float']
  /** The last modified time as a Unix timestamp in milliseconds. */
  lastModified: Scalars['Float']
  /** The physical location of the event. */
  location?: Maybe<Scalars['String']>
  /** The email of the event organizer. */
  organizerEmail?: Maybe<Scalars['String']>
  /** The name of the event organizer. */
  organizerName?: Maybe<Scalars['String']>
  /** The recurrence rule for recurring events. */
  recurrenceRule?: Maybe<Scalars['String']>
  /** The sequence number for the event. */
  sequence: Scalars['Int']
  /** The start time of the event as a Unix timestamp in milliseconds. */
  start: Scalars['Float']
  /** The title of the event. */
  title: Scalars['String']
  /** The unique identifier for the calendar event. */
  uid: Scalars['String']
  /** The URL for virtual events. */
  url?: Maybe<Scalars['String']>
}

export enum CallbackAction {
  Insert = 'Insert',
  Modal = 'Modal',
  None = 'None',
  Replace = 'Replace',
}

export type CallbackResponse = {
  action: CallbackAction
  slate?: Maybe<Slate>
  toast?: Maybe<Toast>
}

/** Input for canceling event registration. */
export type CancelRegistrationInput = {
  /** The mode to cancel event registration. If not provided, defaults to thisEventOnly. */
  recurringEventRegistrationMode?: InputMaybe<RecurringEventRegistrationMode>
}

export type CaptchaSettings = {
  enabled: Scalars['Boolean']
  secretKey?: Maybe<Scalars['String']>
  siteKey?: Maybe<Scalars['String']>
}

export type CaptchaSettingsInput = {
  enabled: Scalars['Boolean']
  secretKey?: InputMaybe<Scalars['String']>
  siteKey?: InputMaybe<Scalars['String']>
}

export type ChartData = {
  label: Scalars['String']
  points: Scalars['String']
  value?: Maybe<Scalars['String']>
}

export type Chat = {
  /** The ID of the chat */
  _id: Scalars['ID']
  /** The ID of the avatar image */
  avatarId?: Maybe<Scalars['String']>
  /** The URL of the avatar image */
  avatarUrl?: Maybe<Scalars['String']>
  /** The date the chat was created */
  createdAt: Scalars['DateTime']
  /** The ID of the user who created the chat */
  createdById: Scalars['String']
  /** The participation record of the authenticated user */
  currentParticipant?: Maybe<ChatParticipant>
  /** The hash ID of the chat, used to determine if there is an existing chat */
  hashId?: Maybe<Scalars['String']>
  /** The last message sent to the chat */
  lastMessage?: Maybe<MessagePreview>
  /** The name of the chat */
  name?: Maybe<Scalars['String']>
  /** The network to which the chat belongs */
  networkId: Scalars['String']
  /** The participation record of the other user in a direct chat. Null for group chats. */
  otherParticipant?: Maybe<ChatParticipant>
  /** The number of participants in the chat */
  participantCount: Scalars['Int']
  /** The status of the chat: active or archived */
  status: ChatStatus
  /** The type of the chat: direct or group */
  type: ChatType
  /** The date the chat was updated */
  updatedAt: Scalars['DateTime']
}

export type ChatIdFromSlug = {
  /** The ID of the chat */
  chatId?: Maybe<Scalars['String']>
  /** The slug of the legacy private messaging space */
  slug: Scalars['String']
}

export type ChatList = {
  data: Array<Chat>
  pageInfo: BiDirectionalPageInfo
}

export enum ChatLogType {
  AddedParticipants = 'AddedParticipants',
  CreatedGroup = 'CreatedGroup',
  DemotedAdmins = 'DemotedAdmins',
  EditedGroup = 'EditedGroup',
  LeftGroup = 'LeftGroup',
  PromotedAdmins = 'PromotedAdmins',
  RemovedParticipants = 'RemovedParticipants',
  TransferredOwnership = 'TransferredOwnership',
}

export type ChatParticipant = {
  _id: Scalars['ID']
  archivedAt?: Maybe<Scalars['String']>
  avatarUrl?: Maybe<Scalars['String']>
  chatId: Scalars['ID']
  deletedAt?: Maybe<Scalars['String']>
  handle: Scalars['String']
  lastReadMessage?: Maybe<MessageAddress>
  leftAt?: Maybe<Scalars['String']>
  memberId: Scalars['ID']
  name: Scalars['String']
  role: ChatParticipantRole
  status: ChatParticipantStatus
}

export type ChatParticipantList = {
  data: Array<ChatParticipant>
  pageInfo: PageInfo
}

export enum ChatParticipantRole {
  Admin = 'Admin',
  Member = 'Member',
  Owner = 'Owner',
}

export enum ChatParticipantStatus {
  Active = 'Active',
  Left = 'Left',
  Removed = 'Removed',
}

export enum ChatStatus {
  Active = 'Active',
  Tombstone = 'Tombstone',
}

export enum ChatType {
  Direct = 'Direct',
  Group = 'Group',
}

export type ClientApiUsage = {
  clientId: Scalars['String']
  clientName?: Maybe<Scalars['String']>
  value: Scalars['Float']
}

export type Collection = {
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<Member>
  customOrderingIndex: Scalars['Float']
  description?: Maybe<Scalars['String']>
  externalId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  name: Scalars['String']
  network?: Maybe<Network>
  relativeUrl?: Maybe<Scalars['String']>
  slug: Scalars['String']
  spaces?: Maybe<PaginatedSpace>
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
}

export type CollectionSpacesArgs = {
  exploreOnly?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
  memberId?: InputMaybe<Scalars['ID']>
}

export type CollectionEdge = {
  cursor: Scalars['String']
  node: Collection
}

export enum CollectionListOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  CUSTOM_ORDERING_INDEX = 'CUSTOM_ORDERING_INDEX',
  UPDATED_AT = 'UPDATED_AT',
}

export type ColumnSortInput = {
  key: Scalars['String']
  order?: InputMaybe<SortOrder>
}

export type CompleteMultiPartUploadInput = {
  /** The ID of the media that is being uploaded. */
  mediaId: Scalars['String']
}

export type CompletedMultiPartUpload = {
  error?: Maybe<Scalars['String']>
  media?: Maybe<Media>
  mediaId: Scalars['String']
}

export type ConfirmResetPasswordInput = {
  token: Scalars['String']
}

export enum ContactabilityStatus {
  BlockedByYou = 'BlockedByYou',
  BlockedYou = 'BlockedYou',
  Contactable = 'Contactable',
  LimitedByContactPrivacy = 'LimitedByContactPrivacy',
  LimitedBySitePrivacy = 'LimitedBySitePrivacy',
  Unknown = 'Unknown',
}

export type ContentModule = {
  authMemberProps?: Maybe<ContentModuleAuthMemberProps>
  contentModuleType: ContentModuleType
}

export type ContentModuleAuthMemberProps = {
  availableSpaces?: Maybe<Array<Space>>
  contentModuleType: ContentModuleType
  context: PermissionContext
  permissions?: Maybe<Array<ActionPermissions>>
  scopes?: Maybe<Array<Scalars['String']>>
}

/** The type of content modules provided */
export enum ContentModuleType {
  event = 'event',
}

export type ContentTranslationSettings = {
  enabled: Scalars['Boolean']
}

export type ContentTranslationSettingsInput = {
  enabled: Scalars['Boolean']
}

export type ContentTypeTemplate = {
  allowedReactions?: Maybe<Array<Scalars['String']>>
  context: PostTypeContext
  forbiddenReactions?: Maybe<Array<Scalars['String']>>
  languageTemplate?: Maybe<Scalars['String']>
  name: Scalars['String']
  pluralName: Scalars['String']
  postFields?: Maybe<CustomFieldsSchema>
  /** @deprecated Use allowedReactions instead. */
  primaryReactionType?: Maybe<ReactionType>
  selfRepliable?: Maybe<Scalars['Boolean']>
  shortContentTemplate?: Maybe<Scalars['String']>
  singleChoiceReactions?: Maybe<Array<Scalars['String']>>
  slate?: Maybe<Slate>
  slug: Scalars['String']
  titleTemplate?: Maybe<Scalars['String']>
  validReplyTypesIds?: Maybe<Array<Scalars['String']>>
}

export type ContextPermissions = {
  context: PermissionContext
  entityActions: Array<EntityPermissions>
}

export type ContextScopes = {
  context: PermissionContext
  entityScopes: Array<EntityScopes>
}

export type ConvertPostInput = {
  byPassFieldPermissions?: InputMaybe<Scalars['Boolean']>
  fallbackField?: InputMaybe<Scalars['String']>
  targetPostTypeId: Scalars['ID']
}

export type CreateAccessGroupInput = {
  description?: InputMaybe<Scalars['String']>
  entityId: Scalars['ID']
  entityType: AccessGroupEntityType
  info?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  type: Scalars['String']
}

export type CreateAppInput = {
  about?: InputMaybe<Scalars['String']>
  authorName?: InputMaybe<Scalars['String']>
  authorUrl?: InputMaybe<Scalars['String']>
  bannerId?: InputMaybe<Scalars['String']>
  comingSoon?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  networkId: Scalars['String']
  onFreePlan?: InputMaybe<Scalars['Boolean']>
  privacyPolicyUrl?: InputMaybe<Scalars['String']>
  slug?: InputMaybe<Scalars['String']>
  termsOfServiceUrl?: InputMaybe<Scalars['String']>
}

export type CreateBadgeInput = {
  active: Scalars['Boolean']
  backgroundColor?: InputMaybe<Scalars['String']>
  daysUntilExpired?: InputMaybe<Scalars['Float']>
  imageId?: InputMaybe<Scalars['String']>
  longDescription?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  settings?: InputMaybe<Array<BadgeSettingsInput>>
  shortDescription: Scalars['String']
  text?: InputMaybe<Scalars['String']>
  textColor?: InputMaybe<Scalars['String']>
}

export type CreateCollectionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>
  description?: InputMaybe<Scalars['String']>
  externalId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  updatedAt?: InputMaybe<Scalars['DateTime']>
}

export type CreateDraftPostInput = {
  /** The id of all the attachments to this post. */
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  createdAt?: InputMaybe<Scalars['DateTime']>
  /** The custom seo detail of this post */
  customSeoDetail?: InputMaybe<CustomSeoDetailInput>
  externalId?: InputMaybe<Scalars['String']>
  externalUrl?: InputMaybe<Scalars['String']>
  key?: InputMaybe<Scalars['String']>
  /** Whether the post is locked */
  locked?: InputMaybe<Scalars['Boolean']>
  /** The fields of the post. Depending of the post type it may include title, text, image, etc. */
  mappingFields: Array<PostMappingFieldInput>
  ownerId?: InputMaybe<Scalars['ID']>
  /** The id of all the polls associated with this post. */
  pollIds?: InputMaybe<Array<Scalars['String']>>
  /** The id of this post's type */
  postTypeId: Scalars['String']
  /**
   * This will publish the post immediately. If false, the post will become a draft.
   *       This is only usable by admins and moderators.
   */
  publish?: Scalars['Boolean']
  publishedAt?: InputMaybe<Scalars['DateTime']>
  /** Providing this field will schedule the post to be published at the given date. */
  scheduledFor?: InputMaybe<Scalars['DateTime']>
  /** The slug of the post creating the human readable part of its URL */
  slug?: InputMaybe<Scalars['String']>
  /** The TagIds for this post. Can be used in conjunction with tagNames. */
  tagIds?: InputMaybe<Array<Scalars['String']>>
  /** The tags of this post. Can be used in conjunction with tagIds. */
  tagNames?: InputMaybe<Array<Scalars['String']>>
  updatedAt?: InputMaybe<Scalars['DateTime']>
}

export type CreateEmojiInput = {
  text: Scalars['String']
}

/** Input for creating a new event. */
export type CreateEventInput = {
  /** IDs of files to attach to the event. */
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  /** The maximum number of attendees allowed for the event. */
  capacity?: InputMaybe<Scalars['Int']>
  /** The main content/description of the event. */
  content: Scalars['String']
  /** Custom SEO details for the event. */
  customSeoDetail?: InputMaybe<CustomSeoDetailInput>
  /** The end date and time of the event. */
  endTime: Scalars['DateTime']
  /** IDs of members who will be hosts of the event. */
  hostIds: Array<Scalars['String']>
  /** Notification settings for the event. */
  notificationSettings: EventNotificationSettingsInput
  /** Physical locations where the event takes place. */
  physicalLocations?: InputMaybe<Array<CreatePhysicalLocationInput>>
  /** IDs of polls to associate with the event. */
  pollIds?: InputMaybe<Array<Scalars['String']>>
  /** Configuration for recurring events. If provided, the event will repeat according to the specified settings. */
  recurrenceConfig?: InputMaybe<EventRecurrenceConfigInput>
  /** The URL slug for the event. If not provided, it will be generated from the title. */
  slug?: InputMaybe<Scalars['String']>
  /** The start date and time of the event. */
  startTime: Scalars['DateTime']
  /** IDs of tags to associate with the event. */
  tagIds?: InputMaybe<Array<Scalars['String']>>
  /** The ID of the thumbnail image for the event. */
  thumbnailId?: InputMaybe<Scalars['String']>
  /** The IANA timezone for the event times (e.g., "America/New_York", "UTC"). */
  timeZone: Scalars['String']
  /** The title of the event. */
  title: Scalars['String']
  /** Virtual locations where the event takes place online. */
  virtualLocations?: InputMaybe<Array<CreateVirtualLocationInput>>
}

export type CreateFileInput = {
  /** The MIME type of the file */
  contentType: Scalars['String']
  /** The extension of the file */
  extension: Scalars['String']
  /** The name of the file */
  name?: InputMaybe<Scalars['String']>
  /** The size of the file in bytes */
  size: Scalars['Float']
}

export type CreateGroupChatInput = {
  /** ID of the group avatar image */
  avatarId?: InputMaybe<Scalars['String']>
  /** List up to 10 members as initial group participants. Use addMembersToGroup mutation after creating the group to add more members. */
  memberIds: Array<Scalars['String']>
  /** Name of the group */
  name: Scalars['String']
}

export type CreateHighlightedTag = {
  /** ID of an existing tag. This field will become required in an upcoming release. */
  tagId: Scalars['String']
}

export type CreateImageInput = {
  /** The MIME type of the image */
  contentType: Scalars['String']
  /** The height of the crop */
  cropHeight?: InputMaybe<Scalars['Int']>
  /** The width of the crop */
  cropWidth?: InputMaybe<Scalars['Int']>
  /** The x coordinate of the crop */
  cropX?: InputMaybe<Scalars['Int']>
  /** The y coordinate of the crop */
  cropY?: InputMaybe<Scalars['Int']>
  /** The zoom of the crop */
  cropZoom?: InputMaybe<Scalars['Int']>
  /** The height of the image */
  height?: InputMaybe<Scalars['Int']>
  /** The name of the image */
  name?: InputMaybe<Scalars['String']>
  /** The size of the image in bytes */
  size: Scalars['Float']
  /** The width of the image */
  width?: InputMaybe<Scalars['Int']>
}

export type CreateLimitedSupportTokenInput = {
  networkId: Scalars['String']
}

export type CreatePermissionInput = {
  description?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  scopes: Array<Scalars['String']>
}

/** Input for creating a physical location for an event. */
export type CreatePhysicalLocationInput = {
  /** Additional data of the location. */
  additionalData?: InputMaybe<Scalars['String']>
  /** The display name of the location. */
  displayName?: InputMaybe<Scalars['String']>
  /** The formatted address of the location. */
  formattedAddress?: InputMaybe<Scalars['String']>
  /** The latitude coordinate of the location (-90 to 90 degrees). */
  latitude: Scalars['Float']
  /** The longitude coordinate of the location (-180 to 180 degrees). */
  longitude: Scalars['Float']
  /** The Google Places ID of the location. */
  placeId: Scalars['String']
  /** The Plus Code of the location. */
  plusCode?: InputMaybe<Scalars['String']>
}

export type CreatePollInput = {
  /** The time when the poll closes for voting. Set to null to remove close date. */
  closesAt?: InputMaybe<Scalars['DateTime']>
  /** The number of votes each participant can cast. Default is 1. */
  maxSelections?: InputMaybe<Scalars['Int']>
  /** The time when the poll opens for voting. */
  opensAt?: InputMaybe<Scalars['DateTime']>
  options: Array<PollOptionInput>
  /** The parent entity ID for the poll. Can only be null if the parent entity type is Post to create a draft poll. Draft polls will be lazily attached to the corresponding entity when the poll is first loaded as a property of the parent post. */
  parentEntityId?: InputMaybe<Scalars['String']>
  /** The parent entity type for the poll */
  parentEntityType: PollEntityType
  /** Required if parentEntityId is not provided. */
  parentHint?: InputMaybe<PollParentHintInput>
  title: Scalars['String']
}

/** Input for creating a post */
export type CreatePostInput = {
  /** The id of all the attachments to this post. */
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  createdAt?: InputMaybe<Scalars['DateTime']>
  /** The custom seo detail of this post */
  customSeoDetail?: InputMaybe<CustomSeoDetailInput>
  externalId?: InputMaybe<Scalars['String']>
  externalUrl?: InputMaybe<Scalars['String']>
  key?: InputMaybe<Scalars['String']>
  /** Whether the post is locked */
  locked?: InputMaybe<Scalars['Boolean']>
  /** The fields of the post. Depending of the post type it may include title, text, image, etc. */
  mappingFields: Array<PostMappingFieldInput>
  ownerId?: InputMaybe<Scalars['ID']>
  /** The id of all the polls associated with this post. */
  pollIds?: InputMaybe<Array<Scalars['String']>>
  /** The id of this post's type */
  postTypeId: Scalars['String']
  /**
   * This will publish the post immediately. If false, the post will become a draft.
   *       This is only usable by admins and moderators.
   */
  publish?: Scalars['Boolean']
  publishedAt?: InputMaybe<Scalars['DateTime']>
  /** The slug of the post creating the human readable part of its URL */
  slug?: InputMaybe<Scalars['String']>
  /** The TagIds for this post. Can be used in conjunction with tagNames. */
  tagIds?: InputMaybe<Array<Scalars['String']>>
  /** The tags of this post. Can be used in conjunction with tagIds. */
  tagNames?: InputMaybe<Array<Scalars['String']>>
  updatedAt?: InputMaybe<Scalars['DateTime']>
}

export type CreatePostTypeInput = {
  allowedReactions?: InputMaybe<Array<Scalars['String']>>
  context: PostTypeContext
  customReactions?: InputMaybe<Array<CustomReactionInput>>
  description?: InputMaybe<Scalars['String']>
  excludedNativeShortcuts?: InputMaybe<Array<Scalars['String']>>
  forbiddenReactions?: InputMaybe<Array<Scalars['String']>>
  iconId?: InputMaybe<Scalars['ID']>
  languageTemplate?: InputMaybe<Scalars['String']>
  layout?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  nativeFieldsTemplates?: InputMaybe<NativeFieldsTemplatesInput>
  pluralName: Scalars['String']
  postFields?: InputMaybe<CustomFieldsSchemaInput>
  primaryReactionType?: InputMaybe<ReactionType>
  recommendationsSettings?: InputMaybe<PostTypeRecommendationSettingsInput>
  selfRepliable?: InputMaybe<Scalars['Boolean']>
  shortContentTemplate?: InputMaybe<Scalars['String']>
  singleChoiceReactions?: InputMaybe<Array<Scalars['String']>>
  slate?: InputMaybe<SlateInput>
  titleTemplate?: InputMaybe<Scalars['String']>
  validReplyTypesIds?: InputMaybe<Array<Scalars['String']>>
}

export type CreateReportInput = {
  captchaToken?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  entityId: Scalars['String']
  entityType: ModerationEntityType
  reportCategory: ReportCategory
  spaceId?: InputMaybe<Scalars['String']>
}

/** Input for creating a space. */
export type CreateSpaceInput = {
  address?: InputMaybe<SpaceAddressInput>
  adminIds?: InputMaybe<Array<Scalars['String']>>
  /** The id of the space banner. */
  bannerId?: InputMaybe<Scalars['String']>
  /** The id of the collection in which the space is created. */
  collectionId?: InputMaybe<Scalars['ID']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  customSeoDetail?: InputMaybe<CustomSeoDetailInput>
  /** The description of the space. */
  description?: InputMaybe<Scalars['String']>
  externalId?: InputMaybe<Scalars['String']>
  externalUrl?: InputMaybe<Scalars['String']>
  /** Is this space hidden? */
  hidden?: InputMaybe<Scalars['Boolean']>
  /** The id of the space image. */
  imageId?: InputMaybe<Scalars['String']>
  /** Is this space invite only? */
  inviteOnly?: InputMaybe<Scalars['Boolean']>
  layout?: InputMaybe<Scalars['String']>
  memberIds?: InputMaybe<Array<Scalars['String']>>
  /** The name of the space. */
  name: Scalars['String']
  nonAdminsCanInvite?: InputMaybe<Scalars['Boolean']>
  /** Is this space a private space? */
  private?: InputMaybe<Scalars['Boolean']>
  seoDetail?: InputMaybe<SpaceSeoDetailInput>
  slate?: InputMaybe<SlateInput>
  /** The slug of the space. It will be auto-generated if not provided. */
  slug?: InputMaybe<Scalars['String']>
  type?: InputMaybe<SpaceType>
  updatedAt?: InputMaybe<Scalars['DateTime']>
  whoCanPost?: InputMaybe<Array<SpaceRoleType>>
  whoCanReact?: InputMaybe<Array<SpaceRoleType>>
  whoCanReply?: InputMaybe<Array<SpaceRoleType>>
  withRoles?: InputMaybe<Scalars['Boolean']>
}

/** Input for creating a tag. */
export type CreateTagInput = {
  /** The description of the tag. */
  description?: InputMaybe<Scalars['String']>
  /** The slug of the tag. Slug is auto-generated from title if left empty. */
  slug?: InputMaybe<Scalars['String']>
  /** The name of the tag. */
  title: Scalars['String']
}

export type CreateTemplateInput = {
  about?: InputMaybe<Scalars['String']>
  appIds?: InputMaybe<Array<Scalars['String']>>
  authorName?: InputMaybe<Scalars['String']>
  authorUrl?: InputMaybe<Scalars['String']>
  bannerId?: InputMaybe<Scalars['String']>
  categories?: InputMaybe<Array<Scalars['String']>>
  comingSoon?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  entityId: Scalars['String']
  entityType: TemplateEntityType
  faviconId?: InputMaybe<Scalars['String']>
  hubContentId?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  onFreePlan?: InputMaybe<Scalars['Boolean']>
  previewHtml?: InputMaybe<Scalars['String']>
  privacyPolicyUrl?: InputMaybe<Scalars['String']>
  slug?: InputMaybe<Scalars['String']>
  termsOfServiceUrl?: InputMaybe<Scalars['String']>
  upsertKey?: InputMaybe<Scalars['String']>
}

/** Input for creating a virtual location for an event. */
export type CreateVirtualLocationInput = {
  /** The provider of the virtual meeting (e.g., Zoom, Google Meet, Microsoft Teams). */
  provider: Scalars['String']
  /** The URL of the virtual meeting. */
  url: Scalars['String']
}

export type CreatedGroupMetadata = {
  type: ChatLogType
}

export enum CreatorType {
  App = 'App',
  Member = 'Member',
  System = 'System',
}

export type CustomCode = {
  anonymize: Scalars['Boolean']
  code: Scalars['String']
  /** Indicates whether the custom code enables integration with cookie consent management platforms (CMPs). */
  isCmpProvider?: Maybe<Scalars['Boolean']>
  position: CustomCodePosition
}

export enum CustomCodePosition {
  BODY = 'BODY',
  HEAD = 'HEAD',
}

export type CustomField = {
  key: Scalars['String']
  relationEntities?: Maybe<CustomFieldRelation>
  value?: Maybe<Scalars['String']>
}

export type CustomFieldInput = {
  key: Scalars['String']
  value: Scalars['String']
}

export type CustomFieldPrivacy = {
  allow: Array<CustomFieldPrivacyOptions>
}

export type CustomFieldPrivacyInput = {
  allow: Array<CustomFieldPrivacyOptions>
}

export enum CustomFieldPrivacyOptions {
  ADMIN = 'ADMIN',
  OWN = 'OWN',
}

export type CustomFieldRelation = {
  medias: Array<Media>
  members: Array<Member>
  posts: Array<Post>
  spaces: Array<Space>
  tags: Array<Tag>
}

export type CustomFieldSchema = {
  archived?: Maybe<Scalars['Boolean']>
  default?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  externalKeys?: Maybe<Array<Scalars['String']>>
  items?: Maybe<BaseCustomFieldSchema>
  key: Scalars['String']
  name: Scalars['String']
  properties?: Maybe<Array<BaseCustomFieldSchema>>
  readPrivacy?: Maybe<CustomFieldPrivacy>
  required?: Maybe<Scalars['Boolean']>
  searchable?: Maybe<Scalars['Boolean']>
  settings?: Maybe<Array<CustomFieldSettings>>
  type: CustomFieldType
  typeOptions?: Maybe<CustomFieldTypeOptions>
  validators?: Maybe<Array<CustomFieldValidator>>
  writePrivacy?: Maybe<CustomFieldPrivacy>
}

export type CustomFieldSchemaInput = {
  archived?: InputMaybe<Scalars['Boolean']>
  default?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  externalKeys?: InputMaybe<Array<Scalars['String']>>
  items?: InputMaybe<BaseCustomFieldSchemaInput>
  key: Scalars['String']
  name: Scalars['String']
  properties?: InputMaybe<Array<BaseCustomFieldSchemaInput>>
  readPrivacy?: InputMaybe<CustomFieldPrivacyInput>
  required?: InputMaybe<Scalars['Boolean']>
  searchable?: InputMaybe<Scalars['Boolean']>
  settings?: InputMaybe<Array<CustomFieldSettingsInput>>
  type: CustomFieldType
  typeOptions?: InputMaybe<CustomFieldTypeOptionsInput>
  validators?: InputMaybe<Array<CustomFieldValidatorInput>>
  writePrivacy?: InputMaybe<CustomFieldPrivacyInput>
}

export type CustomFieldSettings = {
  key: Scalars['String']
  value: Scalars['String']
}

export type CustomFieldSettingsInput = {
  key: Scalars['String']
  value: Scalars['String']
}

export enum CustomFieldType {
  array = 'array',
  boolean = 'boolean',
  date = 'date',
  number = 'number',
  object = 'object',
  relation = 'relation',
  richText = 'richText',
  text = 'text',
}

export type CustomFieldTypeOptions = {
  dateType?: Maybe<DateTypeOptions>
  numberType?: Maybe<NumberTypeOptions>
  relationType?: Maybe<RelationTypeOptions>
  richTextType?: Maybe<RichTextTypeOptions>
  textType?: Maybe<TextTypeOptions>
}

export type CustomFieldTypeOptionsInput = {
  dateType?: InputMaybe<DateTypeOptions>
  numberType?: InputMaybe<NumberTypeOptions>
  relationType?: InputMaybe<RelationTypeOptions>
  richTextType?: InputMaybe<RichTextTypeOptions>
  textType?: InputMaybe<TextTypeOptions>
}

export type CustomFieldValidator = {
  customErrorMessage?: Maybe<Scalars['String']>
  validation: CustomFieldValidators
  value: Scalars['String']
}

export type CustomFieldValidatorInput = {
  customErrorMessage?: InputMaybe<Scalars['String']>
  validation: CustomFieldValidators
  value: Scalars['String']
}

export enum CustomFieldValidators {
  allOf = 'allOf',
  anyOf = 'anyOf',
  enum = 'enum',
  exclusiveMaximum = 'exclusiveMaximum',
  exclusiveMinimum = 'exclusiveMinimum',
  format = 'format',
  maxItems = 'maxItems',
  maxLength = 'maxLength',
  maxProperties = 'maxProperties',
  maximum = 'maximum',
  minItems = 'minItems',
  minLength = 'minLength',
  minProperties = 'minProperties',
  minimum = 'minimum',
  multipleOf = 'multipleOf',
  not = 'not',
  oneOf = 'oneOf',
  pattern = 'pattern',
  uniqueItems = 'uniqueItems',
}

export type CustomFieldsSchema = {
  fields: Array<CustomFieldSchema>
}

export type CustomFieldsSchemaInput = {
  fields: Array<CustomFieldSchemaInput>
}

export enum CustomHostnameStatus {
  Missing = 'Missing',
  Ok = 'Ok',
  Pending = 'Pending',
  Wrong = 'Wrong',
}

export type CustomReaction = {
  activeColor?: Maybe<Scalars['String']>
  activeGlyphId?: Maybe<Scalars['String']>
  activeName?: Maybe<Scalars['String']>
  color?: Maybe<Scalars['String']>
  glyphId: Scalars['String']
  key: Scalars['String']
  name: Scalars['String']
}

export type CustomReactionInput = {
  activeColor?: InputMaybe<Scalars['String']>
  activeGlyphId?: InputMaybe<Scalars['String']>
  activeName?: InputMaybe<Scalars['String']>
  color?: InputMaybe<Scalars['String']>
  glyphId: Scalars['String']
  key: Scalars['String']
  name: Scalars['String']
}

export type CustomSeoDetail = {
  canonicalUrl?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  noIndex?: Maybe<Scalars['Boolean']>
  thumbnail?: Maybe<Media>
  thumbnailId?: Maybe<Scalars['ID']>
  title?: Maybe<Scalars['String']>
}

export type CustomSeoDetailInput = {
  canonicalUrl?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  noIndex?: InputMaybe<Scalars['Boolean']>
  thumbnailId?: InputMaybe<Scalars['ID']>
  title?: InputMaybe<Scalars['String']>
}

export enum CustomSsoType {
  Saml = 'Saml',
  oauth2 = 'oauth2',
}

export type DailyApiUsage = {
  date: Scalars['DateTime']
  total: Scalars['Float']
  usageType: ApiRequestLimitType
  values: Array<ClientApiUsage>
}

export enum DateFilterByOperator {
  equals = 'equals',
  gt = 'gt',
  gte = 'gte',
  hasValue = 'hasValue',
  in = 'in',
  lt = 'lt',
  lte = 'lte',
  nin = 'nin',
  not = 'not',
}

export enum DateTypeOptions {
  date = 'date',
  datetime = 'datetime',
}

export enum DayOfWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
}

export enum DefaultSsoType {
  Apple = 'Apple',
  Discord = 'Discord',
  Slack = 'Slack',
  facebook = 'facebook',
  google = 'google',
  linkedin = 'linkedin',
}

/** Input for deleting an event. */
export type DeleteEventInput = {
  /** The mode to delete the event recurrence. If not provided, defaults to thisEventOnly. */
  recurringEventUpdateMode?: InputMaybe<RecurringEventUpdateMode>
}

export type DemoteChatAdminsInput = {
  /** List of member ids to demote from admin. These members must already be a part of the group chat. */
  memberIds: Array<Scalars['String']>
}

export type DemotedAdminsMetadata = {
  demotedParticipants: Array<ChatParticipant>
  type: ChatLogType
}

export type DeprecatedBaseFilterInput = {
  and?: InputMaybe<Array<DeprecatedBaseFilterInput>>
  filtername: Filtername
  key?: InputMaybe<Scalars['String']>
  negator?: InputMaybe<Scalars['String']>
  operator?: InputMaybe<Scalars['String']>
  or?: InputMaybe<Array<DeprecatedBaseFilterInput>>
  value?: InputMaybe<Scalars['String']>
}

export type DeprecatedFiltersInput = {
  filter: DeprecatedBaseFilterInput
}

export enum DnsRecordStatus {
  Healthy = 'Healthy',
  Missing = 'Missing',
  Pending = 'Pending',
  Wrong = 'Wrong',
}

export enum DnsRecordType {
  CNAME = 'CNAME',
  TXT = 'TXT',
}

export type DomainAvailability = {
  available: Scalars['Boolean']
}

export type DomainAvailabilityInput = {
  domain: Scalars['String']
}

export type DomainDnsRecord = {
  desiredValue: Scalars['String']
  message?: Maybe<Scalars['String']>
  name: Scalars['String']
  status: DnsRecordStatus
  type: DnsRecordType
}

export type DomainParseResult = {
  isApex: Scalars['Boolean']
  parts: DomainParts
}

export type DomainParts = {
  /** The apex part of the address. It includes the domain and TLD. The `my-domain.com` in `sub.my-domain.com`. */
  apex: Scalars['String']
  /** The full domain name (a.k.a FQDN). It includes the subdomain, domain, and TLD. Is equivalent to `apex` if `subdomain` is missing. */
  domain: Scalars['String']
  /** The Second-level domain of the address that appears before TLD. The `my-domain` in `sub.my-domain.com`. */
  sld: Scalars['String']
  /** The subdomain part of the address. The `sub` in `sub.my-domain.com`. */
  subdomain?: Maybe<Scalars['String']>
  /** The Top-level domain of the address, per ICANN specifications. (e.g. com, org, co.uk) */
  tld: Scalars['String']
}

export type DomainProbeResult = {
  customHostnameStatus: CustomHostnameStatus
  dnsRecords: Array<DomainDnsRecord>
  parseResult?: Maybe<DomainParseResult>
  status: DomainProbeStatus
}

export enum DomainProbeStatus {
  Active = 'Active',
  Available = 'Available',
  Invalid = 'Invalid',
  Pending = 'Pending',
  ReadyForTransfer = 'ReadyForTransfer',
  Reserved = 'Reserved',
  RestrictedFeature = 'RestrictedFeature',
  Taken = 'Taken',
}

export type DomainTransferStatus = {
  aaaarecordSuccess: Scalars['Boolean']
  aaaarecords: Array<Scalars['String']>
  arecordSuccess: Scalars['Boolean']
  arecords: Array<Scalars['String']>
  cnameSuccess: Scalars['Boolean']
  cnames: Array<Scalars['String']>
  domain: Scalars['String']
  ns: Array<Scalars['String']>
  root: Scalars['Boolean']
  success: Scalars['Boolean']
  tribeARecords: Array<Scalars['String']>
  tribeCname: Scalars['String']
}

export type DynamicBlock = {
  app?: Maybe<App>
  appId: Scalars['String']
  contexts?: Maybe<Array<PermissionContext>>
  description?: Maybe<Scalars['String']>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  key: Scalars['String']
  maxSize: DynamicBlockSize
  name: Scalars['String']
  slate?: Maybe<Slate>
  staffOnly: Scalars['Boolean']
}

export type DynamicBlockSlateArgs = {
  context: PermissionContext
  entityId?: InputMaybe<Scalars['ID']>
}

export type DynamicBlockEdge = {
  cursor: Scalars['String']
  node: DynamicBlock
}

export enum DynamicBlockSize {
  full = 'full',
  lg = 'lg',
  md = 'md',
  sm = 'sm',
  xl = 'xl',
}

export type EditMessageInput = {
  /** IDs of attached files. */
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  content: Scalars['String']
  /** IDs of embedded links. */
  embedIds?: InputMaybe<Array<Scalars['String']>>
  /** IDs of attached images. */
  imageIds?: InputMaybe<Array<Scalars['String']>>
  messageId: Scalars['String']
  pageId: Scalars['String']
}

export type EditedGroupMetadata = {
  avatarId?: Maybe<Scalars['String']>
  avatarUrl?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  type: ChatLogType
}

export type EmailAvailability = {
  available: Scalars['Boolean']
}

export enum EmailDigestFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
}

export type EmailDigestRecentPostsFilter = {
  filterOption: EmailDigestRecentPostsFilterOption
  spaceIds: Array<Scalars['String']>
}

export type EmailDigestRecentPostsFilterInput = {
  filterOption: EmailDigestRecentPostsFilterOption
  spaceIds: Array<Scalars['String']>
}

export enum EmailDigestRecentPostsFilterOption {
  ALL_SPACES_EXCEPT_SELECTED = 'ALL_SPACES_EXCEPT_SELECTED',
  JOINED_SPACES = 'JOINED_SPACES',
  ONLY_SELECTED_SPACES = 'ONLY_SELECTED_SPACES',
}

export type EmailLog = {
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  reason?: Maybe<Scalars['String']>
  recipient: Scalars['String']
  status: EmailStatus
  type: EmailType
  updatedAt: Scalars['DateTime']
}

export type EmailLogEdge = {
  cursor: Scalars['String']
  node: EmailLog
}

export enum EmailStatus {
  BLOCKED = 'BLOCKED',
  BOUNCED = 'BOUNCED',
  CREATED = 'CREATED',
  DEFERRED = 'DEFERRED',
  DELIVERED = 'DELIVERED',
  DROPPED = 'DROPPED',
  PROCESSED = 'PROCESSED',
  SENT = 'SENT',
}

export enum EmailType {
  AppNotification = 'AppNotification',
  CollaboratorInvitation = 'CollaboratorInvitation',
  EmailDigest = 'EmailDigest',
  EmailVerification = 'EmailVerification',
  ExportFinished = 'ExportFinished',
  MemberConfirmation = 'MemberConfirmation',
  MemberInvitation = 'MemberInvitation',
  Notification = 'Notification',
  ResetPassword = 'ResetPassword',
  Unknown = 'Unknown',
}

export type Embed = {
  author?: Maybe<Scalars['String']>
  author_url?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  html?: Maybe<Scalars['String']>
  id: Scalars['ID']
  options?: Maybe<Scalars['String']>
  provider_name?: Maybe<Scalars['String']>
  thumbnail_height?: Maybe<Scalars['String']>
  thumbnail_url?: Maybe<Scalars['String']>
  thumbnail_width?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  url: Scalars['String']
}

export type EmbedInput = {
  options?: InputMaybe<Scalars['String']>
  url: Scalars['String']
}

export type EmbedPreview = {
  description?: Maybe<Scalars['String']>
  iconUrl?: Maybe<Scalars['String']>
  /** ID of the embed */
  id: Scalars['ID']
  providerName?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  /** The embedded URL */
  url: Scalars['String']
}

export type Emoji = {
  id: Scalars['ID']
  text: Scalars['String']
}

export type EntityListFilterByInput = {
  key: Scalars['String']
  operator: EntityListFilterByOperator
  value: Scalars['String']
}

export enum EntityListFilterByOperator {
  contains = 'contains',
  endsWith = 'endsWith',
  equals = 'equals',
  gt = 'gt',
  gte = 'gte',
  hasValue = 'hasValue',
  in = 'in',
  lt = 'lt',
  lte = 'lte',
  nin = 'nin',
  not = 'not',
  startsWith = 'startsWith',
}

export type EntityPermissions = {
  actions: Array<ActionPermissions>
  id: Scalars['String']
}

export type EntityReport = {
  data?: Maybe<Array<ReportData>>
  description?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['DateTime']>
  entity?: Maybe<ReportableEntity>
  entityId: Scalars['ID']
  entityType: ReportableEntityType
  startDate?: Maybe<Scalars['DateTime']>
  tooltip?: Maybe<Scalars['String']>
}

export type EntityScopes = {
  id: Scalars['String']
  scopes: Array<Scalars['String']>
}

/** An event created in a space. */
export type Event = {
  /** IDs of files attached to the event. */
  attachmentIds: Array<Scalars['String']>
  attachments?: Maybe<Array<File>>
  authMemberProps?: Maybe<EventAuthMemberProps>
  /** The maximum number of attendees allowed for the event. */
  capacity?: Maybe<Scalars['Int']>
  /** The main content/description of the event. */
  content: Scalars['String']
  /** The date and time when the event was created. */
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<SpaceMember>
  /** The ID of the member who created the event. */
  createdById: Scalars['ID']
  /** Custom SEO details for the event. */
  customSeoDetail?: Maybe<CustomSeoDetail>
  /** IDs of embeds included in the event content. */
  embedIds: Array<Scalars['String']>
  embeds?: Maybe<Array<Embed>>
  /** The end time of the event. */
  endTime: Scalars['DateTime']
  /** The ID of the event detail. This is used to fetch recurring events that share the same detail. */
  eventDetailId: Scalars['ID']
  /** IDs of members who are hosts of the event. */
  hostIds: Array<Scalars['String']>
  hosts?: Maybe<Array<Member>>
  /** The unique identifier of the event. */
  id: Scalars['ID']
  /** IDs of images associated with the event. */
  imageIds: Array<Scalars['String']>
  images?: Maybe<Array<Media>>
  /** The detected language of the event content. */
  language?: Maybe<Scalars['String']>
  /** IDs of members mentioned in the event content. */
  mentionedMembers: Array<Scalars['String']>
  mentions?: Maybe<Array<Member>>
  /** Notification settings for the event. */
  notificationSettings: EventNotificationSettings
  /** The physical locations where the event takes place. */
  physicalLocations?: Maybe<Array<PhysicalLocation>>
  /** IDs of polls associated with the event. */
  pollIds: Array<Scalars['String']>
  polls?: Maybe<Array<Poll>>
  /** The 3 most recent registrations for this event. */
  recentRegistrations?: Maybe<Array<EventRegistration>>
  /** Configuration for recurring events. */
  recurrenceConfig?: Maybe<EventRecurrenceConfig>
  /** The ID of the recurring event series. Use to fetch all recurrences of the event series. */
  recurrenceId?: Maybe<Scalars['ID']>
  /** The number of registered members for this event. */
  registrationsCount: Scalars['Int']
  relativeUrl?: Maybe<Scalars['String']>
  /** SEO details for the event. */
  seoDetail: PostSeoDetail
  /** A shortened version of the event content. */
  shortContent: Scalars['String']
  /** The URL slug for the event. */
  slug: Scalars['String']
  space?: Maybe<Space>
  /** The ID of the space where the event is created. */
  spaceId: Scalars['ID']
  /** The start time of the event. */
  startTime: Scalars['DateTime']
  /** The current status of the event. */
  status: EventStatus
  /** IDs of tags associated with the event. */
  tagIds: Array<Scalars['String']>
  tags?: Maybe<Array<Tag>>
  thumbnail?: Maybe<Media>
  /** The ID of the thumbnail image for the event. */
  thumbnailId?: Maybe<Scalars['String']>
  /** The timezone for the event times. */
  timeZone: Scalars['String']
  /** The title of the event. */
  title: Scalars['String']
  /** The date and time when the event was last updated. */
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
  /** The virtual locations where the event takes place online. */
  virtualLocations?: Maybe<Array<VirtualLocation>>
}

export type EventAuthMemberProps = {
  context: PermissionContext
  eventRegistration?: Maybe<EventRegistration>
  permissions?: Maybe<Array<ActionPermissions>>
  scopes?: Maybe<Array<Scalars['String']>>
}

export type EventDateFilterInput = {
  operator: DateFilterByOperator
  value: Scalars['String']
}

export type EventEdge = {
  cursor: Scalars['String']
  node: Event
}

/** The order by field to sort the events by. */
export enum EventListOrderByEnum {
  createdAt = 'createdAt',
  endTime = 'endTime',
  startTime = 'startTime',
  title = 'title',
  updatedAt = 'updatedAt',
}

export enum EventMetric {
  conversionRatio = 'conversionRatio',
  uniqueRegistrants = 'uniqueRegistrants',
  uniqueVisitors = 'uniqueVisitors',
}

/** Notification settings for event updates and reminders. */
export type EventNotificationSettings = {
  /** Whether to send notifications when the event is deleted. */
  notifyOnDelete: Scalars['Boolean']
  /** Whether to send notifications when someone registers for the event. */
  notifyOnRegister: Scalars['Boolean']
  /** Whether to send notifications when the event is updated. */
  notifyOnUpdate: Scalars['Boolean']
  /** Whether to send reminder notifications before the event starts. */
  remindBefore: Scalars['Boolean']
}

/** Input for configuring event notification settings. */
export type EventNotificationSettingsInput = {
  /** Whether to send notifications when the event is deleted. */
  notifyOnDelete: Scalars['Boolean']
  /** Whether to send notifications when someone registers for the event. */
  notifyOnRegister: Scalars['Boolean']
  /** Whether to send notifications when the event is updated. */
  notifyOnUpdate: Scalars['Boolean']
  /** Whether to send reminder notifications before the event starts. */
  remindBefore: Scalars['Boolean']
}

/** A recurrence of an event. */
export type EventRecurrence = {
  authMemberProps?: Maybe<EventAuthMemberProps>
  /** The end time of the event. */
  endTime: Scalars['DateTime']
  /** The unique identifier of the end. */
  id: Scalars['ID']
  /** The physical locations where the event takes place. */
  physicalLocations?: Maybe<Array<PhysicalLocation>>
  /** The 3 most recent registrations for this event. */
  recentRegistrations?: Maybe<Array<EventRegistration>>
  /** The number of registered members for this event. */
  registrationsCount: Scalars['Int']
  relativeUrl?: Maybe<Scalars['String']>
  /** The start time of the event. */
  startTime: Scalars['DateTime']
  /** The status of the event. */
  status: EventStatus
  url?: Maybe<Scalars['String']>
}

/** Configuration for recurring events. */
export type EventRecurrenceConfig = {
  /** The frequency of the recurring event (daily, weekly, monthly, yearly). */
  frequency: RecurringEventFrequency
  /** The end date for the recurring event series. */
  recurrenceEndDate?: Maybe<Scalars['DateTime']>
  /** The days of the week for the recurring event. Required when frequency is weekly. */
  repeatsOn?: Maybe<Array<DayOfWeek>>
}

/** Configuration for recurring events. */
export type EventRecurrenceConfigInput = {
  /** The frequency of the recurring event (daily, weekly, monthly, yearly). */
  frequency: RecurringEventFrequency
  /** The end date for the recurring event series. */
  recurrenceEndDate?: InputMaybe<Scalars['DateTime']>
  /** The days of the week for the recurring event. Required when frequency is weekly. */
  repeatsOn?: InputMaybe<Array<DayOfWeek>>
}

export type EventRecurrenceEdge = {
  cursor: Scalars['String']
  node: EventRecurrence
}

/** The order by field to sort the event recurrences by. */
export enum EventRecurrenceOrderByEnum {
  createdAt = 'createdAt',
  endTime = 'endTime',
  startTime = 'startTime',
  updatedAt = 'updatedAt',
}

/** A member registration for an event. */
export type EventRegistration = {
  /** The date and time when the registration was cancelled. */
  cancelledAt?: Maybe<Scalars['DateTime']>
  /** The ID of the event. */
  eventId: Scalars['ID']
  /** The unique identifier of the registration. */
  id: Scalars['ID']
  member?: Maybe<Member>
  /** The ID of the member who registered. */
  memberId: Scalars['ID']
  /** The date and time when the member registered. */
  registeredAt: Scalars['DateTime']
  /** The status of the registration. */
  status: EventRegistrationStatus
}

export type EventRegistrationEdge = {
  cursor: Scalars['String']
  node: EventRegistration
}

export enum EventRegistrationStatus {
  cancelled = 'cancelled',
  registered = 'registered',
}

/** The status of the event. */
export enum EventStatus {
  deleted = 'deleted',
  draft = 'draft',
  published = 'published',
}

export type EventType = {
  description: Scalars['String']
  name: Scalars['String']
  noun: Scalars['String']
  requiredScope: Scalars['String']
  shortDescription: Scalars['String']
  verb: EventVerb
}

export enum EventVerb {
  ACCEPTED = 'ACCEPTED',
  ADDED = 'ADDED',
  BANNED = 'BANNED',
  BLOCKED = 'BLOCKED',
  CANCELED = 'CANCELED',
  CLICKED = 'CLICKED',
  CREATED = 'CREATED',
  CUSTOM = 'CUSTOM',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  FOLLOWED = 'FOLLOWED',
  GENERATED = 'GENERATED',
  HIDDEN = 'HIDDEN',
  IMPRESSION = 'IMPRESSION',
  INSTALLED = 'INSTALLED',
  LOGGED_IN = 'LOGGED_IN',
  MARKED_FOR_PURGE = 'MARKED_FOR_PURGE',
  NOT_ASSIGNED = 'NOT_ASSIGNED',
  PERMITTED = 'PERMITTED',
  PING = 'PING',
  PINGED = 'PINGED',
  PINNED = 'PINNED',
  PUBLISHED = 'PUBLISHED',
  PURGED = 'PURGED',
  RECEIVED = 'RECEIVED',
  REGISTERED = 'REGISTERED',
  REJECTED = 'REJECTED',
  REMOVED = 'REMOVED',
  RESENT = 'RESENT',
  REVOKED = 'REVOKED',
  SENT = 'SENT',
  SIGNED_UP = 'SIGNED_UP',
  SUCCEEDED = 'SUCCEEDED',
  SUSPENDED = 'SUSPENDED',
  UNBLOCKED = 'UNBLOCKED',
  UNFOLLOWED = 'UNFOLLOWED',
  UNHIDDEN = 'UNHIDDEN',
  UNINSTALLED = 'UNINSTALLED',
  UNPINNED = 'UNPINNED',
  UNPUBLISHED = 'UNPUBLISHED',
  UNSUSPENDED = 'UNSUSPENDED',
  UNUSED = 'UNUSED',
  UNVERIFIED = 'UNVERIFIED',
  UPDATED = 'UPDATED',
  USED = 'USED',
  VERIFIED = 'VERIFIED',
  VIEWED = 'VIEWED',
}

export type Export = {
  createdAt: Scalars['DateTime']
  endedAt?: Maybe<Scalars['DateTime']>
  fields: Array<Scalars['String']>
  file?: Maybe<File>
  fileId: Scalars['ID']
  filterBy?: Maybe<Array<MemberListFilterBy>>
  id: Scalars['ID']
  networkId: Scalars['ID']
  startedAt?: Maybe<Scalars['DateTime']>
  status: ExportStatus
  updatedAt: Scalars['DateTime']
}

export type ExportEdge = {
  cursor: Scalars['String']
  node: Export
}

export type ExportInput = {
  fields: Array<Scalars['String']>
  filterBy?: InputMaybe<Array<MemberListFilterByInput>>
  query?: InputMaybe<Scalars['String']>
}

export enum ExportListOrderByEnum {
  CreatedAt = 'CreatedAt',
  UpdatedAt = 'UpdatedAt',
}

export enum ExportStatus {
  Done = 'Done',
  Expired = 'Expired',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Initialized = 'Initialized',
}

export type ExternalSearchResult = {
  description: Scalars['String']
  iconUrl?: Maybe<Scalars['String']>
  id: Scalars['ID']
  title: Scalars['String']
  url: Scalars['String']
}

export type ExtraProperty = {
  key: Scalars['String']
  value: Scalars['String']
}

export enum ExtraPropertyEntityType {
  Member = 'Member',
  Network = 'Network',
}

export type File = {
  downloadUrl: Scalars['String']
  extension: Scalars['String']
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  size?: Maybe<Scalars['Int']>
  status?: Maybe<MediaStatus>
  url: Scalars['String']
}

export enum FilterOperator {
  And = 'And',
  Or = 'Or',
}

export enum Filtername {
  and = 'and',
  leaf = 'leaf',
  or = 'or',
}

/** FiltersInput class is used to group multiple group filters with a logical operator. It allows combining multiple group filters using AND, OR, or other logical operators. Each filters input represents a set of group filters combined with a logical operator. For example, a filters input with operator AND and group filters [{operator: OR, matchFilters: [{key: "status", is: "\"active\""}, {key: "status", is: "\"pending\""}]}, {operator: AND, matchFilters: [{key: "age", range: {gte: "18", lte: "30"}}]}] will match records where (status is "active" or "pending") and (age is between 18 and 30) inclusive. */
export type FiltersInput = {
  /** List of group filters to be combined. Each group filter represents a set of conditions (match filters) combined with a logical operator. */
  groupFilters: Array<GroupFiltersInput>
  /** Logical operator to combine group filters. This can be AND, OR, etc. */
  operator: FilterOperator
}

export enum FlaggedType {
  MEMBER = 'MEMBER',
  SYSTEM = 'SYSTEM',
}

export type Footer = {
  urls: Array<FooterUrl>
}

export type FooterUrl = {
  title: Scalars['String']
  url: Scalars['String']
}

/** GeoBoundingBoxInput class is used to filter fields of type geo-point. It allows specifying a bounding box with top-left and bottom-right geographical points. */
export type GeoBoundingBoxInput = {
  /** Bottom-right point of the bounding box */
  bottomRight: GeoPointInput
  /** Top-left point of the bounding box */
  topLeft: GeoPointInput
}

/** GeoPointInput class is used to represent a geographical point with latitude and longitude. It is useful for geo-based filtering. */
export type GeoPointInput = {
  /** Latitude of the geographical point */
  lat: Scalars['Float']
  /** Longitude of the geographical point */
  lon: Scalars['Float']
}

/** GeoRadiusInput class is used to filter fields of type geo-point. It allows specifying a radius with a center geographical point. */
export type GeoRadiusInput = {
  /** Center point of the radius */
  center: GeoPointInput
  /** Radius distance from the center point */
  radius: Scalars['Float']
}

export enum GetEventsRecurrenceMode {
  collapseBySeries = 'collapseBySeries',
  expanded = 'expanded',
}

export type GlobalToken = {
  accessToken: Scalars['String']
  email: Scalars['String']
}

export type GlobalTokenInput = {
  email: Scalars['String']
  verificationCode: Scalars['String']
}

export type Glyph = {
  id: Scalars['ID']
  text: Scalars['String']
  variant: GlyphMediaVariant
}

export enum GlyphMediaVariant {
  emoji = 'emoji',
  icon = 'icon',
}

export enum GroupChatCreationPermission {
  Anyone = 'Anyone',
  Staff = 'Staff',
}

/** GroupFiltersInput class is used to group multiple match filters with a logical operator. It allows combining multiple match filters using AND, OR, or other logical operators. Each group filter represents a set of conditions (match filters) combined with a logical operator. For example, a group filter with operator AND and match filters [{key: "status", is: "\"active\""}, {key: "age", range: {gte: "18"}}] will match records where the status is "active" and the age is 18 or more. */
export type GroupFiltersInput = {
  /** List of match filters to be combined. Each match filter represents a single condition. */
  matchFilters: Array<MatchFilterInput>
  /** Logical operator to combine match filters. This can be AND, OR, etc. */
  operator: FilterOperator
}

export enum HomeSpaceType {
  Default = 'Default',
  NewUser = 'NewUser',
  ReturningUser = 'ReturningUser',
}

export type HubContent = {
  attachmentIds: Array<Scalars['ID']>
  attachments?: Maybe<Array<File>>
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  embedIds: Array<Scalars['ID']>
  embeds?: Maybe<Array<Embed>>
  fields?: Maybe<Array<HubContentCustomField>>
  id: Scalars['ID']
  imageIds: Array<Scalars['ID']>
  images?: Maybe<Array<Media>>
  language?: Maybe<Scalars['String']>
  /** Whether the post is locked */
  locked: Scalars['Boolean']
  postTypeId: Scalars['ID']
  publishedAt?: Maybe<Scalars['DateTime']>
  slug?: Maybe<Scalars['String']>
  tagIds?: Maybe<Array<Scalars['String']>>
  thumbnail?: Maybe<Media>
  thumbnailId?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export type HubContentCustomField = {
  key: Scalars['String']
  relationEntities?: Maybe<HubContentCustomFieldRelation>
  value?: Maybe<Scalars['String']>
}

export type HubContentCustomFieldRelation = {
  medias: Array<Media>
}

export type Image = {
  cropHeight?: Maybe<Scalars['Int']>
  cropWidth?: Maybe<Scalars['Int']>
  cropX: Scalars['Int']
  cropY: Scalars['Int']
  cropZoom: Scalars['Float']
  dominantColorHex?: Maybe<Scalars['String']>
  downloadUrl: Scalars['String']
  dpi?: Maybe<Scalars['Float']>
  height?: Maybe<Scalars['Float']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  status?: Maybe<MediaStatus>
  url: Scalars['String']
  urls?: Maybe<MediaUrls>
  width?: Maybe<Scalars['Float']>
}

export type ImagePreview = {
  /** The dominant color of the image */
  dominantColorHex?: Maybe<Scalars['String']>
  /** Thumbnail URL of the image */
  iconUrl: Scalars['String']
  /** ID of the image */
  id: Scalars['ID']
  /** Name of the image */
  name?: Maybe<Scalars['String']>
}

export type ImpersonateLoginToNetworkInput = {
  memberId: Scalars['ID']
  networkId: Scalars['ID']
}

export type In = Space

export type InputPathPermissions = {
  isAuthorized: IsAuthorized
  path: Scalars['String']
  values: Array<ValuePermissions>
}

export type InstallAppInput = {
  context?: InputMaybe<PermissionContext>
  entityId?: InputMaybe<Scalars['String']>
  permissions?: InputMaybe<Array<PrimaryScopes>>
  templatesMappings?: InputMaybe<AppInstallationTemplatesMappingsInput>
}

export type IntValue = {
  int: Scalars['Int']
}

export type InteractWithAppInput = {
  appId: Scalars['String']
  callbackId?: InputMaybe<Scalars['String']>
  dynamicBlockKey?: InputMaybe<Scalars['String']>
  inputs?: InputMaybe<Scalars['String']>
  interactionId: Scalars['String']
  preview?: InputMaybe<Scalars['Boolean']>
  props?: InputMaybe<Scalars['String']>
  shortcutKey?: InputMaybe<Scalars['String']>
}

/** Input for inviting members. */
export type InviteMembersInput = {
  /** The ids of the default spaces the invitees have. */
  defaultSpacesIds?: InputMaybe<Array<Scalars['ID']>>
  /** When does the invitations expire? Empty for no expiration. */
  expiresAt?: InputMaybe<Scalars['DateTime']>
  /** Custom message for invitation. */
  invitationMessage?: InputMaybe<Scalars['String']>
  /** The details of the invitees */
  invitees: Array<InviteeInput>
  /** The id of the role the invitees have. */
  roleId?: InputMaybe<Scalars['ID']>
}

export type InviteeInput = {
  /** The ids of the default spaces this invitee has. */
  defaultSpacesIds?: InputMaybe<Array<Scalars['ID']>>
  /** The email address of the invitee. */
  email: Scalars['String']
  /** The name of the invitee. */
  name?: InputMaybe<Scalars['String']>
  /** The role id of the invitee. */
  roleId?: InputMaybe<Scalars['ID']>
}

export type IsAuthorized = {
  authorized: Scalars['Boolean']
  onPaidPlan?: Maybe<Scalars['Boolean']>
  reason?: Maybe<UnauthorizedReason>
}

export type JoinNetworkInput = {
  captchaToken?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  email: Scalars['String']
  externalId?: InputMaybe<Scalars['String']>
  externalUrl?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  password: Scalars['String']
  phone?: InputMaybe<Scalars['String']>
  tagline?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['DateTime']>
  username?: InputMaybe<Scalars['String']>
  verified?: InputMaybe<Scalars['Boolean']>
}

export type JoinNetworkWithLinkInput = {
  captchaToken?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  invitationLinkId: Scalars['String']
  name: Scalars['String']
  password: Scalars['String']
  username?: InputMaybe<Scalars['String']>
}

export type JoinNetworkWithTokenInput = {
  captchaToken?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  password: Scalars['String']
  token: Scalars['String']
  username?: InputMaybe<Scalars['String']>
}

export type JwtSsoAuthUrls = {
  authorizationUrl?: Maybe<Scalars['String']>
  signUpUrl?: Maybe<Scalars['String']>
}

export type JwtSsoToken = {
  clientSecret: Scalars['String']
}

export type KeyValue = {
  key: Scalars['String']
  value?: Maybe<Scalars['String']>
}

export type LeaderboardItem = {
  member?: Maybe<Member>
  memberId: Scalars['String']
  score: Scalars['Float']
}

export type LeftGroupMetadata = {
  type: ChatLogType
}

export type LocationCoordinatesInput = {
  /** The latitude coordinate of the location (-90 to 90 degrees). */
  latitude: Scalars['Float']
  /** The longitude coordinate of the location (-180 to 180 degrees). */
  longitude: Scalars['Float']
}

export type LoginNetworkWithPasswordInput = {
  password: Scalars['String']
  usernameOrEmail: Scalars['String']
}

export type LoginSupportWithSsoCodeInput = {
  code: Scalars['String']
  hd: Scalars['String']
  prompt: Scalars['String']
  scope: Scalars['String']
  state: Scalars['String']
}

export type LoginWithSamlResponseInput = {
  relayState: Scalars['String']
  samlResponse: Scalars['String']
}

export type LoginWithSsoCodeInput = {
  code?: InputMaybe<Scalars['String']>
  hd?: InputMaybe<Scalars['String']>
  oauth_token?: InputMaybe<Scalars['String']>
  oauth_verifier?: InputMaybe<Scalars['String']>
  prompt?: InputMaybe<Scalars['String']>
  scope?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
}

export type LogoutNetworkInput = {
  sessionId: Scalars['String']
}

export type MapUrlsInput = {
  /** The height of the image in pixels */
  height?: InputMaybe<Scalars['Int']>
  /** The scale value for higher resolution displays (1 or 2) */
  scale?: InputMaybe<Scalars['Int']>
  /** The width of the image in pixels */
  width?: InputMaybe<Scalars['Int']>
  /** The zoom level (0-21) */
  zoom?: InputMaybe<Scalars['Int']>
}

export type MassActionFilters = {
  entityIds?: InputMaybe<Array<Scalars['ID']>>
  filterBy?: InputMaybe<Array<MemberListFilterByInput>>
  query?: InputMaybe<Scalars['String']>
}

export type MassActionFiltersModel = {
  entityIds?: Maybe<Array<Scalars['ID']>>
  filterBy?: Maybe<Array<MemberListFilterBy>>
  query?: Maybe<Scalars['String']>
}

export type MassActionRequest = {
  action: MassActionRequestAction
  context: MassActionRequestContext
  createdAt: Scalars['DateTime']
  createdById: Scalars['String']
  endedAt?: Maybe<Scalars['DateTime']>
  entitiesCount?: Maybe<Scalars['Int']>
  failedCount?: Maybe<Scalars['Int']>
  filters: MassActionFiltersModel
  id: Scalars['ID']
  networkId: Scalars['ID']
  processedCount?: Maybe<Scalars['Int']>
  startedAt?: Maybe<Scalars['DateTime']>
  status: MassActionRequestStatus
  updatedAt: Scalars['DateTime']
}

export enum MassActionRequestAction {
  Accept = 'Accept',
  AddTag = 'AddTag',
  AddToSpace = 'AddToSpace',
  AssignBadge = 'AssignBadge',
  Create = 'Create',
  Delete = 'Delete',
  Expire = 'Expire',
  Flag = 'Flag',
  Follow = 'Follow',
  Hide = 'Hide',
  Lock = 'Lock',
  Move = 'Move',
  Pin = 'Pin',
  Publish = 'Publish',
  Reject = 'Reject',
  RemoveTag = 'RemoveTag',
  Resend = 'Resend',
  Revoke = 'Revoke',
  RevokeBadge = 'RevokeBadge',
  Suspend = 'Suspend',
  Unflag = 'Unflag',
  Unfollow = 'Unfollow',
  Unhide = 'Unhide',
  Unpin = 'Unpin',
  Unsuspend = 'Unsuspend',
  Update = 'Update',
  Verify = 'Verify',
}

export enum MassActionRequestContext {
  Member = 'Member',
  MemberInvitation = 'MemberInvitation',
  ModerationItem = 'ModerationItem',
  Post = 'Post',
  Space = 'Space',
  Tag = 'Tag',
}

export type MassActionRequestExtraPropertiesInput = {
  badgeIds?: InputMaybe<Array<Scalars['ID']>>
  includeReplies?: InputMaybe<Scalars['Boolean']>
  postTypeId?: InputMaybe<Scalars['ID']>
  removeAllTags?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['ID']>
  tagIds?: InputMaybe<Array<Scalars['ID']>>
  tagNames?: InputMaybe<Array<Scalars['ID']>>
  updatePostProperties?: InputMaybe<MassActionUpdatePostPropertiesInput>
}

export type MassActionRequestInput = {
  action: MassActionRequestAction
  context: MassActionRequestContext
  extraProperties?: InputMaybe<MassActionRequestExtraPropertiesInput>
  filters: MassActionFilters
  waitForConfirmation?: InputMaybe<Scalars['Boolean']>
}

export enum MassActionRequestStatus {
  Done = 'Done',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Initialized = 'Initialized',
  WaitingForConfirmation = 'WaitingForConfirmation',
}

export type MassActionUpdatePostPropertiesInput = {
  ownerId?: InputMaybe<Scalars['String']>
  publishedAt?: InputMaybe<Scalars['DateTime']>
}

/** MatchFilterInput class is used to filter fields of various types. It allows specifying different conditions such as equality, text containment, range, geo-bounding box, geo-radius, values count, null check, and emptiness check. Each match filter represents a single condition applied to a specific field. For example, instead of title is 'hello', you would use {key: "title", is: "\"hello\""} */
export type MatchFilterInput = {
  /** Filter to match any of the provided values (values should be JSON strings). For example, {key: "status", any: ["\"active\"", "\"pending\""]} will match records where the status field is either "active" or "pending". */
  any?: InputMaybe<Array<Scalars['String']>>
  /** Filter to check if the text contains a specific string. For example, {key: "description", containsText: "example"} will match records where the description field contains the string "example". */
  containsText?: InputMaybe<Scalars['String']>
  /** Filter to check if the text does not contain a specific string. For example, {key: "description", doesNotContainText: "example"} will match records where the description field does not contain the string "example". */
  doesNotContainText?: InputMaybe<Scalars['String']>
  /** Filter to exclude all of the provided values (values should be JSON strings). For example, {key: "status", except: ["\"inactive\"", "\"banned\""]} will match records where the status field is neither "inactive" nor "banned". */
  except?: InputMaybe<Array<Scalars['String']>>
  /** Filter to match a geographical bounding box. For example, {key: "location", geoBoundingBox: {topLeft: {lat: 40.73, lon: -74.1}, bottomRight: {lat: 40.01, lon: -71.12}}} will match records where the location field is within the specified bounding box. */
  geoBoundingBox?: InputMaybe<GeoBoundingBoxInput>
  /** Filter to match a geographical radius. For example, {key: "location", geoRadius: {center: {lat: 40.73, lon: -74.1}, radius: 10}} will match records where the location field is within a 10 km radius of the specified center point. */
  geoRadius?: InputMaybe<GeoRadiusInput>
  /** Filter to match the exact value (value should be a JSON string). For example, {key: "title", is: "\"hello\""} will match records where the title field is exactly "hello". */
  is?: InputMaybe<Scalars['String']>
  /** Filter to check if the field value is empty (for strings or arrays). For example, {key: "comments", isEmpty: true} will match records where the comments field (an array) is empty. */
  isEmpty?: InputMaybe<Scalars['Boolean']>
  /** Filter to exclude the exact value (value should be a JSON string). For example, {key: "title", isNot: "\"hello\""} will match records where the title field is not "hello". */
  isNot?: InputMaybe<Scalars['String']>
  /** Filter to check if the field value is null. For example, {key: "deletedAt", isNull: true} will match records where the deletedAt field is null. */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Field key to apply the filter on. This specifies which field the condition will be applied to. */
  key: Scalars['String']
  /** Filter to match a range of dates or numbers (each value should be a JSON string). For example, {key: "age", range: {gte: "18", lte: "30"}} will match records where the age field is between 18 and 30 inclusive. For dates, {key: "createdAt", range: {gte: "2022-01-01", lte: "2022-12-31"}} will match records where the createdAt field is between January 1, 2022, and December 31, 2022 inclusive. */
  range?: InputMaybe<RangeInput>
  /** Filter to match the count of values in an array. For example, {key: "tags", valuesCount: {gte: 3}} will match records where the tags field (an array) has 3 or more values. */
  valuesCount?: InputMaybe<ValuesCountInput>
}

export type Media = Emoji | File | Glyph | Image

export type MediaBase = {
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  purgeRequestedAt?: Maybe<Scalars['DateTime']>
  purgedAt?: Maybe<Scalars['DateTime']>
  remoteUrl?: Maybe<Scalars['String']>
  status: MediaStatus
  type: MediaType
  uploaded: Scalars['Boolean']
}

export type MediaLimits = {
  /** @deprecated There is no limit on file size anymore */
  fileSizeLimit?: Maybe<Scalars['Float']>
  /** @deprecated There is no limit on file types anymore */
  fileTypesLimit?: Maybe<Array<Scalars['String']>>
  /** @deprecated There is no limit on image size anymore */
  imageSizeLimit?: Maybe<Scalars['Float']>
  /** @deprecated There is no limit on image types anymore */
  imageTypesLimit?: Maybe<Array<Scalars['String']>>
}

export type MediaNetworkSettings = {
  alternateUploadDestination?: Maybe<Scalars['String']>
  fileSizeLimit: Scalars['Float']
  fileTypesLimit: Array<Scalars['String']>
  imageSizeLimit: Scalars['Float']
  imageTypesLimit: Array<Scalars['String']>
}

export enum MediaStatus {
  Ok = 'Ok',
  Pending = 'Pending',
  Removed = 'Removed',
}

export enum MediaType {
  Emoji = 'Emoji',
  File = 'File',
  Glyph = 'Glyph',
  Image = 'Image',
}

export type MediaUrls = {
  full: Scalars['String']
  icon?: Maybe<Scalars['String']>
  large: Scalars['String']
  medium: Scalars['String']
  small: Scalars['String']
  thumb: Scalars['String']
}

export type Member = {
  activeSession?: Maybe<MemberSession>
  /** @deprecated Has been replaced by locale field */
  attributes: MemberAttributes
  authMemberProps?: Maybe<MemberAuthMemberProps>
  badges?: Maybe<Array<MemberBadge>>
  banner?: Maybe<Media>
  bannerId?: Maybe<Scalars['ID']>
  blockedMemberIds?: Maybe<Array<Scalars['String']>>
  blockedMembers?: Maybe<Array<Member>>
  createdAt: Scalars['DateTime']
  /** @deprecated Has been replaced with name */
  displayName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  emailStatus?: Maybe<MemberEmailStatus>
  externalId?: Maybe<Scalars['ID']>
  externalUrl?: Maybe<Scalars['String']>
  extraProperties?: Maybe<Array<ExtraProperty>>
  fields?: Maybe<Array<CustomField>>
  flagged: Scalars['Boolean']
  id: Scalars['ID']
  lastSeen?: Maybe<Scalars['DateTime']>
  lastSeenAt?: Maybe<Scalars['DateTime']>
  locale: Scalars['String']
  name?: Maybe<Scalars['String']>
  network?: Maybe<Network>
  networkId: Scalars['ID']
  newEmail?: Maybe<Scalars['String']>
  /** @deprecated Use the teammate field instead */
  overrideTeammate?: Maybe<Scalars['Boolean']>
  profilePicture?: Maybe<Media>
  profilePictureId?: Maybe<Scalars['ID']>
  relativeUrl?: Maybe<Scalars['String']>
  role?: Maybe<Role>
  roleId: Scalars['ID']
  score?: Maybe<Scalars['Int']>
  sessions?: Maybe<Array<MemberSession>>
  settings?: Maybe<MemberSettings>
  shortcuts?: Maybe<Array<Shortcut>>
  spaces?: Maybe<PaginatedSpace>
  staffReasons?: Maybe<Array<StaffReason>>
  status: MemberStatus
  subscribersCount?: Maybe<Scalars['Int']>
  tagline?: Maybe<Scalars['String']>
  teammate: Scalars['Boolean']
  timeZone?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
  username: Scalars['String']
  verifiedAt?: Maybe<Scalars['DateTime']>
}

export type MemberExtraPropertiesArgs = {
  keys?: InputMaybe<Array<Scalars['String']>>
}

export type MemberSpacesArgs = {
  exploreOnly?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
}

export type MemberAttributes = {
  locale: Scalars['String']
}

export type MemberAuthMemberProps = {
  canSendPrivateMessages?: Maybe<Scalars['Boolean']>
  context: PermissionContext
  permissions?: Maybe<Array<ActionPermissions>>
  scopes?: Maybe<Array<Scalars['String']>>
  subscribed?: Maybe<Scalars['Boolean']>
}

export type MemberBadge = {
  backgroundColor?: Maybe<Scalars['String']>
  badge?: Maybe<Badge>
  badgeId: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  longDescription?: Maybe<Scalars['String']>
  shortDescription: Scalars['String']
  text?: Maybe<Scalars['String']>
  textColor?: Maybe<Scalars['String']>
  type: BadgeType
}

export type MemberContactabilityStatus = {
  memberId: Scalars['String']
  status: ContactabilityStatus
}

export type MemberEdge = {
  cursor: Scalars['String']
  node: Member
}

export enum MemberEmailStatus {
  notDelivered = 'notDelivered',
  sent = 'sent',
  spammed = 'spammed',
  verified = 'verified',
}

export type MemberEventRegistration = {
  /** The ID of the event. */
  eventId: Scalars['ID']
  /** The registration for the event. */
  registration?: Maybe<EventRegistration>
}

export type MemberForSpaceInvitation = {
  member: Member
  memberId: Scalars['ID']
  spaceAffiliation: SpaceMemberAffiliation
}

export type MemberInvitation = {
  createdAt: Scalars['DateTime']
  emailLog?: Maybe<EmailLog>
  emailLogs?: Maybe<Array<EmailLog>>
  expiresAt: Scalars['DateTime']
  id: Scalars['ID']
  invitationMessage?: Maybe<Scalars['String']>
  invitee?: Maybe<Member>
  inviteeEmail: Scalars['String']
  inviteeId?: Maybe<Scalars['ID']>
  inviteeName?: Maybe<Scalars['String']>
  inviter?: Maybe<Member>
  inviterId?: Maybe<Scalars['ID']>
  joinedAt?: Maybe<Scalars['DateTime']>
  network?: Maybe<Network>
  networkId: Scalars['ID']
  role?: Maybe<Role>
  roleId: Scalars['ID']
  status: MemberInvitationStatus
}

export type MemberInvitationEdge = {
  cursor: Scalars['String']
  node: MemberInvitation
}

export type MemberInvitationFilterByInput = {
  key: Scalars['String']
  operator: MemberInvitationFilterByOperator
  value: Scalars['String']
}

export enum MemberInvitationFilterByOperator {
  contains = 'contains',
  equals = 'equals',
  gt = 'gt',
  gte = 'gte',
  lt = 'lt',
  lte = 'lte',
  not = 'not',
}

export type MemberInvitationLink = {
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  inviter?: Maybe<Member>
  link: Scalars['String']
  network?: Maybe<Network>
}

export enum MemberInvitationStatus {
  Expired = 'Expired',
  Pending = 'Pending',
  Revoked = 'Revoked',
  accepted = 'accepted',
  delivered = 'delivered',
  notDelivered = 'notDelivered',
  notSent = 'notSent',
  rejected = 'rejected',
  sent = 'sent',
  spammed = 'spammed',
}

export type MemberListFilterBy = {
  key: Scalars['String']
  operator: MemberListFilterByOperator
  value: Scalars['String']
}

export type MemberListFilterByInput = {
  key: Scalars['String']
  operator: MemberListFilterByOperator
  value: Scalars['String']
}

export enum MemberListFilterByOperator {
  contains = 'contains',
  endsWith = 'endsWith',
  equals = 'equals',
  gt = 'gt',
  gte = 'gte',
  hasValue = 'hasValue',
  in = 'in',
  lt = 'lt',
  lte = 'lte',
  nin = 'nin',
  not = 'not',
  startsWith = 'startsWith',
}

export type MemberPermissionsSettingsInput = {
  canDeleteAccount: Scalars['Boolean']
}

export type MemberPrivateMessagingSettings = {
  /** @deprecated Use whoCanContactMember instead */
  privateMessagingEnabled?: Maybe<Scalars['Boolean']>
  quickEnter?: Maybe<Scalars['Boolean']>
  whoCanContactMember?: Maybe<PrivateMessagingIncomingContact>
}

export type MemberPrivateMessagingSettingsInput = {
  privateMessagingEnabled?: InputMaybe<Scalars['Boolean']>
  quickEnter?: InputMaybe<Scalars['Boolean']>
  whoCanContactMember?: InputMaybe<PrivateMessagingIncomingContact>
}

export type MemberSession = {
  active: Scalars['Boolean']
  country?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  deviceBrand?: Maybe<Scalars['String']>
  id: Scalars['ID']
  ip: Scalars['String']
  lastActivityAt: Scalars['DateTime']
  os?: Maybe<Scalars['String']>
  osVersion?: Maybe<Scalars['String']>
}

export type MemberSettings = {
  privateMessaging?: Maybe<MemberPrivateMessagingSettings>
}

export type MemberSettingsInput = {
  privateMessaging?: InputMaybe<MemberPrivateMessagingSettingsInput>
}

export enum MemberStatus {
  DELETED = 'DELETED',
  Suspended = 'Suspended',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED',
}

export enum MemberStatusInput {
  Suspended = 'Suspended',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED',
}

export type MembersContactabilityStatus = {
  data: Array<MemberContactabilityStatus>
}

export type MembersPermissionSettings = {
  canDeleteAccount: Scalars['Boolean']
}

export type Message = {
  /** The ID of the message */
  _id: Scalars['String']
  /** The address signature of the message */
  addressSignature: Scalars['String']
  /** The IDs of any attachments on the message */
  attachmentIds: Array<Scalars['String']>
  attachments?: Maybe<Array<File>>
  /** The member ID of the author in the site */
  authorId: Scalars['String']
  /** Cached copy of the author’s name. The property is not updated if the author name gets changed after the message is sent. */
  authorName?: Maybe<Scalars['String']>
  /** The participant ID of the author in the chat */
  authorParticipantId: Scalars['String']
  /** The content of the message */
  content?: Maybe<Scalars['String']>
  /** The content type of the message */
  contentType: MessageContentType
  /** The date the message was edited */
  editedAt?: Maybe<Scalars['DateTime']>
  /** The IDs of any embeds on the message */
  embedIds: Array<Scalars['String']>
  embeds?: Maybe<Array<Embed>>
  /** The IDs of any images on the message. This is specifically for in-line images */
  imageIds: Array<Scalars['String']>
  images?: Maybe<Array<Image>>
  /** The legacy ID of the message */
  legacyId?: Maybe<Scalars['String']>
  /** The IDs of any members mentioned in the message */
  mentionedMemberIds: Array<Scalars['String']>
  /** The IDs of any participants mentioned in the message */
  mentionedParticipantIds: Array<Scalars['String']>
  /** Meta information of the message. May contain additional information regarding chat logs or contextual data of the message */
  meta?: Maybe<MessageMetadata>
  /** A nonce provided by the client. Can be used for optimistic updates */
  nonce?: Maybe<Scalars['String']>
  /** The page ID of the message */
  pageId: Scalars['String']
  /** A global index for the message indicating it's position in the chat */
  pos: Scalars['Int']
  /** The preview of the message */
  preview?: Maybe<Scalars['String']>
  /** The date the message was sent */
  sentAt: Scalars['DateTime']
}

export type MessageAddress = {
  messageId: Scalars['String']
  pageId: Scalars['String']
  signature: Scalars['String']
}

export enum MessageContentType {
  ChatLog = 'ChatLog',
  Html = 'Html',
  Plain = 'Plain',
}

export type MessageList = {
  data: Array<Message>
  pageInfo: PageInfo
}

export type MessageMetadata =
  | AddedParticipantsMetadata
  | CreatedGroupMetadata
  | DemotedAdminsMetadata
  | EditedGroupMetadata
  | LeftGroupMetadata
  | PromotedAdminsMetadata
  | RemovedParticipantsMetadata
  | TransferredOwnershipMetadata

export type MessagePreview = {
  /** The signature of address of the message. Required to fetch messages of a conversation. */
  addressSignature: Scalars['String']
  /** The preview details of the first file attached to this message */
  attachmentPreview?: Maybe<AttachmentPreview>
  /** The number of files attached to the message */
  attachmentsCount: Scalars['Int']
  /** The member ID of the author in the site */
  authorId: Scalars['String']
  /** Cached copy of the author’s name. The property is not updated if the author name gets changed after the message is sent. */
  authorName?: Maybe<Scalars['String']>
  /** The preview details of the first image attached to this message */
  embedPreview?: Maybe<EmbedPreview>
  /** The number of links embedded in the message */
  embedsCount: Scalars['Int']
  /** The preview details of the first image attached to this message */
  imagePreview?: Maybe<ImagePreview>
  /** The number of images associated with the message */
  imagesCount: Scalars['Int']
  /** The ID of the message */
  messageId: Scalars['String']
  /** Meta information of the message. May contain additional information regarding chat logs or contextual data of the message */
  meta?: Maybe<MessageMetadata>
  /** The ID of the page this message belongs to */
  pageId: Scalars['String']
  /** The preview of the message */
  preview?: Maybe<Scalars['String']>
  /** The date the message was sent */
  sentAt: Scalars['DateTime']
}

export type Migration = {
  id: Scalars['ID']
  networkId: Scalars['ID']
  requesterId: Scalars['ID']
  stage: MigrationStage
  status: MigrationStatus
}

export type MigrationFieldError = {
  field: Scalars['String']
  message: Scalars['String']
}

export type MigrationFileResult = {
  file: Scalars['String']
  insertedRows: Scalars['Int']
  rowErrors: Array<MigrationRowErrors>
  skippedRows: Scalars['Int']
}

export type MigrationRowErrors = {
  externalId?: Maybe<Scalars['String']>
  fieldErrors: Array<MigrationFieldError>
  message: Scalars['String']
  rowNumber: Scalars['Int']
}

export enum MigrationStage {
  MEDIA = 'MEDIA',
  MEMBER = 'MEMBER',
  POST = 'POST',
  SPACE = 'SPACE',
  SPACE_MEMBER = 'SPACE_MEMBER',
  TAG = 'TAG',
}

export enum MigrationStatus {
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum ModerationEntityType {
  MEMBER = 'MEMBER',
  POST = 'POST',
}

export type ModerationItem = {
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  entity?: Maybe<ModerationItemEntity>
  flaggedBy: FlaggedType
  id: Scalars['String']
  memberId?: Maybe<Scalars['String']>
  moderator?: Maybe<Member>
  reporters?: Maybe<PaginatedModerationItemReporter>
  spaceId?: Maybe<Scalars['String']>
  status: ModerationStatus
  updatedAt: Scalars['DateTime']
}

export type ModerationItemReportersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type ModerationItemEdge = {
  cursor: Scalars['String']
  node: ModerationItem
}

export type ModerationItemEntity = Member | Post

export type ModerationItemReporter = {
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  reportCategory: ReportCategory
  reporter?: Maybe<Member>
  updatedAt: Scalars['DateTime']
}

export type ModerationItemReporterEdge = {
  cursor: Scalars['String']
  node: ModerationItemReporter
}

export type ModerationMemberSettings = {
  minimumHoursToPost: Scalars['Int']
  minimumHoursToReply: Scalars['Int']
}

export type ModerationMemberSettingsInput = {
  minimumHoursToPost: Scalars['Int']
  minimumHoursToReply: Scalars['Int']
}

export enum ModerationOpMode {
  Purge = 'Purge',
  Retain = 'Retain',
}

export type ModerationSettings = {
  akismet: Scalars['Boolean']
  blackListPostTypeIds: Array<Scalars['String']>
  blackListSpaceIds: Array<Scalars['String']>
  customBlacklist?: Maybe<Array<Scalars['String']>>
  enableBlacklisting: Scalars['Boolean']
  member: ModerationMemberSettings
  oopSpam: Scalars['Boolean']
  preventPublish: Scalars['Boolean']
  useDefaultBlacklisting?: Maybe<Scalars['Boolean']>
}

export enum ModerationStatus {
  ACCEPTED = 'ACCEPTED',
  PendingConfirmation = 'PendingConfirmation',
  REJECTED = 'REJECTED',
  REVIEW = 'REVIEW',
}

export type MultiPartUploadInput = {
  /** The files to upload */
  fileInputs?: InputMaybe<Array<CreateFileInput>>
  /** The images to upload */
  imageInputs?: InputMaybe<Array<CreateImageInput>>
  /** The maximum size of each part in bytes. This will be used to calculate the number of parts. Must be between 5MiB and 100MiB. If a value outside of this range is provided, it will be automatically set to the nearest valid value. */
  maxPartSize?: InputMaybe<Scalars['Float']>
}

export type MultiPartUploadUrls = {
  /** The URL to abort the multi-part upload. Use this to cancel the upload if needed. */
  abortUrl: Scalars['String']
  /** The URL to download the media. */
  mediaDownloadUrl: Scalars['String']
  /** The ID of the media. */
  mediaId: Scalars['String']
  /** The URL to access the media. */
  mediaUrl: Scalars['String']
  /** The URLs to upload the parts of the media. The URLs are signed and will expire after 2 hours. */
  partUrls: Array<PartUrl>
  /** The URLs to access the uploaded images at different sizes. Null if the media is not an image. */
  urls?: Maybe<MediaUrls>
}

export type Mutation = {
  /** @deprecated Use Glyphs instead, just update the media id with `emoji/...` */
  addEmoji: Emoji
  /** @deprecated Use Glyphs instead, just update the media id with `emoji/...` */
  addEmojis: Array<Emoji>
  /** Add the FCM token to the subscriber settings. */
  addFcmTokenToSubscriberSettings: Action
  /** @deprecated This mutation will be replaced by createCollection */
  addGroup: Collection
  /** @deprecated This mutation will be replaced by createImages */
  addImage: SignedUrl
  /** @deprecated This mutation will be replaced by createImages */
  addImages: Array<SignedUrl>
  /** @deprecated This mutation will be replaced by createImages or createEmojis */
  addMedias: Array<SignedUrl>
  addMemberSchemaField: Network
  /** Add members to a group chat */
  addMembersToGroup: Action
  /** @deprecated This mutation will be replaced by createModerationReport */
  addModerationReport: ModerationItem
  /** @deprecated This mutation will be replaced by createNetwork */
  addNetwork: AuthTokenWithOtp
  /** @deprecated This mutation will be replaced by updateNewDomain */
  addNewDomain: DomainTransferStatus
  /** @deprecated This mutation will be replaced by createPost */
  addPost: Post
  addPostTypeField: PostType
  addReaction: Action
  /** @deprecated This mutation will be replaced by createReply */
  addReply: Post
  /** @deprecated This mutation will be replaced by createSpace */
  addSpace: Space
  addSpaceMembers: Array<SpaceMember>
  addTemplateToNetwork: TemplateRequest
  /** Set the latest message read by the member in the chat */
  advanceReadMessageOffset: AdvanceReadMessageOffsetResult
  /** @deprecated This mutation will be replaced by approveSpaceMembershipRequest */
  approveSpaceJoinRequest: Action
  approveSpaceMembershipRequest: Action
  /** Archive a chat */
  archiveChat: Action
  archiveMemberSchemaField: Network
  archivePostType: PostType
  archivePostTypeField: PostType
  assignBadge: Action
  blockMember: Action
  callback: CallbackResponse
  cancelDomainTransfer: Action
  cancelEmailUpdate: Action
  /** Cancel the current member's registration for an event. */
  cancelEventRegistration: Action
  cancelNetworkDeletion: Action
  /** Cast a vote on a poll using a vote token */
  castVote: Poll
  changeHomepage: Action
  clearNewDomain: Action
  clearNotificationsCount: Action
  closeSpace: Action
  commitDomainTransfer: Action
  /** This will mark the multi-part upload as complete. The upload must be completed before the media is available. The media will be returned if the upload was successful. An error will be returned if the upload failed. */
  completeMultiPartUpload: Array<CompletedMultiPartUpload>
  confirmMassActionRequest: MassActionRequest
  confirmResetPassword: Action
  createAccessGroup: AccessGroup
  createBadge: Badge
  createBillingPortalSession: BillingPortalSession
  createCollection: Collection
  /** Create a draft post. This will also allow scheduling by filling in the scheduledFor field in the input. */
  createDraftPost: Post
  /** @deprecated Use Glyphs instead, just update the media id with `emoji/...` */
  createEmojis: Array<Emoji>
  /** Create a new event in a space. */
  createEvent: Event
  createExportMemberRequest: Export
  createFiles: Array<SignedUrl>
  /** Create a group chat */
  createGroupChat: Chat
  createImages: Array<SignedUrl>
  createMassActionRequest: MassActionRequest
  createModerationReport: ModerationItem
  createNetwork: AuthTokenWithOtp
  createOidc: Oidc
  createPermission: Permission
  /** Create a new poll */
  createPoll: Poll
  /** Create a new post in a space. */
  createPost: Post
  /** Create a new post type. */
  createPostType: PostType
  /** Add a comment to a post. */
  createReply: Post
  /** @deprecated This mutation will be replaced by createModerationReport */
  createReport: ModerationItem
  /** Create a space inside your community. */
  createSpace: Space
  createSpaceFromTemplate: TemplateRequest
  createSubscriptionCheckoutSession: SubscriptionCheckoutSession
  /** Create a new tag */
  createTag: Tag
  createTemplate: Template
  /** @deprecated This mutation will be replaced by declineSpaceMembershipRequest */
  declineSpaceJoinRequest: Action
  declineSpaceMembershipRequest: Action
  deleteAccessGroup: Action
  deleteBadge: Action
  deleteCollection: Action
  /** Delete an event. */
  deleteEvent: Action
  deleteMember: Action
  deleteMemberSchemaField: Network
  deleteNetwork: Action
  deleteNotification: Action
  deleteNotifications: Action
  deleteOidc: Action
  deletePageCustomResponse: Action
  deletePermission: Action
  /** Delete a post. This is a soft delete at first and will eventually be fully purged from the system. */
  deletePost: Action
  deletePostTypeField: PostType
  deleteSpace: Action
  deleteSpaceContentModule: Action
  deleteSpacePostTypes: Action
  deleteSsoMembership: Action
  deleteTag: Action
  deleteTemplate: Action
  /** Demote members from admin in a group chat. Only group chat owners or site staff can perform this action. */
  demoteChatAdmins: Action
  /** @deprecated This mutation will be replaced by updatePasswordWithToken */
  doResetPassword: Action
  /** @deprecated This mutation will be replaced by updateImage */
  editImage: Image
  /** Edit a message in a chat */
  editMessage: Message
  /** @deprecated Use the global gateway instead */
  globalAddAppCollaborator: AppCollaborator
  /** @deprecated Use the global gateway instead */
  globalCreateApp: App
  /** @deprecated Use Glyphs instead, just update the media id with `emoji/...` */
  globalCreateEmojis: Array<Emoji>
  /** @deprecated Use the global gateway instead */
  globalCreateImages: Array<SignedUrl>
  /** @deprecated Use the global gateway instead */
  globalDeleteApp: Action
  /** @deprecated Use the global gateway instead */
  globalDeleteAppSetting: AppSetting
  /** @deprecated Use the global gateway instead */
  globalPublishAppPrivately: AppPublication
  /** @deprecated Use the global gateway instead */
  globalRegenerateClientSecret: App
  /** @deprecated Use the global gateway instead */
  globalRemoveAppCollaborator: Action
  /** @deprecated Use the global gateway instead */
  globalTestAppWebhook: Action
  /** @deprecated Use the global gateway instead */
  globalUnPublishAppPrivately: Action
  /** @deprecated Use the global gateway instead */
  globalUpdateApp: App
  /** @deprecated Use the global gateway instead */
  globalUpdateAppSetting: AppSetting
  hidePost: Action
  impersonateLoginToNetwork: AuthInfoWithOtp
  installApp: AppInstallation
  installAppOnAuthMember: AppInstallation
  interactWithApps: Array<AppInteraction>
  /** Invite members to join your community. */
  inviteMembers: Array<MemberInvitation>
  joinNetwork: AuthToken
  joinNetworkWithInvitationLink: AuthToken
  joinNetworkWithToken: AuthToken
  joinSpace: Action
  /** Leave a group chat */
  leaveGroupChat: Action
  leaveSpace: Action
  loginNetwork: AuthToken
  loginNetworkWithPassword: AuthToken
  loginWithSamlResponse: AuthToken
  loginWithSsoCode: AuthToken
  logoutMemberSessions: Action
  logoutNetwork: Action
  modifySubscriptionAddon: Action
  /** Move a post to a different space. */
  movePost: Post
  /** Move multiple posts to a different space. */
  movePosts: Array<Post>
  /** This allows uploading files in chunks, useful for large files. The upload must be completed using completeMultiPartUpload before it will be available. */
  multiPartUpload: Array<MultiPartUploadUrls>
  nominateNewDomain: Action
  organizeCollections: Action
  /** @deprecated This mutation will be replaced by organizeSpacesInCollection */
  organizeGroupSpaces: Action
  /** @deprecated This mutation will be replaced by organizeCollections */
  organizeGroups: Action
  organizeSpacesInCollection: Action
  pinPostToSpace: Action
  pinReplyToPost: Action
  /** Promote members to admin in a group chat. Only a chat admin can promote members to admin in the chat. */
  promoteChatAdmins: Action
  publishAppPrivately: AppPublication
  /** This will immediately publish a draft post. */
  publishPost: Post
  publishTemplate: Action
  /** Permanently delete a chat and all associated data. Only staff members can perform this action. */
  purgeChat: Action
  purgeMedias: Array<MediaBase>
  readNotification: Action
  readNotifications: Action
  readSpace: Action
  regenerateJwtSsoToken: JwtSsoToken
  /** Register the current member for an event. */
  registerForEvent: Action
  /** Remove the FCM token from the subscriber settings. */
  removeFcmTokenFromSubscriberSettings: Action
  /** @deprecated This mutation will be replaced by deleteCollection */
  removeGroup: Action
  /** @deprecated This mutation will be replaced by deleteMember */
  removeMember: Action
  /** Remove members from a group chat */
  removeMembersFromGroup: Action
  /** @deprecated This mutation will be replaced by deleteNetwork */
  removeNetwork: Action
  /** @deprecated This mutation will be replaced by deletePost */
  removePost: Action
  removeReaction: Action
  removeSpaceMembers: Array<Action>
  /** Reorder a single badge, moving it directly after the badge with specified using previousBadgeId or to the beginning of the list if not provided */
  reorderBadge: Badge
  /** Reorder all badges for the network, using the badgeOrderId input field */
  reorderBadges: Action
  reorderMemberSchemaFields: Network
  reorderPostTypeFields: PostType
  /** @deprecated Use the global gateway instead */
  requestGlobalTokenCode: Action
  requestSpaceMembership: SpaceJoinRequest
  /** @deprecated Use the global gateway instead */
  resendGlobalTokenCode: Action
  resendMemberInvitation: Action
  resendVerification: Action
  /** @deprecated This mutation will be replaced by sendResetPasswordEmail */
  resetPassword: Action
  revokeBadge: Action
  revokeMemberInvitation: Action
  runMigration: Migration
  sendEmailDigestPreview: Action
  /** Send message to an existing chat identified by its ID. */
  sendMessageToChat: NewMessage
  /** Send message to a member. Will create a new conversation between the parties if it doesn’t already exist. */
  sendMessageToMember: NewMessage
  sendResetPasswordEmail: Action
  setPrivatelyPublishedApps: Array<AppPublication>
  /** @deprecated This mutation will be replaced by loginWithSsoCode */
  ssoRedirect: AuthToken
  /** Subscribe the auth member to the given publisher. */
  subscribe: Action
  /** @deprecated This mutation will be replaced by loginSupportWithSsoCode */
  supportSsoRedirect: SupportAuthToken
  suspendMember: Action
  syncTemplate: Template
  /** Transfer ownership of a group chat */
  transferGroupChatOwnership: Action
  /** Transfer ownership of a network to another member. Only support tokens can perform this action. */
  transferNetworkOwnership: Action
  transferToNewDomain: Action
  triggerEmailDigest: Action
  unArchiveMemberSchemaField: Network
  unPublishAppPrivately: ActionStatus
  /** Unarchive a chat */
  unarchiveChat: Action
  unarchivePostType: PostType
  unarchivePostTypeField: PostType
  unblockMember: Action
  /** WARNING: This is an unstable API that does not handle subscriptions, integrations, or potential conflicts. Use at your own risk. */
  undoMembersDeletion: Action
  /** WARNING: This is an unstable API that does not handle subscriptions, integrations, or potential conflicts. Use at your own risk. */
  undoPostsDeletion: Action
  unhidePost: Action
  uninstallApp?: Maybe<AppInstallation>
  unpinPostFromSpace: Action
  unpinReplyFromPost: Action
  unpublishTemplate: Action
  unsetHomepage: Action
  /** Unsubscribe the auth member from the given publisher. */
  unsubscribe: Action
  unsubscribeFromNotification: Action
  unsuspendMember: Action
  updateAccessGroup: AccessGroup
  updateAppInstallation: AppInstallation
  updateAppNetworkSettings: AppAction
  updateAppSpaceSetting: AppAction
  updateAppStanding: ActionStatus
  updateAppStatus: ActionStatus
  updateAuthMember: Member
  updateBadge: Badge
  updateCollection: Action
  updateCustomSso: Sso
  updateDefaultSsoStatus: Action
  /** Update an existing event. */
  updateEvent: Event
  updateFile: File
  /** @deprecated This mutation will be replaced by updateCollection */
  updateGroup: Action
  /** Update a group chat */
  updateGroupChat: Chat
  updateImage: Image
  updateJwtSso: Sso
  updateMember: Member
  updateMemberInvitation: MemberInvitation
  updateMemberSchemaField: Network
  updateMemberSpaceRole: Action
  /** @deprecated This mutation will be replaced by updateModerationItem */
  updateModeration: Action
  updateModerationItem: Action
  updateModerationSettings: ModerationSettings
  updateNetwork: Network
  updateNetworkAvailableLocales: Network
  /** @deprecated This mutation has been replaced by Stripe */
  updateNetworkCustomCapacities: Network
  updateNetworkDomainSubfolder: Network
  updateNetworkMediaSettings: MediaNetworkSettings
  updateNetworkNotificationSettings: NotificationNetworkSettings
  updateNetworkSearchSettings: SearchNetworkSettings
  /** @deprecated This mutation is unstable and may be removed in the future */
  updateNetworkSessionSettings: SessionSettings
  updateNetworkStatus: Action
  updateNewDomain: DomainTransferStatus
  updateOidc: Oidc
  updatePasswordWithToken: Action
  updatePermission: Permission
  /** Update an existing poll. Poll authors and network admins/moderators can update any poll. Additional permissions apply based on poll context (post ownership, space edit access). */
  updatePoll: Poll
  updatePost: Post
  updatePostType: PostType
  updatePostTypeField: PostType
  /** Update the publisher settings for the given publisher. */
  updatePublisherSettings: Action
  updateSpace: Space
  updateSpaceContentModule: Array<SpaceContentModule>
  updateSpaceHighlightedTags: Action
  /** @deprecated This mutation will be replaced by updateMemberSpaceRole */
  updateSpaceMemberRole: Action
  updateSpacePostTypes: Array<SpacePostType>
  /** Update the subscriber settings for the auth member. */
  updateSubscriberSettings: Action
  updateSubscriptionInterval: Action
  updateSubscriptionPlan: Action
  updateTag: Tag
  updateTemplate: Template
  uploadMigrationFiles: UploadedMigrations
  upsertExtraProperty: Action
  upsertPageCustomResponse: PageDetailedCustomResponse
  upsertTheme: NewTheme
  verifyMember: AuthToken
}

export type MutationAddEmojiArgs = {
  input: CreateEmojiInput
}

export type MutationAddEmojisArgs = {
  input: Array<CreateEmojiInput>
}

export type MutationAddFcmTokenToSubscriberSettingsArgs = {
  token: Scalars['String']
}

export type MutationAddGroupArgs = {
  input: CreateCollectionInput
}

export type MutationAddImageArgs = {
  input: CreateImageInput
}

export type MutationAddImagesArgs = {
  input: Array<CreateImageInput>
}

export type MutationAddMediasArgs = {
  input: AddMediasInput
}

export type MutationAddMemberSchemaFieldArgs = {
  input: CustomFieldSchemaInput
}

export type MutationAddMembersToGroupArgs = {
  chatId: Scalars['String']
  input: AddMembersToGroupInput
}

export type MutationAddModerationReportArgs = {
  input: CreateReportInput
}

export type MutationAddNetworkArgs = {
  input: AddNetworkInput
}

export type MutationAddNewDomainArgs = {
  input: DomainAvailabilityInput
}

export type MutationAddPostArgs = {
  input: CreatePostInput
  spaceId: Scalars['ID']
}

export type MutationAddPostTypeFieldArgs = {
  id: Scalars['ID']
  input: CustomFieldSchemaInput
}

export type MutationAddReactionArgs = {
  input: AddReactionInput
  postId: Scalars['ID']
}

export type MutationAddReplyArgs = {
  input: CreatePostInput
  postId: Scalars['ID']
}

export type MutationAddSpaceArgs = {
  input: CreateSpaceInput
}

export type MutationAddSpaceMembersArgs = {
  input: Array<AddSpaceMemberInput>
  spaceId: Scalars['ID']
}

export type MutationAddTemplateToNetworkArgs = {
  excludeEntityTypes?: InputMaybe<Array<TemplateEntityType>>
  templateId: Scalars['String']
}

export type MutationAdvanceReadMessageOffsetArgs = {
  chatId: Scalars['String']
  input: AdvanceReadMessageOffsetInput
  returnNewCount?: InputMaybe<Scalars['Boolean']>
}

export type MutationApproveSpaceJoinRequestArgs = {
  spaceId: Scalars['ID']
  spaceJoinRequestId: Scalars['ID']
}

export type MutationApproveSpaceMembershipRequestArgs = {
  spaceId: Scalars['ID']
  spaceMembershipRequestId: Scalars['ID']
}

export type MutationArchiveChatArgs = {
  chatId: Scalars['String']
}

export type MutationArchiveMemberSchemaFieldArgs = {
  key: Scalars['String']
}

export type MutationArchivePostTypeArgs = {
  id: Scalars['ID']
}

export type MutationArchivePostTypeFieldArgs = {
  id: Scalars['ID']
  key: Scalars['String']
}

export type MutationAssignBadgeArgs = {
  id: Scalars['String']
  input: AssignOrRevokeBadgeInput
}

export type MutationBlockMemberArgs = {
  memberId: Scalars['String']
}

export type MutationCallbackArgs = {
  appId: Scalars['ID']
  callbackId: Scalars['ID']
  context: PermissionContext
  dynamicBlockId?: InputMaybe<Scalars['ID']>
  entityId?: InputMaybe<Scalars['ID']>
  inputs?: InputMaybe<Scalars['String']>
}

export type MutationCancelEmailUpdateArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type MutationCancelEventRegistrationArgs = {
  eventId: Scalars['ID']
  input?: InputMaybe<CancelRegistrationInput>
}

export type MutationCastVoteArgs = {
  input: VoteInput
}

export type MutationChangeHomepageArgs = {
  spaceId: Scalars['String']
  type?: InputMaybe<HomeSpaceType>
}

export type MutationCloseSpaceArgs = {
  spaceId: Scalars['ID']
}

export type MutationCompleteMultiPartUploadArgs = {
  input: Array<CompleteMultiPartUploadInput>
}

export type MutationConfirmMassActionRequestArgs = {
  massActionRequestId: Scalars['String']
}

export type MutationConfirmResetPasswordArgs = {
  input: ConfirmResetPasswordInput
}

export type MutationCreateAccessGroupArgs = {
  input: CreateAccessGroupInput
}

export type MutationCreateBadgeArgs = {
  input: CreateBadgeInput
}

export type MutationCreateBillingPortalSessionArgs = {
  returnUrl: Scalars['String']
}

export type MutationCreateCollectionArgs = {
  input: CreateCollectionInput
}

export type MutationCreateDraftPostArgs = {
  input: CreateDraftPostInput
  spaceId: Scalars['ID']
}

export type MutationCreateEmojisArgs = {
  input: Array<CreateEmojiInput>
}

export type MutationCreateEventArgs = {
  input: CreateEventInput
  spaceId: Scalars['ID']
}

export type MutationCreateExportMemberRequestArgs = {
  input: ExportInput
}

export type MutationCreateFilesArgs = {
  input: Array<CreateFileInput>
}

export type MutationCreateGroupChatArgs = {
  input: CreateGroupChatInput
}

export type MutationCreateImagesArgs = {
  input: Array<CreateImageInput>
}

export type MutationCreateMassActionRequestArgs = {
  input: MassActionRequestInput
}

export type MutationCreateModerationReportArgs = {
  input: CreateReportInput
}

export type MutationCreateNetworkArgs = {
  input: AddNetworkInput
}

export type MutationCreatePermissionArgs = {
  input: CreatePermissionInput
}

export type MutationCreatePollArgs = {
  input: CreatePollInput
}

export type MutationCreatePostArgs = {
  input: CreatePostInput
  spaceId: Scalars['ID']
}

export type MutationCreatePostTypeArgs = {
  input: CreatePostTypeInput
}

export type MutationCreateReplyArgs = {
  input: CreatePostInput
  postId: Scalars['ID']
}

export type MutationCreateReportArgs = {
  input: CreateReportInput
}

export type MutationCreateSpaceArgs = {
  input: CreateSpaceInput
}

export type MutationCreateSpaceFromTemplateArgs = {
  excludeEntityTypes?: InputMaybe<Array<TemplateEntityType>>
  input: CreateSpaceInput
  style?: InputMaybe<Scalars['String']>
  templateId: Scalars['String']
}

export type MutationCreateSubscriptionCheckoutSessionArgs = {
  cancelUrl: Scalars['String']
  priceId: Scalars['String']
  successUrl: Scalars['String']
}

export type MutationCreateTagArgs = {
  input: CreateTagInput
}

export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput
}

export type MutationDeclineSpaceJoinRequestArgs = {
  spaceId: Scalars['ID']
  spaceJoinRequestId: Scalars['ID']
}

export type MutationDeclineSpaceMembershipRequestArgs = {
  spaceId: Scalars['ID']
  spaceMembershipRequestId: Scalars['ID']
}

export type MutationDeleteAccessGroupArgs = {
  id: Scalars['ID']
}

export type MutationDeleteBadgeArgs = {
  id: Scalars['String']
}

export type MutationDeleteCollectionArgs = {
  id: Scalars['ID']
}

export type MutationDeleteEventArgs = {
  eventId: Scalars['ID']
  input?: InputMaybe<DeleteEventInput>
}

export type MutationDeleteMemberArgs = {
  id: Scalars['ID']
}

export type MutationDeleteMemberSchemaFieldArgs = {
  key: Scalars['String']
}

export type MutationDeleteNotificationArgs = {
  notificationId: Scalars['ID']
}

export type MutationDeleteNotificationsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>
}

export type MutationDeleteOidcArgs = {
  id: Scalars['String']
}

export type MutationDeletePageCustomResponseArgs = {
  path: Scalars['String']
}

export type MutationDeletePermissionArgs = {
  id: Scalars['ID']
}

export type MutationDeletePostArgs = {
  id: Scalars['ID']
}

export type MutationDeletePostTypeFieldArgs = {
  id: Scalars['ID']
  key: Scalars['String']
}

export type MutationDeleteSpaceArgs = {
  id: Scalars['ID']
}

export type MutationDeleteSpaceContentModuleArgs = {
  contentModuleTypes: Array<ContentModuleType>
  spaceId: Scalars['ID']
}

export type MutationDeleteSpacePostTypesArgs = {
  postTypeIds: Array<Scalars['ID']>
  spaceId: Scalars['ID']
}

export type MutationDeleteSsoMembershipArgs = {
  memberId: Scalars['String']
  type: SsoType
}

export type MutationDeleteTagArgs = {
  id: Scalars['ID']
}

export type MutationDeleteTemplateArgs = {
  id: Scalars['String']
}

export type MutationDemoteChatAdminsArgs = {
  chatId: Scalars['String']
  input: DemoteChatAdminsInput
}

export type MutationDoResetPasswordArgs = {
  input: UpdatePasswordWithTokenInput
}

export type MutationEditImageArgs = {
  imageId: Scalars['String']
  input: UpdateImageInput
}

export type MutationEditMessageArgs = {
  chatId: Scalars['String']
  input: EditMessageInput
}

export type MutationGlobalAddAppCollaboratorArgs = {
  appId: Scalars['String']
  input: AddAppCollaboratorInput
}

export type MutationGlobalCreateAppArgs = {
  input: CreateAppInput
}

export type MutationGlobalCreateEmojisArgs = {
  input: Array<CreateEmojiInput>
}

export type MutationGlobalCreateImagesArgs = {
  input: Array<CreateImageInput>
}

export type MutationGlobalDeleteAppArgs = {
  id: Scalars['ID']
}

export type MutationGlobalDeleteAppSettingArgs = {
  context: PermissionContext
  entityId?: InputMaybe<Scalars['ID']>
  networkId: Scalars['ID']
}

export type MutationGlobalPublishAppPrivatelyArgs = {
  appId: Scalars['ID']
  networkId: Scalars['ID']
}

export type MutationGlobalRegenerateClientSecretArgs = {
  appId: Scalars['ID']
}

export type MutationGlobalRemoveAppCollaboratorArgs = {
  appId: Scalars['String']
  collaboratorId: Scalars['String']
}

export type MutationGlobalTestAppWebhookArgs = {
  appId: Scalars['ID']
  input: TestAppWebhookInput
}

export type MutationGlobalUnPublishAppPrivatelyArgs = {
  appId: Scalars['ID']
  networkId: Scalars['ID']
}

export type MutationGlobalUpdateAppArgs = {
  id: Scalars['ID']
  input: UpdateAppInput
}

export type MutationGlobalUpdateAppSettingArgs = {
  context: PermissionContext
  entityId?: InputMaybe<Scalars['ID']>
  networkId: Scalars['ID']
  settings: Scalars['String']
}

export type MutationHidePostArgs = {
  id: Scalars['ID']
}

export type MutationImpersonateLoginToNetworkArgs = {
  input: ImpersonateLoginToNetworkInput
}

export type MutationInstallAppArgs = {
  appId: Scalars['ID']
  input?: InputMaybe<InstallAppInput>
}

export type MutationInstallAppOnAuthMemberArgs = {
  appId: Scalars['ID']
  input?: InputMaybe<InstallAppInput>
}

export type MutationInteractWithAppsArgs = {
  context: PermissionContext
  entityId?: InputMaybe<Scalars['ID']>
  input: Array<InteractWithAppInput>
}

export type MutationInviteMembersArgs = {
  input: InviteMembersInput
}

export type MutationJoinNetworkArgs = {
  input: JoinNetworkInput
}

export type MutationJoinNetworkWithInvitationLinkArgs = {
  input: JoinNetworkWithLinkInput
}

export type MutationJoinNetworkWithTokenArgs = {
  input: JoinNetworkWithTokenInput
}

export type MutationJoinSpaceArgs = {
  spaceId: Scalars['ID']
}

export type MutationLeaveGroupChatArgs = {
  chatId: Scalars['String']
}

export type MutationLeaveSpaceArgs = {
  spaceId: Scalars['ID']
}

export type MutationLoginNetworkArgs = {
  input: LoginNetworkWithPasswordInput
}

export type MutationLoginNetworkWithPasswordArgs = {
  input: LoginNetworkWithPasswordInput
}

export type MutationLoginWithSamlResponseArgs = {
  input: LoginWithSamlResponseInput
}

export type MutationLoginWithSsoCodeArgs = {
  input: LoginWithSsoCodeInput
}

export type MutationLogoutMemberSessionsArgs = {
  memberId: Scalars['String']
}

export type MutationLogoutNetworkArgs = {
  input?: InputMaybe<LogoutNetworkInput>
}

export type MutationModifySubscriptionAddonArgs = {
  priceId: Scalars['String']
  quantity: Scalars['Float']
}

export type MutationMovePostArgs = {
  convertPost?: InputMaybe<ConvertPostInput>
  id: Scalars['ID']
  spaceId: Scalars['ID']
}

export type MutationMovePostsArgs = {
  convertPost?: InputMaybe<ConvertPostInput>
  ids: Array<Scalars['ID']>
  spaceId: Scalars['ID']
}

export type MutationMultiPartUploadArgs = {
  input: MultiPartUploadInput
}

export type MutationNominateNewDomainArgs = {
  domain: Scalars['String']
}

export type MutationOrganizeCollectionsArgs = {
  ids: Array<Scalars['String']>
}

export type MutationOrganizeGroupSpacesArgs = {
  groupId: Scalars['String']
  spaceIds: Array<Scalars['String']>
}

export type MutationOrganizeGroupsArgs = {
  groupIds: Array<Scalars['String']>
}

export type MutationOrganizeSpacesInCollectionArgs = {
  collectionId: Scalars['String']
  spaceIds: Array<Scalars['String']>
}

export type MutationPinPostToSpaceArgs = {
  postId: Scalars['ID']
}

export type MutationPinReplyToPostArgs = {
  postId: Scalars['ID']
  replyId: Scalars['ID']
}

export type MutationPromoteChatAdminsArgs = {
  chatId: Scalars['String']
  input: PromoteChatAdminsInput
}

export type MutationPublishAppPrivatelyArgs = {
  appId: Scalars['ID']
}

export type MutationPublishPostArgs = {
  postId: Scalars['ID']
}

export type MutationPublishTemplateArgs = {
  id: Scalars['String']
}

export type MutationPurgeChatArgs = {
  chatId: Scalars['String']
}

export type MutationPurgeMediasArgs = {
  input: PurgeMediasInput
}

export type MutationReadNotificationArgs = {
  notificationId: Scalars['ID']
}

export type MutationReadNotificationsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>
}

export type MutationReadSpaceArgs = {
  date: Scalars['DateTime']
  spaceId: Scalars['String']
}

export type MutationRegisterForEventArgs = {
  eventId: Scalars['ID']
  input?: InputMaybe<RegisterForEventInput>
}

export type MutationRemoveFcmTokenFromSubscriberSettingsArgs = {
  token: Scalars['String']
}

export type MutationRemoveGroupArgs = {
  groupId?: InputMaybe<Scalars['ID']>
}

export type MutationRemoveMemberArgs = {
  memberId: Scalars['ID']
}

export type MutationRemoveMembersFromGroupArgs = {
  chatId: Scalars['String']
  input: RemoveMembersFromGroupInput
}

export type MutationRemovePostArgs = {
  postId: Scalars['ID']
}

export type MutationRemoveReactionArgs = {
  participantId?: InputMaybe<Scalars['String']>
  postId: Scalars['ID']
  reaction: Scalars['String']
}

export type MutationRemoveSpaceMembersArgs = {
  memberIds: Array<Scalars['ID']>
  spaceId: Scalars['ID']
}

export type MutationReorderBadgeArgs = {
  id: Scalars['String']
  input: ReorderBadgeInput
}

export type MutationReorderBadgesArgs = {
  input: ReorderBadgesInput
}

export type MutationReorderMemberSchemaFieldsArgs = {
  input: Array<ReOrderSchemaFieldInput>
}

export type MutationReorderPostTypeFieldsArgs = {
  id: Scalars['ID']
  input: Array<ReOrderSchemaFieldInput>
}

export type MutationRequestGlobalTokenCodeArgs = {
  input: RequestGlobalTokenInput
}

export type MutationRequestSpaceMembershipArgs = {
  spaceId: Scalars['ID']
}

export type MutationResendGlobalTokenCodeArgs = {
  input: RequestGlobalTokenInput
}

export type MutationResendMemberInvitationArgs = {
  id: Scalars['ID']
}

export type MutationResetPasswordArgs = {
  input: ResetPasswordInput
}

export type MutationRevokeBadgeArgs = {
  id: Scalars['String']
  input: AssignOrRevokeBadgeInput
}

export type MutationRevokeMemberInvitationArgs = {
  id: Scalars['ID']
}

export type MutationRunMigrationArgs = {
  id: Scalars['String']
}

export type MutationSendEmailDigestPreviewArgs = {
  memberId?: InputMaybe<Scalars['ID']>
}

export type MutationSendMessageToChatArgs = {
  chatId: Scalars['String']
  input: SendMessageToChatInput
}

export type MutationSendMessageToMemberArgs = {
  input: SendMessageToMemberInput
}

export type MutationSendResetPasswordEmailArgs = {
  email: Scalars['String']
}

export type MutationSetPrivatelyPublishedAppsArgs = {
  ids: Array<Scalars['ID']>
}

export type MutationSsoRedirectArgs = {
  input: LoginWithSsoCodeInput
}

export type MutationSubscribeArgs = {
  publisherId: Scalars['String']
}

export type MutationSupportSsoRedirectArgs = {
  input: LoginSupportWithSsoCodeInput
}

export type MutationSuspendMemberArgs = {
  memberId: Scalars['String']
}

export type MutationSyncTemplateArgs = {
  id: Scalars['String']
  upsertKey?: InputMaybe<Scalars['String']>
}

export type MutationTransferGroupChatOwnershipArgs = {
  chatId: Scalars['String']
  input: TransferGroupChatOwnershipInput
}

export type MutationTransferNetworkOwnershipArgs = {
  input: TransferNetworkOwnershipInput
}

export type MutationTriggerEmailDigestArgs = {
  timeZone: Scalars['String']
}

export type MutationUnArchiveMemberSchemaFieldArgs = {
  key: Scalars['String']
}

export type MutationUnPublishAppPrivatelyArgs = {
  appId: Scalars['ID']
  networkId: Scalars['ID']
}

export type MutationUnarchiveChatArgs = {
  chatId: Scalars['String']
}

export type MutationUnarchivePostTypeArgs = {
  id: Scalars['ID']
}

export type MutationUnarchivePostTypeFieldArgs = {
  id: Scalars['ID']
  key: Scalars['String']
}

export type MutationUnblockMemberArgs = {
  memberId: Scalars['String']
}

export type MutationUndoMembersDeletionArgs = {
  memberIds: Array<Scalars['ID']>
}

export type MutationUndoPostsDeletionArgs = {
  postIds: Array<Scalars['ID']>
}

export type MutationUnhidePostArgs = {
  id: Scalars['ID']
}

export type MutationUninstallAppArgs = {
  appInstallationId: Scalars['ID']
  reason?: InputMaybe<Scalars['String']>
}

export type MutationUnpinPostFromSpaceArgs = {
  postId: Scalars['ID']
}

export type MutationUnpinReplyFromPostArgs = {
  postId: Scalars['ID']
  replyId: Scalars['ID']
}

export type MutationUnpublishTemplateArgs = {
  id: Scalars['String']
}

export type MutationUnsetHomepageArgs = {
  type: HomeSpaceType
}

export type MutationUnsubscribeArgs = {
  publisherId: Scalars['String']
}

export type MutationUnsubscribeFromNotificationArgs = {
  input: UnsubscribeWithTokenInput
}

export type MutationUnsuspendMemberArgs = {
  memberId: Scalars['String']
}

export type MutationUpdateAccessGroupArgs = {
  id: Scalars['ID']
  input: UpdateAccessGroupInput
}

export type MutationUpdateAppInstallationArgs = {
  appInstallationId: Scalars['ID']
  input: UpdateAppInstallationInput
}

export type MutationUpdateAppNetworkSettingsArgs = {
  appId: Scalars['ID']
  settings: Scalars['String']
}

export type MutationUpdateAppSpaceSettingArgs = {
  appId: Scalars['ID']
  settings: Scalars['String']
  spaceId: Scalars['ID']
}

export type MutationUpdateAppStandingArgs = {
  appId: Scalars['ID']
  standing: StoreItemStanding
}

export type MutationUpdateAppStatusArgs = {
  appId: Scalars['ID']
  status: StoreItemStatus
}

export type MutationUpdateAuthMemberArgs = {
  input: UpdateMemberInput
}

export type MutationUpdateBadgeArgs = {
  id: Scalars['String']
  input: UpdateBadgeInput
}

export type MutationUpdateCollectionArgs = {
  id: Scalars['ID']
  input: UpdateCollectionInput
}

export type MutationUpdateCustomSsoArgs = {
  input: UpdateCustomSsoInput
}

export type MutationUpdateDefaultSsoStatusArgs = {
  sso: DefaultSsoType
  status: SsoStatus
}

export type MutationUpdateEventArgs = {
  eventId: Scalars['ID']
  input: UpdateEventInput
}

export type MutationUpdateFileArgs = {
  id: Scalars['String']
  input: UpdateFileInput
}

export type MutationUpdateGroupArgs = {
  groupId?: InputMaybe<Scalars['ID']>
  input: UpdateCollectionInput
}

export type MutationUpdateGroupChatArgs = {
  chatId: Scalars['String']
  input: UpdateGroupChatInput
}

export type MutationUpdateImageArgs = {
  id: Scalars['String']
  input: UpdateImageInput
}

export type MutationUpdateJwtSsoArgs = {
  input: UpdateJwtSsoInput
}

export type MutationUpdateMemberArgs = {
  id?: InputMaybe<Scalars['ID']>
  input: UpdateMemberInput
}

export type MutationUpdateMemberInvitationArgs = {
  id: Scalars['ID']
  input: UpdateMemberInvitationInput
}

export type MutationUpdateMemberSchemaFieldArgs = {
  input: UpdateCustomFieldSchemaInput
}

export type MutationUpdateMemberSpaceRoleArgs = {
  input: UpdateSpaceMemberRoleInput
  memberId: Scalars['ID']
  spaceId: Scalars['ID']
}

export type MutationUpdateModerationArgs = {
  id: Scalars['ID']
  input: UpdateModerationItemInput
}

export type MutationUpdateModerationItemArgs = {
  id: Scalars['ID']
  input: UpdateModerationItemInput
}

export type MutationUpdateModerationSettingsArgs = {
  input: UpdateModerationSettingsInput
}

export type MutationUpdateNetworkArgs = {
  input: UpdateNetworkInput
}

export type MutationUpdateNetworkAvailableLocalesArgs = {
  availableLocales: Array<Scalars['String']>
}

export type MutationUpdateNetworkCustomCapacitiesArgs = {
  additionalSeats?: InputMaybe<Scalars['Int']>
  customMemberCapacity?: InputMaybe<Scalars['Int']>
}

export type MutationUpdateNetworkDomainSubfolderArgs = {
  domainSubfolder?: InputMaybe<Scalars['String']>
}

export type MutationUpdateNetworkMediaSettingsArgs = {
  input: UpdateMediaNetworkSettingsInput
}

export type MutationUpdateNetworkNotificationSettingsArgs = {
  input: UpdateNotificationNetworkSettingsInput
}

export type MutationUpdateNetworkSearchSettingsArgs = {
  input: UpdateSearchNetworkSettingsInput
}

export type MutationUpdateNetworkSessionSettingsArgs = {
  input: SessionSettingsInput
}

export type MutationUpdateNetworkStatusArgs = {
  input: UpdateNetworkStatusInput
}

export type MutationUpdateNewDomainArgs = {
  input: UpdateNewDomainInput
}

export type MutationUpdateOidcArgs = {
  id: Scalars['String']
  input: UpdateOidcInput
}

export type MutationUpdatePasswordWithTokenArgs = {
  input: UpdatePasswordWithTokenInput
}

export type MutationUpdatePermissionArgs = {
  id: Scalars['ID']
  input: UpdatePermissionInput
}

export type MutationUpdatePollArgs = {
  id: Scalars['ID']
  input: UpdatePollInput
}

export type MutationUpdatePostArgs = {
  id: Scalars['ID']
  input: UpdatePostInput
}

export type MutationUpdatePostTypeArgs = {
  id: Scalars['ID']
  input: UpdatePostTypeInput
}

export type MutationUpdatePostTypeFieldArgs = {
  id: Scalars['ID']
  input: UpdateCustomFieldSchemaInput
}

export type MutationUpdatePublisherSettingsArgs = {
  input: UpdatePublisherInput
  publisherId: Scalars['String']
}

export type MutationUpdateSpaceArgs = {
  id: Scalars['ID']
  input: UpdateSpaceInput
}

export type MutationUpdateSpaceContentModuleArgs = {
  input: Array<UpdateSpaceContentModuleInput>
  spaceId: Scalars['ID']
}

export type MutationUpdateSpaceHighlightedTagsArgs = {
  input: UpdateHighlightedTags
  spaceId: Scalars['ID']
}

export type MutationUpdateSpaceMemberRoleArgs = {
  input: UpdateSpaceMemberRoleInput
  memberId: Scalars['ID']
  spaceId: Scalars['ID']
}

export type MutationUpdateSpacePostTypesArgs = {
  input: Array<UpdateSpacePostTypeInput>
  spaceId: Scalars['ID']
}

export type MutationUpdateSubscriberSettingsArgs = {
  input: UpdateSubscriberInput
}

export type MutationUpdateSubscriptionIntervalArgs = {
  interval: BillingPriceInterval
}

export type MutationUpdateSubscriptionPlanArgs = {
  priceId: Scalars['String']
}

export type MutationUpdateTagArgs = {
  id: Scalars['ID']
  input: UpdateTagInput
}

export type MutationUpdateTemplateArgs = {
  id: Scalars['String']
  input: UpdateTemplateInput
}

export type MutationUploadMigrationFilesArgs = {
  baseUrl?: InputMaybe<Scalars['String']>
  changeMemberEmails?: InputMaybe<Scalars['Boolean']>
  dryRun?: InputMaybe<Scalars['Boolean']>
  members?: InputMaybe<Scalars['Upload']>
  migrationId?: InputMaybe<Scalars['String']>
  posts?: InputMaybe<Scalars['Upload']>
  spaces?: InputMaybe<Scalars['Upload']>
}

export type MutationUpsertExtraPropertyArgs = {
  input: UpsertExtraPropertyInput
}

export type MutationUpsertPageCustomResponseArgs = {
  input: UpsertPageCustomResponse
  path: Scalars['String']
}

export type MutationUpsertThemeArgs = {
  input: UpsertTheme
}

export type MutationVerifyMemberArgs = {
  input: VerifyMemberInput
}

export type NativeFieldsTemplates = {
  description?: Maybe<Scalars['String']>
  thumbnailId?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export type NativeFieldsTemplatesInput = {
  description?: InputMaybe<Scalars['String']>
  thumbnailId?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type NavigationItem = {
  link?: Maybe<Scalars['String']>
  openInNewWindow?: Maybe<Scalars['Boolean']>
  text: Scalars['String']
  type: NavigationItemType
}

export enum NavigationItemType {
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  PRIMARY_LINK = 'PRIMARY_LINK',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TEXT_LINK = 'TEXT_LINK',
}

export type NavigationSlateUpdatesInput = {
  footer?: InputMaybe<SlateUpdatesInput>
  footerDisabled?: InputMaybe<Scalars['Boolean']>
  footerFixed?: InputMaybe<Scalars['Boolean']>
  header?: InputMaybe<SlateUpdatesInput>
  headerDisabled?: InputMaybe<Scalars['Boolean']>
  headerFixed?: InputMaybe<Scalars['Boolean']>
  sidebar1?: InputMaybe<SlateUpdatesInput>
  sidebar1Disabled?: InputMaybe<Scalars['Boolean']>
  sidebar1Fixed?: InputMaybe<Scalars['Boolean']>
  sidebar2?: InputMaybe<SlateUpdatesInput>
  sidebar2Disabled?: InputMaybe<Scalars['Boolean']>
  sidebar2Fixed?: InputMaybe<Scalars['Boolean']>
}

export type NavigationSlates = {
  footer?: Maybe<Slate>
  footerDisabled?: Maybe<Scalars['Boolean']>
  footerFixed?: Maybe<Scalars['Boolean']>
  header: Slate
  headerDisabled?: Maybe<Scalars['Boolean']>
  headerFixed?: Maybe<Scalars['Boolean']>
  sidebar1: Slate
  sidebar1Disabled?: Maybe<Scalars['Boolean']>
  sidebar1Fixed?: Maybe<Scalars['Boolean']>
  sidebar2?: Maybe<Slate>
  sidebar2Disabled?: Maybe<Scalars['Boolean']>
  sidebar2Fixed?: Maybe<Scalars['Boolean']>
}

export type Network = {
  activeSso?: Maybe<ActiveSso>
  activeTheme?: Maybe<NewTheme>
  /** @deprecated Has been moved to usageLimits */
  additionalSeatsCapacity?: Maybe<Scalars['Int']>
  aliases: Array<Scalars['String']>
  authMemberProps?: Maybe<NetworkAuthMemberProps>
  availableLocales: Array<Scalars['String']>
  badges?: Maybe<Array<Badge>>
  /** @deprecated It will be stored on Stripe. */
  billingEmail?: Maybe<Scalars['String']>
  /** Has been replaced by activeTheme, but some may still use it */
  brandColor?: Maybe<Scalars['String']>
  companyName?: Maybe<Scalars['String']>
  contentModules?: Maybe<Array<ContentModule>>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<Member>
  createdById: Scalars['ID']
  customCodes?: Maybe<Array<CustomCode>>
  /** @deprecated Has been moved to usageLimits */
  customMemberCapacity?: Maybe<Scalars['Int']>
  customSeoDetail?: Maybe<CustomSeoDetail>
  defaultSpaces?: Maybe<Array<Space>>
  description?: Maybe<Scalars['String']>
  domain: Scalars['String']
  domainSubfolder?: Maybe<Scalars['String']>
  extraProperties?: Maybe<Array<ExtraProperty>>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  /** @deprecated Has been replaced by navigation slates */
  footer?: Maybe<Footer>
  hideDefaultAuthenticationForm: Scalars['Boolean']
  id: Scalars['ID']
  images?: Maybe<NetworkImages>
  incidentEmails?: Maybe<Array<Scalars['String']>>
  /** @deprecated Has been moved to extraProperties */
  industry?: Maybe<NetworkIndustryType>
  /** @deprecated This field is deprecated. */
  landingPages?: Maybe<NetworkSettings>
  limits?: Maybe<NetworkLimits>
  limitsUpdatedAt?: Maybe<Scalars['DateTime']>
  locale: Scalars['String']
  logo?: Maybe<Media>
  logoId?: Maybe<Scalars['ID']>
  /** @deprecated This resolver will be replaced by limits */
  mediaLimits?: Maybe<MediaLimits>
  /** @deprecated This resolver will be replaced by settings */
  mediaSettings?: Maybe<MediaNetworkSettings>
  /**
   * Calculated member capacity
   * @deprecated Has been moved to usageLimits
   */
  memberCapacity?: Maybe<Scalars['Int']>
  /** @deprecated Has been moved to usageLimits */
  memberCapacityDeclared?: Maybe<Scalars['Int']>
  memberFields?: Maybe<CustomFieldsSchema>
  members?: Maybe<PaginatedMember>
  membersCount?: Maybe<Scalars['Int']>
  membership: NetworkMembership
  name: Scalars['String']
  navigationSlates: NavigationSlates
  newDomain?: Maybe<Scalars['String']>
  /** @deprecated This resolver will be replaced by settings */
  notificationSettings?: Maybe<NotificationNetworkSettings>
  organizationId?: Maybe<Scalars['String']>
  overUsedAt?: Maybe<Scalars['DateTime']>
  owner?: Maybe<Member>
  ownerId: Scalars['ID']
  passwordComplexity: NetworkPasswordComplexity
  planName: Scalars['String']
  postTypes?: Maybe<Array<PostType>>
  privacyPolicyUrl?: Maybe<Scalars['String']>
  referralLink?: Maybe<Scalars['String']>
  referralProgramEnabled: Scalars['Boolean']
  /** @deprecated Has been moved to extraProperties */
  releaseChannel?: Maybe<NetworkReleaseChannelType>
  roles?: Maybe<Array<Role>>
  searchSettings?: Maybe<SearchNetworkSettings>
  /** @deprecated Has been moved to usageLimits */
  seatCapacityDeclared?: Maybe<Scalars['Int']>
  /**
   * Calculated seats capacity
   * @deprecated Has been moved to usageLimits
   */
  seatsCapacity?: Maybe<Scalars['Int']>
  settings?: Maybe<Settings>
  shortcuts?: Maybe<Array<Shortcut>>
  spaces?: Maybe<PaginatedSpace>
  status: NetworkStatus
  statusLocked: Scalars['Boolean']
  statusReason?: Maybe<StatusReason>
  systemSpaces?: Maybe<Array<Space>>
  termsOfServiceUrl?: Maybe<Scalars['String']>
  /** Has been replaced by activeTheme, but some may still use "themes" */
  themes?: Maybe<Themes>
  /** @deprecated Has been replaced by navigation slates */
  topNavigation?: Maybe<TopNavigation>
  tribeBranding: Scalars['Boolean']
  usages?: Maybe<NetworkUsages>
  visibility: NetworkVisibility
  whoCanInvite?: Maybe<Array<Role>>
  whoCanInviteIds: Array<Scalars['ID']>
  willUnpublishAt?: Maybe<Scalars['DateTime']>
}

export type NetworkCustomCodesArgs = {
  anonymize: Scalars['Boolean']
}

export type NetworkExtraPropertiesArgs = {
  keys?: InputMaybe<Array<Scalars['String']>>
}

export type NetworkMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<Array<MemberStatusInput>>
}

export type NetworkPostTypesArgs = {
  context?: InputMaybe<PostTypeContext>
}

export type NetworkSpacesArgs = {
  limit: Scalars['Int']
}

export type NetworkAuthMemberProps = {
  context: PermissionContext
  permissions?: Maybe<Array<ActionPermissions>>
  /** @deprecated This field will be replaced by Member.settings */
  privateMessagingEnabled?: Maybe<Scalars['Boolean']>
  scopes?: Maybe<Array<Scalars['String']>>
  totalUnreadPostsCount?: Maybe<Scalars['Int']>
}

export type NetworkAuthMemberPropsTotalUnreadPostsCountArgs = {
  type?: InputMaybe<Array<SpaceType>>
}

export type NetworkCurrentUsages = {
  /** If true, AI search is allowed */
  aiSearchAccess: Scalars['Boolean']
  /** If true, analytics access is allowed */
  analyticsAccess: Scalars['Boolean']
  /** Maximum number of days of analytics data, if null, unlimited */
  analyticsDaysLimit?: Maybe<Scalars['Float']>
  /** If true, API access is allowed */
  apiAccess: Scalars['Boolean']
  /** API request limits */
  apiRequestCapacity: Array<ApiRequestLimit>
  /** List of purchased apps ids */
  appIds: Array<Scalars['String']>
  /** If true, Ask AI is allowed */
  askAiAccess: Scalars['Boolean']
  /** If true, audit log access is allowed */
  auditLogAccess: Scalars['Boolean']
  /** If true, custom domain is allowed */
  customDomain: Scalars['Boolean']
  /** If true, site can set a different media upload target domain */
  customUploadDestination?: Maybe<Scalars['Boolean']>
  /** If true, allows disabling Bettermode branding */
  disableBettermodeBranding: Scalars['Boolean']
  /** If true, email customization is allowed */
  emailCustomization: Scalars['Boolean']
  /** If true, email digest access is allowed */
  emailDigestAccess: Scalars['Boolean']
  /** If true, allows creating events */
  eventContentModuleAccess: Scalars['Boolean']
  /** If true, JWT SSO access is allowed */
  jwtSSOAccess: Scalars['Boolean']
  /** Maximum size per file attachment allowed in bytes, if null, limited to 2047 MB (32bit integer) */
  maximumAttachmentSizeLimit?: Maybe<Scalars['Float']>
  /** Number of members allowed, if null, unlimited */
  membersCapacity?: Maybe<Scalars['Float']>
  /** If true, allows modifying allowed file types */
  modifyAllowedFileTypes: Scalars['Boolean']
  /** Number of monthly emails allowed, if null, unlimited */
  monthlyEmailCapacity?: Maybe<Scalars['Float']>
  /** Number of monthly visitors allowed, if null, unlimited */
  monthlyVisitorCapacity?: Maybe<Scalars['Float']>
  /** If true, OAuth2 SSO access is allowed */
  oauth2SSOAccess: Scalars['Boolean']
  /** Number of post types allowed, if null, unlimited */
  postTypesCapacity?: Maybe<Scalars['Float']>
  /** If true, SAML SSO access is allowed */
  samlSSOAccess: Scalars['Boolean']
  /** Number of seats allowed, if null, unlimited */
  seatsCapacity?: Maybe<Scalars['Float']>
  /** If true, sitemap access is allowed */
  sitemap: Scalars['Boolean']
  /** Number of spaces allowed, if null, unlimited */
  spacesCapacity?: Maybe<Scalars['Float']>
  /** Allowed storage size, if null, unlimited */
  storageCapacity?: Maybe<Scalars['Float']>
  /** Number of translation locales allowed, if null, unlimited */
  translationLocaleCapacity?: Maybe<Scalars['Float']>
}

export type NetworkImages = {
  darkFavicon?: Maybe<Media>
  darkLogo?: Maybe<Media>
  darkMobileLogo?: Maybe<Media>
  lightFavicon?: Maybe<Media>
  lightLogo?: Maybe<Media>
  lightMobileLogo?: Maybe<Media>
}

export type NetworkImagesInput = {
  darkFaviconId?: InputMaybe<Scalars['String']>
  darkLogoId?: InputMaybe<Scalars['String']>
  darkMobileLogoId?: InputMaybe<Scalars['String']>
  lightFaviconId?: InputMaybe<Scalars['String']>
  lightLogoId?: InputMaybe<Scalars['String']>
  lightMobileLogoId?: InputMaybe<Scalars['String']>
}

export enum NetworkIndustryType {
  BloggerCoachCreator = 'BloggerCoachCreator',
  ConsultingAndAgency = 'ConsultingAndAgency',
  EcomerceAndRetail = 'EcomerceAndRetail',
  EntertainmentAndEvents = 'EntertainmentAndEvents',
  FinancianServices = 'FinancianServices',
  Healthcare = 'Healthcare',
  InternetAndOnlineService = 'InternetAndOnlineService',
  MediaAndPublishing = 'MediaAndPublishing',
  NonProfitAndAssociation = 'NonProfitAndAssociation',
  OnlineTrainingAndEducation = 'OnlineTrainingAndEducation',
  Other = 'Other',
  SoftwareAndSaas = 'SoftwareAndSaas',
}

export enum NetworkLandingPage {
  EXPLORE = 'EXPLORE',
  FEED = 'FEED',
  SPACES = 'SPACES',
}

export type NetworkLimits = {
  analyticsLimits?: Maybe<AnalyticsLimits>
  /** @deprecated There is no limit on file size anymore */
  fileSizeLimit?: Maybe<Scalars['Float']>
  /** @deprecated There is no limit on file types anymore */
  fileTypesLimit?: Maybe<Array<Scalars['String']>>
  /** @deprecated There is no limit on image size anymore */
  imageSizeLimit?: Maybe<Scalars['Float']>
  /** @deprecated There is no limit on image types anymore */
  imageTypesLimit?: Maybe<Array<Scalars['String']>>
  usageLimits: NetworkUsageLimits
}

export enum NetworkMembership {
  inviteOnly = 'inviteOnly',
  open = 'open',
}

export enum NetworkPasswordComplexity {
  Complex = 'Complex',
  Simple = 'Simple',
  Standard = 'Standard',
}

export enum NetworkPrimaryMembersType {
  Customers = 'Customers',
  Employees = 'Employees',
  Members = 'Members',
  Other = 'Other',
  Students = 'Students',
}

export type NetworkPublicInfo = {
  domain: Scalars['String']
  domainSubfolder?: Maybe<Scalars['String']>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  images?: Maybe<NetworkImages>
  jwtSsoAuthUrls?: Maybe<JwtSsoAuthUrls>
  logo?: Maybe<Media>
  logoId?: Maybe<Scalars['ID']>
  membership: NetworkMembership
  name: Scalars['String']
  status: NetworkStatus
  systemSpaces?: Maybe<Array<Space>>
  visibility: NetworkVisibility
}

export enum NetworkReleaseChannelType {
  edge = 'edge',
  stable = 'stable',
}

export type NetworkSettings = {
  landingPageForGuest: NetworkLandingPage
  landingPageForMember: NetworkLandingPage
  landingPageForNewMember: NetworkLandingPage
}

export type NetworkSettingsInput = {
  captcha?: InputMaybe<CaptchaSettingsInput>
  contentTranslation?: InputMaybe<ContentTranslationSettingsInput>
  memberPermissions?: InputMaybe<MemberPermissionsSettingsInput>
  privateMessaging?: InputMaybe<PrivateMessagingSettingsInput>
  xFrameEmbedding?: InputMaybe<XFrameEmbeddingSettingsInput>
}

export enum NetworkStatus {
  archived = 'archived',
  published = 'published',
  unpublished = 'unpublished',
}

export enum NetworkStatusChangedBy {
  admin = 'admin',
  support = 'support',
  system = 'system',
}

export enum NetworkStatusReason {
  memberCapacityExceeded = 'memberCapacityExceeded',
  networkCreated = 'networkCreated',
  networkLockLifted = 'networkLockLifted',
  seatsCapacityExceeded = 'seatsCapacityExceeded',
  trialEnded = 'trialEnded',
}

export enum NetworkTimeframeType {
  FewMonths = 'FewMonths',
  FewWeeks = 'FewWeeks',
  NotSure = 'NotSure',
  VerySoon = 'VerySoon',
}

export type NetworkUsageLimits = {
  /** If true, AI search is allowed */
  aiSearchAccess: Scalars['Boolean']
  /** If true, analytics access is allowed */
  analyticsAccess: Scalars['Boolean']
  /** Maximum number of days of analytics data, if null, unlimited */
  analyticsDaysLimit?: Maybe<Scalars['Float']>
  /** If true, API access is allowed */
  apiAccess: Scalars['Boolean']
  /** API request limits */
  apiRequestCapacity: Array<ApiRequestLimit>
  /** List of purchased apps ids */
  appIds: Array<Scalars['String']>
  /** If true, Ask AI is allowed */
  askAiAccess: Scalars['Boolean']
  /** If true, audit log access is allowed */
  auditLogAccess: Scalars['Boolean']
  /** If true, custom domain is allowed */
  customDomain: Scalars['Boolean']
  /** If true, site can set a different media upload target domain */
  customUploadDestination?: Maybe<Scalars['Boolean']>
  /** If true, allows disabling Bettermode branding */
  disableBettermodeBranding: Scalars['Boolean']
  /** If true, email customization is allowed */
  emailCustomization: Scalars['Boolean']
  /** If true, email digest access is allowed */
  emailDigestAccess: Scalars['Boolean']
  /** If true, allows creating events */
  eventContentModuleAccess: Scalars['Boolean']
  /** If true, JWT SSO access is allowed */
  jwtSSOAccess: Scalars['Boolean']
  /** Maximum size per file attachment allowed in bytes, if null, limited to 2047 MB (32bit integer) */
  maximumAttachmentSizeLimit?: Maybe<Scalars['Float']>
  /** Number of members allowed, if null, unlimited */
  membersCapacity?: Maybe<Scalars['Float']>
  /** If true, allows modifying allowed file types */
  modifyAllowedFileTypes: Scalars['Boolean']
  /** Number of monthly emails allowed, if null, unlimited */
  monthlyEmailCapacity?: Maybe<Scalars['Float']>
  /** Number of monthly visitors allowed, if null, unlimited */
  monthlyVisitorCapacity?: Maybe<Scalars['Float']>
  /** If true, OAuth2 SSO access is allowed */
  oauth2SSOAccess: Scalars['Boolean']
  /** Number of post types allowed, if null, unlimited */
  postTypesCapacity?: Maybe<Scalars['Float']>
  /** If true, SAML SSO access is allowed */
  samlSSOAccess: Scalars['Boolean']
  /** Number of seats allowed, if null, unlimited */
  seatsCapacity?: Maybe<Scalars['Float']>
  /** If true, sitemap access is allowed */
  sitemap: Scalars['Boolean']
  /** Number of spaces allowed, if null, unlimited */
  spacesCapacity?: Maybe<Scalars['Float']>
  /** Allowed storage size, if null, unlimited */
  storageCapacity?: Maybe<Scalars['Float']>
  /** Number of translation locales allowed, if null, unlimited */
  translationLocaleCapacity?: Maybe<Scalars['Float']>
}

export type NetworkUsages = {
  /** @deprecated Deprecated, use usages.storageCapacity instead */
  fileStorageUsage?: Maybe<Scalars['Float']>
  /** @deprecated Deprecated, use usages.storageCapacity instead */
  imageStorageUsage?: Maybe<Scalars['Float']>
  usages: NetworkCurrentUsages
}

export enum NetworkVisibility {
  private = 'private',
  public = 'public',
}

export type NewMessage = {
  /** The ID of the chat the this message was sent to */
  chatId: Scalars['String']
  /** The message object which was created and persisted as a result of the mutation */
  message: Message
  /** The page in which this message was inserted into, which is required when addressing a message. */
  pageId: Scalars['String']
}

export type NewTheme = {
  colorTokens?: Maybe<ThemeColorTokens>
  colors?: Maybe<ThemeColors>
  id: Scalars['String']
  name?: Maybe<Scalars['String']>
  typography?: Maybe<Array<ThemeToken>>
}

export type Notification = {
  /** This field represents the member that triggered the event. However, for events such as 'post updated', 'post deleted', 'comment updated', 'comment deleted', or 'join request status updated', the actor field may be set to null. This is a privacy measure designed to prevent the exposure of potentially sensitive identities, such as moderators, who may be responsible for these actions. */
  actor?: Maybe<Payload>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  meta?: Maybe<NotificationMeta>
  object?: Maybe<Payload>
  read: Scalars['Boolean']
  space?: Maybe<Space>
  summary?: Maybe<Scalars['String']>
  target?: Maybe<Payload>
  verb: NotificationVerb
}

export type NotificationEdge = {
  cursor: Scalars['String']
  node: Notification
}

export type NotificationMeta = {
  body?: Maybe<Scalars['String']>
  fullTitle: Scalars['String']
  reason: NotificationReason
  relativeUrl: Scalars['String']
  textBody?: Maybe<Scalars['String']>
  textFullTitle: Scalars['String']
  textTitle: Scalars['String']
  title: Scalars['String']
  url: Scalars['String']
}

export type NotificationNetworkSettings = {
  emailDigestEnabled: Scalars['Boolean']
  emailDigestLayoutId: Scalars['String']
  emailDigestRecentPostsFilter: EmailDigestRecentPostsFilter
  emailEnabled: Scalars['Boolean']
  emailFrom?: Maybe<Scalars['String']>
  emailNotificationEnabled: Scalars['Boolean']
}

export enum NotificationReason {
  EVENT_SUBSCRIPTION = 'EVENT_SUBSCRIPTION',
  NETWORK_ADMIN = 'NETWORK_ADMIN',
  NETWORK_SUBSCRIPTION = 'NETWORK_SUBSCRIPTION',
  POST_AUTHOR = 'POST_AUTHOR',
  POST_SUBSCRIPTION = 'POST_SUBSCRIPTION',
  SPACE_ADMIN = 'SPACE_ADMIN',
  SPACE_SUBSCRIPTION = 'SPACE_SUBSCRIPTION',
}

export type NotificationSubscription = {
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  networkId: Scalars['String']
  publisher?: Maybe<Publisher>
  publisherId: Scalars['String']
  subscriberId: Scalars['String']
}

export type NotificationSubscriptionEdge = {
  cursor: Scalars['String']
  node: NotificationSubscription
}

export enum NotificationTrigger {
  MENTION = 'MENTION',
  MESSAGE = 'MESSAGE',
  REACTION = 'REACTION',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SYSTEM = 'SYSTEM',
}

export enum NotificationVerb {
  COMMENT_CREATED = 'COMMENT_CREATED',
  COMMENT_DELETED = 'COMMENT_DELETED',
  COMMENT_UPDATED = 'COMMENT_UPDATED',
  EVENT_CREATED = 'EVENT_CREATED',
  EVENT_DELETED = 'EVENT_DELETED',
  EVENT_REGISTRATION_CANCELED = 'EVENT_REGISTRATION_CANCELED',
  EVENT_REGISTRATION_CREATED = 'EVENT_REGISTRATION_CREATED',
  EVENT_REMINDER_CREATED = 'EVENT_REMINDER_CREATED',
  EVENT_UPDATED = 'EVENT_UPDATED',
  JOIN_REQUEST_STATUS_UPDATED = 'JOIN_REQUEST_STATUS_UPDATED',
  MEMBER_MENTIONED = 'MEMBER_MENTIONED',
  MESSAGE_CREATED = 'MESSAGE_CREATED',
  POST_CREATED = 'POST_CREATED',
  POST_DELETED = 'POST_DELETED',
  POST_UPDATED = 'POST_UPDATED',
  REACTION_CREATED = 'REACTION_CREATED',
}

export type NotificationsCount = {
  new: Scalars['Float']
}

export enum NumberTypeOptions {
  integer = 'integer',
  number = 'number',
}

export type OAuthCode = {
  code: Scalars['String']
}

export type OAuthCodeInput = {
  clientId: Scalars['String']
  redirectUri: Scalars['String']
  scopes: Array<PrimaryScopes>
}

export type OAuthTokenInput = {
  code?: InputMaybe<Scalars['String']>
  refreshToken?: InputMaybe<Scalars['String']>
}

export type OAuthTokens = {
  accessToken: Scalars['String']
  expiresIn: Scalars['Float']
  memberId: Scalars['String']
  refreshToken: Scalars['String']
}

export type Oidc = {
  clientId: Scalars['String']
  clientSecret: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  jwksUri?: Maybe<Scalars['String']>
  jwtSecret?: Maybe<Scalars['String']>
  networkId: Scalars['ID']
  updatedAt: Scalars['DateTime']
  validIssuers: Array<Scalars['String']>
}

export type Page = {
  customResponse?: Maybe<PageCustomResponse>
  entity?: Maybe<PageEntity>
  seoDetail: PageSeo
  space: Space
}

export type PageCustomResponse = {
  body: Scalars['String']
  headers: Array<PageCustomResponseHeader>
  httpCode: Scalars['Int']
}

export type PageCustomResponseHeader = {
  key: Scalars['String']
  value: Scalars['String']
}

export type PageCustomResponseHeaderInput = {
  key: Scalars['String']
  value: Scalars['String']
}

export type PageDetailedCustomResponse = {
  body: Scalars['String']
  createdAt: Scalars['DateTime']
  createdById?: Maybe<Scalars['String']>
  creatorType: CreatorType
  headers: Array<PageCustomResponseHeader>
  httpCode: Scalars['Int']
  updatedAt?: Maybe<Scalars['DateTime']>
  updatedById?: Maybe<Scalars['String']>
}

export type PageDetailedCustomResponseEdge = {
  cursor: Scalars['String']
  node: PageDetailedCustomResponse
}

export type PageEntity = Collection | Event | Member | Post

export type PageInfo = {
  endCursor?: Maybe<Scalars['String']>
  hasNextPage: Scalars['Boolean']
}

export type PageSeo = {
  additionalMeta?: Maybe<Array<PageTag>>
  description?: Maybe<Scalars['String']>
  jsonld?: Maybe<Scalars['String']>
  thumbnail?: Maybe<Media>
  title: Scalars['String']
}

export enum PageSeoTagType {
  LINK = 'LINK',
  META = 'META',
  TITLE = 'TITLE',
}

export type PageTag = {
  properties: Array<KeyValue>
  type: PageSeoTagType
}

export type PaginatedApp = {
  edges?: Maybe<Array<AppEdge>>
  nodes?: Maybe<Array<App>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedAppInstallation = {
  edges?: Maybe<Array<AppInstallationEdge>>
  nodes?: Maybe<Array<AppInstallation>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedDynamicBlock = {
  edges?: Maybe<Array<DynamicBlockEdge>>
  nodes?: Maybe<Array<DynamicBlock>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedEmailLog = {
  edges?: Maybe<Array<EmailLogEdge>>
  nodes?: Maybe<Array<EmailLog>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedEvent = {
  edges?: Maybe<Array<EventEdge>>
  nodes?: Maybe<Array<Event>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedEventRecurrence = {
  edges?: Maybe<Array<EventRecurrenceEdge>>
  nodes?: Maybe<Array<EventRecurrence>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedEventRegistration = {
  edges?: Maybe<Array<EventRegistrationEdge>>
  nodes?: Maybe<Array<EventRegistration>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedExport = {
  edges?: Maybe<Array<ExportEdge>>
  nodes?: Maybe<Array<Export>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedMember = {
  edges?: Maybe<Array<MemberEdge>>
  nodes?: Maybe<Array<Member>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedMemberInvitation = {
  edges?: Maybe<Array<MemberInvitationEdge>>
  nodes?: Maybe<Array<MemberInvitation>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedModeration = {
  edges?: Maybe<Array<ModerationItemEdge>>
  nodes?: Maybe<Array<ModerationItem>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedModerationItemReporter = {
  edges?: Maybe<Array<ModerationItemReporterEdge>>
  nodes?: Maybe<Array<ModerationItemReporter>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedNetwork = {
  edges?: Maybe<Array<PluralNetworkEdge>>
  nodes?: Maybe<Array<PluralNetwork>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedNotification = {
  edges?: Maybe<Array<NotificationEdge>>
  nodes?: Maybe<Array<Notification>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedNotificationSubscriptions = {
  edges?: Maybe<Array<NotificationSubscriptionEdge>>
  nodes?: Maybe<Array<NotificationSubscription>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedPageCustomResponse = {
  edges?: Maybe<Array<PageDetailedCustomResponseEdge>>
  nodes?: Maybe<Array<PageDetailedCustomResponse>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedPluralMember = {
  edges?: Maybe<Array<PluralMemberEdge>>
  nodes?: Maybe<Array<PluralMember>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedPost = {
  edges?: Maybe<Array<PostEdge>>
  nodes?: Maybe<Array<Post>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedPostReactionParticipant = {
  edges?: Maybe<Array<PostReactionParticipantEdge>>
  nodes?: Maybe<Array<PostReactionParticipant>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedPostType = {
  edges?: Maybe<Array<PostTypeEdge>>
  nodes?: Maybe<Array<PostType>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedSitemap = {
  edges?: Maybe<Array<SitemapEdge>>
  nodes?: Maybe<Array<Sitemap>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedSpace = {
  edges?: Maybe<Array<SpaceEdge>>
  nodes?: Maybe<Array<Space>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedSpaceJoinRequest = {
  edges?: Maybe<Array<SpaceJoinRequestEdge>>
  nodes?: Maybe<Array<SpaceJoinRequest>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedSpaceMember = {
  edges?: Maybe<Array<SpaceMemberEdge>>
  nodes?: Maybe<Array<SpaceMember>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedSpacePostType = {
  edges?: Maybe<Array<SpacePostTypeEdge>>
  nodes?: Maybe<Array<SpacePostType>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedTag = {
  edges?: Maybe<Array<TagEdge>>
  nodes?: Maybe<Array<Tag>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedTemplate = {
  edges?: Maybe<Array<TemplateEdge>>
  nodes?: Maybe<Array<Template>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PartUrl = {
  /** Which part of the file this URL is for */
  partNumber: Scalars['Int']
  /** The file to be uploaded needs to be sliced to be exactly this size for the signature to be valid */
  partSize: Scalars['Int']
  /** The signed URL for the part */
  signedUrl: Scalars['String']
  /** The file to be uploaded needs to be sliced with this byte as the starting point */
  startingByte: Scalars['Int']
}

export type PasswordComplexity = {
  complex: Scalars['Boolean']
}

export type PathPermissions = {
  isAuthorized: IsAuthorized
  path: Scalars['String']
}

export type Payload = {
  id: Scalars['ID']
  media?: Maybe<Media>
  member?: Maybe<Member>
  name?: Maybe<Scalars['String']>
  post?: Maybe<Post>
  space?: Maybe<Space>
  summary?: Maybe<Scalars['String']>
  type: PayloadType
}

export enum PayloadType {
  EVENT = 'EVENT',
  EVENT_REGISTRATION = 'EVENT_REGISTRATION',
  JOIN_REQUEST_STATUS = 'JOIN_REQUEST_STATUS',
  MEMBER = 'MEMBER',
  NETWORK = 'NETWORK',
  POST = 'POST',
  REACTION = 'REACTION',
  SPACE = 'SPACE',
}

export type Permission = {
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  scopes: Array<Scalars['String']>
}

export enum PermissionContext {
  EVENT = 'EVENT',
  MEMBER = 'MEMBER',
  NETWORK = 'NETWORK',
  POST = 'POST',
  SPACE = 'SPACE',
}

export type Permissions = {
  actions: Array<ActionPermissions>
  contextAwareActions: Array<ContextPermissions>
}

export type PermissionsContextInput = {
  context: PermissionContext
  ids: Array<Scalars['String']>
}

/** A physical location where an event takes place. */
export type PhysicalLocation = {
  /** Additional data of the location. */
  additionalData?: Maybe<Scalars['String']>
  /** The display name of the location. */
  displayName?: Maybe<Scalars['String']>
  /** The formatted address of the location. */
  formattedAddress?: Maybe<Scalars['String']>
  /** The unique identifier of the location. */
  id: Scalars['ID']
  /** The latitude coordinate of the location (-90 to 90 degrees). */
  latitude: Scalars['Float']
  /** The longitude coordinate of the location (-180 to 180 degrees). */
  longitude: Scalars['Float']
  /** The URLs of the maps for the location. */
  mapUrls?: Maybe<StaticMaps>
  /** The Google Places ID of the location. */
  placeId?: Maybe<Scalars['String']>
  /** The Plus Code of the location. */
  plusCode?: Maybe<Scalars['String']>
}

/** A physical location where an event takes place. */
export type PhysicalLocationMapUrlsArgs = {
  input?: InputMaybe<MapUrlsInput>
}

export enum PinnedInto {
  member = 'member',
  network = 'network',
  post = 'post',
  space = 'space',
}

/** Detailed information about a place. */
export type PlaceDetails = {
  /** Name of the place */
  displayName: Scalars['String']
  /** Formatted address */
  formattedAddress: Scalars['String']
  /** Latitude coordinate */
  latitude: Scalars['Float']
  /** Longitude coordinate */
  longitude: Scalars['Float']
  /** Place ID */
  placeId: Scalars['String']
  /** Plus code of the place */
  plusCode?: Maybe<Scalars['String']>
}

/** Input for fetching place details. */
export type PlaceDetailsInput = {
  /** The place ID of the location */
  placeId: Scalars['String']
  /** Session token for grouping queries for billing purposes. This will be generated and returned as part of the autocomplete query. Can only be used to select place details once. */
  sessionToken?: InputMaybe<Scalars['String']>
}

export type PluralMember = {
  activeSession?: Maybe<MemberSession>
  /** @deprecated Has been replaced by locale field */
  attributes: MemberAttributes
  authMemberProps?: Maybe<MemberAuthMemberProps>
  badges?: Maybe<Array<MemberBadge>>
  banner?: Maybe<Media>
  bannerId?: Maybe<Scalars['ID']>
  blockedMemberIds?: Maybe<Array<Scalars['String']>>
  blockedMembers?: Maybe<Array<Member>>
  createdAt: Scalars['DateTime']
  /** @deprecated Has been replaced with name */
  displayName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  emailStatus?: Maybe<MemberEmailStatus>
  externalId?: Maybe<Scalars['ID']>
  externalUrl?: Maybe<Scalars['String']>
  extraProperties?: Maybe<Array<ExtraProperty>>
  fields?: Maybe<Array<CustomField>>
  flagged: Scalars['Boolean']
  id: Scalars['ID']
  lastSeen?: Maybe<Scalars['DateTime']>
  lastSeenAt?: Maybe<Scalars['DateTime']>
  locale: Scalars['String']
  name?: Maybe<Scalars['String']>
  network?: Maybe<Network>
  networkId: Scalars['ID']
  newEmail?: Maybe<Scalars['String']>
  /** @deprecated Use the teammate field instead */
  overrideTeammate?: Maybe<Scalars['Boolean']>
  profilePicture?: Maybe<Media>
  profilePictureId?: Maybe<Scalars['ID']>
  relativeUrl?: Maybe<Scalars['String']>
  role?: Maybe<Role>
  roleId: Scalars['ID']
  score?: Maybe<Scalars['Int']>
  sessions?: Maybe<Array<MemberSession>>
  settings?: Maybe<MemberSettings>
  shortcuts?: Maybe<Array<Shortcut>>
  spaces?: Maybe<PaginatedSpace>
  staffReasons?: Maybe<Array<StaffReason>>
  status: MemberStatus
  subscribersCount?: Maybe<Scalars['Int']>
  tagline?: Maybe<Scalars['String']>
  teammate: Scalars['Boolean']
  timeZone?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
  username: Scalars['String']
  verifiedAt?: Maybe<Scalars['DateTime']>
}

export type PluralMemberExtraPropertiesArgs = {
  keys?: InputMaybe<Array<Scalars['String']>>
}

export type PluralMemberSpacesArgs = {
  exploreOnly?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
}

export type PluralMemberEdge = {
  cursor: Scalars['String']
  node: PluralMember
}

export type PluralNetwork = {
  activeSso?: Maybe<ActiveSso>
  activeTheme?: Maybe<NewTheme>
  /** @deprecated Has been moved to usageLimits */
  additionalSeatsCapacity?: Maybe<Scalars['Int']>
  aliases: Array<Scalars['String']>
  authMemberProps?: Maybe<NetworkAuthMemberProps>
  availableLocales: Array<Scalars['String']>
  badges?: Maybe<Array<Badge>>
  /** @deprecated It will be stored on Stripe. */
  billingEmail?: Maybe<Scalars['String']>
  /** Has been replaced by activeTheme, but some may still use it */
  brandColor?: Maybe<Scalars['String']>
  companyName?: Maybe<Scalars['String']>
  contentModules?: Maybe<Array<ContentModule>>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<Member>
  createdById: Scalars['ID']
  customCodes?: Maybe<Array<CustomCode>>
  /** @deprecated Has been moved to usageLimits */
  customMemberCapacity?: Maybe<Scalars['Int']>
  customSeoDetail?: Maybe<CustomSeoDetail>
  defaultSpaces?: Maybe<Array<Space>>
  description?: Maybe<Scalars['String']>
  domain: Scalars['String']
  domainSubfolder?: Maybe<Scalars['String']>
  extraProperties?: Maybe<Array<ExtraProperty>>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  /** @deprecated Has been replaced by navigation slates */
  footer?: Maybe<Footer>
  globalFavicon?: Maybe<Media>
  globalLogo?: Maybe<Media>
  hideDefaultAuthenticationForm: Scalars['Boolean']
  id: Scalars['ID']
  images?: Maybe<NetworkImages>
  incidentEmails?: Maybe<Array<Scalars['String']>>
  /** @deprecated Has been moved to extraProperties */
  industry?: Maybe<NetworkIndustryType>
  /** @deprecated This field is deprecated. */
  landingPages?: Maybe<NetworkSettings>
  limits?: Maybe<NetworkLimits>
  limitsUpdatedAt?: Maybe<Scalars['DateTime']>
  locale: Scalars['String']
  logo?: Maybe<Media>
  logoId?: Maybe<Scalars['ID']>
  /** @deprecated This resolver will be replaced by limits */
  mediaLimits?: Maybe<MediaLimits>
  /** @deprecated This resolver will be replaced by settings */
  mediaSettings?: Maybe<MediaNetworkSettings>
  /**
   * Calculated member capacity
   * @deprecated Has been moved to usageLimits
   */
  memberCapacity?: Maybe<Scalars['Int']>
  /** @deprecated Has been moved to usageLimits */
  memberCapacityDeclared?: Maybe<Scalars['Int']>
  memberFields?: Maybe<CustomFieldsSchema>
  members?: Maybe<PaginatedMember>
  membersCount?: Maybe<Scalars['Int']>
  membership: NetworkMembership
  name: Scalars['String']
  navigationSlates: NavigationSlates
  newDomain?: Maybe<Scalars['String']>
  /** @deprecated This resolver will be replaced by settings */
  notificationSettings?: Maybe<NotificationNetworkSettings>
  organizationId?: Maybe<Scalars['String']>
  overUsedAt?: Maybe<Scalars['DateTime']>
  owner?: Maybe<Member>
  ownerId: Scalars['ID']
  passwordComplexity: NetworkPasswordComplexity
  planName: Scalars['String']
  postTypes?: Maybe<Array<PostType>>
  privacyPolicyUrl?: Maybe<Scalars['String']>
  referralLink?: Maybe<Scalars['String']>
  referralProgramEnabled: Scalars['Boolean']
  /** @deprecated Has been moved to extraProperties */
  releaseChannel?: Maybe<NetworkReleaseChannelType>
  roles?: Maybe<Array<Role>>
  searchSettings?: Maybe<SearchNetworkSettings>
  /** @deprecated Has been moved to usageLimits */
  seatCapacityDeclared?: Maybe<Scalars['Int']>
  /**
   * Calculated seats capacity
   * @deprecated Has been moved to usageLimits
   */
  seatsCapacity?: Maybe<Scalars['Int']>
  settings?: Maybe<Settings>
  shortcuts?: Maybe<Array<Shortcut>>
  spaces?: Maybe<PaginatedSpace>
  status: NetworkStatus
  statusLocked: Scalars['Boolean']
  statusReason?: Maybe<StatusReason>
  systemSpaces?: Maybe<Array<Space>>
  termsOfServiceUrl?: Maybe<Scalars['String']>
  /** Has been replaced by activeTheme, but some may still use "themes" */
  themes?: Maybe<Themes>
  /** @deprecated Has been replaced by navigation slates */
  topNavigation?: Maybe<TopNavigation>
  tribeBranding: Scalars['Boolean']
  usages?: Maybe<NetworkUsages>
  visibility: NetworkVisibility
  whoCanInvite?: Maybe<Array<Role>>
  whoCanInviteIds: Array<Scalars['ID']>
  willUnpublishAt?: Maybe<Scalars['DateTime']>
}

export type PluralNetworkCustomCodesArgs = {
  anonymize: Scalars['Boolean']
}

export type PluralNetworkExtraPropertiesArgs = {
  keys?: InputMaybe<Array<Scalars['String']>>
}

export type PluralNetworkMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<Array<MemberStatusInput>>
}

export type PluralNetworkPostTypesArgs = {
  context?: InputMaybe<PostTypeContext>
}

export type PluralNetworkSpacesArgs = {
  limit: Scalars['Int']
}

export type PluralNetworkEdge = {
  cursor: Scalars['String']
  node: PluralNetwork
}

export type Poll = {
  closesAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['String']
  createdById: Scalars['String']
  deletedAt?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isDraft: Scalars['Boolean']
  /** The maximum number of options a participant can select. Defaults to 1. */
  maxSelections: Scalars['Int']
  networkId: Scalars['String']
  opensAt: Scalars['DateTime']
  options: Array<PollOption>
  parentEntityId?: Maybe<Scalars['String']>
  parentEntityType: PollEntityType
  status: PollStatus
  title: Scalars['String']
  /** The number of people who have participated in the poll. */
  totalParticipants?: Maybe<Scalars['Int']>
  /** The number of votes cast for this poll. In case of multi-choice polls, it can be more than total participants. */
  totalVoteCasts?: Maybe<Scalars['Int']>
  updatedAt: Scalars['String']
  /** Vote cast by the current user */
  usersVote?: Maybe<Vote>
  /** JWT token that allows voting on this poll. Valid for 1 hour from generation. */
  voteToken?: Maybe<Scalars['String']>
}

/** The type of entity a poll belongs to */
export enum PollEntityType {
  Event = 'Event',
  GroupChat = 'GroupChat',
  Network = 'Network',
  Post = 'Post',
  Space = 'Space',
}

export type PollOption = {
  id: Scalars['Int']
  label: Scalars['String']
  result?: Maybe<PollOptionResult>
}

export type PollOptionInput = {
  label: Scalars['String']
}

export type PollOptionResult = {
  /** Ratio of the participants who voted for this option. The value ranges from 0.00 to 1.00 */
  voteCastShare: Scalars['Float']
  /** Number participants who voted for this option */
  voteCount: Scalars['Int']
}

/** In case the parent entity of the poll is not yet created (which can happen when writing up posts), client is required to offer a hint as to where that future parent will exist. In case of posts, the parent hint should point to the space in which the post will live. The poll attachment will be enforced once again when the parent entity is created through the input scopes. */
export type PollParentHintInput = {
  entityId: Scalars['String']
  entityType: PollEntityType
}

/** The status of a poll */
export enum PollStatus {
  Active = 'Active',
  Closed = 'Closed',
  Scheduled = 'Scheduled',
}

export type Post = {
  /** @deprecated Has been replaced by allowedReactions. */
  allowedEmojis?: Maybe<Array<Scalars['String']>>
  allowedReactions?: Maybe<Array<Scalars['String']>>
  attachmentIds: Array<Scalars['ID']>
  attachments?: Maybe<Array<File>>
  authMemberProps?: Maybe<PostAuthMemberProps>
  contentSummary?: Maybe<PostContentSummary>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<SpaceMember>
  createdById: Scalars['ID']
  customSeoDetail?: Maybe<CustomSeoDetail>
  description?: Maybe<Scalars['String']>
  embedIds: Array<Scalars['String']>
  embeds?: Maybe<Array<Embed>>
  externalId?: Maybe<Scalars['ID']>
  externalUrl?: Maybe<Scalars['String']>
  fields?: Maybe<Array<CustomField>>
  /** @deprecated Use "subscribersCount" instead */
  followersCount?: Maybe<Scalars['Int']>
  /** @deprecated Has been replaced by allowedReactions. */
  forbiddenEmojis?: Maybe<Array<Scalars['String']>>
  forbiddenReactions?: Maybe<Array<Scalars['String']>>
  hasMoreContent: Scalars['Boolean']
  id: Scalars['ID']
  imageIds: Array<Scalars['ID']>
  images?: Maybe<Array<Media>>
  isAnonymous: Scalars['Boolean']
  isHidden?: Maybe<Scalars['Boolean']>
  language?: Maybe<Scalars['String']>
  lastActivityAt?: Maybe<Scalars['DateTime']>
  lastActivityDetail?: Maybe<PostLastActivityDetail>
  /** Whether the post is locked */
  locked: Scalars['Boolean']
  /** @deprecated This field is going to be deprecated in favor of "fields" */
  mappingFields?: Maybe<Array<PostMappingField>>
  mentionedMembers: Array<Scalars['String']>
  mentions?: Maybe<Array<Member>>
  /** @deprecated There are no negative reactions anymore. */
  negativeReactions?: Maybe<Array<Scalars['String']>>
  /** @deprecated There are no positive reactions anymore. */
  negativeReactionsCount?: Maybe<Scalars['Int']>
  networkId: Scalars['ID']
  owner?: Maybe<SpaceMember>
  ownerId: Scalars['ID']
  pinnedInto: Array<PinnedInto>
  pinnedReplies?: Maybe<Array<Post>>
  pollIds: Array<Scalars['ID']>
  polls?: Maybe<Array<Poll>>
  /** @deprecated There are no positive reactions anymore. */
  positiveReactions?: Maybe<Array<Scalars['String']>>
  /** @deprecated There are no positive reactions anymore. */
  positiveReactionsCount?: Maybe<Scalars['Int']>
  postType?: Maybe<PostType>
  postTypeId: Scalars['ID']
  /** Has been replaced by allowedReactions, but some may still use it */
  primaryReactionType?: Maybe<ReactionType>
  publishedAt?: Maybe<Scalars['DateTime']>
  reactions?: Maybe<Array<PostReactionDetail>>
  reactionsCount: Scalars['Int']
  relativeUrl?: Maybe<Scalars['String']>
  repliedTo?: Maybe<Post>
  repliedToId?: Maybe<Scalars['ID']>
  repliedToIds?: Maybe<Array<Scalars['String']>>
  repliedTos?: Maybe<Array<Post>>
  replies?: Maybe<PaginatedPost>
  repliesCount: Scalars['Int']
  scheduledFor?: Maybe<Scalars['DateTime']>
  seoDetail: PostSeoDetail
  shortContent?: Maybe<Scalars['String']>
  shortcuts?: Maybe<Array<Shortcut>>
  singleChoiceReactions?: Maybe<Array<Scalars['String']>>
  slug?: Maybe<Scalars['String']>
  space?: Maybe<Space>
  spaceId: Scalars['ID']
  status: PostStatus
  subscribersCount?: Maybe<Scalars['Int']>
  tagIds?: Maybe<Array<Scalars['String']>>
  tags?: Maybe<Array<Tag>>
  textContent?: Maybe<Scalars['String']>
  thumbnail?: Maybe<Media>
  thumbnailId?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  topRepliers: Array<PostTopReplier>
  /** @deprecated topicIds is replaced by tagIds. */
  topicIds?: Maybe<Array<Scalars['String']>>
  totalRepliesCount: Scalars['Int']
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
}

export type PostContentSummaryArgs = {
  format?: ShortContentFormat
  length?: Scalars['Int']
}

export type PostRepliesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  excludePins?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  orderByString?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type PostShortContentArgs = {
  format?: ShortContentFormat
  length?: InputMaybe<Scalars['Int']>
}

export type PostAuthMemberProps = {
  availableReplyTypes?: Maybe<Array<PostType>>
  canReact?: Maybe<Scalars['Boolean']>
  context: PermissionContext
  /** @deprecated Use "subscribed" instead */
  memberPostNotificationSettingsEnabled?: Maybe<Scalars['Boolean']>
  permissions?: Maybe<Array<ActionPermissions>>
  scopes?: Maybe<Array<Scalars['String']>>
  subscribed?: Maybe<Scalars['Boolean']>
}

export type PostContentSummary = {
  hasMoreContent: Scalars['Boolean']
  summary: Scalars['String']
}

export type PostEdge = {
  cursor: Scalars['String']
  node: Post
}

export enum PostFieldsEnum {
  boolean1 = 'boolean1',
  boolean2 = 'boolean2',
  boolean3 = 'boolean3',
  boolean4 = 'boolean4',
  boolean5 = 'boolean5',
  date1 = 'date1',
  date2 = 'date2',
  date3 = 'date3',
  date4 = 'date4',
  date5 = 'date5',
  html1 = 'html1',
  html2 = 'html2',
  html3 = 'html3',
  html4 = 'html4',
  html5 = 'html5',
  html6 = 'html6',
  html7 = 'html7',
  html8 = 'html8',
  html9 = 'html9',
  html10 = 'html10',
  image1 = 'image1',
  image2 = 'image2',
  image3 = 'image3',
  image4 = 'image4',
  image5 = 'image5',
  number1 = 'number1',
  number2 = 'number2',
  number3 = 'number3',
  number4 = 'number4',
  number5 = 'number5',
  numberArray1 = 'numberArray1',
  numberArray2 = 'numberArray2',
  numberArray3 = 'numberArray3',
  numberArray4 = 'numberArray4',
  numberArray5 = 'numberArray5',
  text1 = 'text1',
  text2 = 'text2',
  text3 = 'text3',
  text4 = 'text4',
  text5 = 'text5',
  text6 = 'text6',
  text7 = 'text7',
  text8 = 'text8',
  text9 = 'text9',
  text10 = 'text10',
  textArray1 = 'textArray1',
  textArray2 = 'textArray2',
  textArray3 = 'textArray3',
  textArray4 = 'textArray4',
  textArray5 = 'textArray5',
}

export type PostLastActivityDetail = {
  entity?: Maybe<PostLastActivityEntity>
  entityId: Scalars['ID']
  entityType: PostLastActivityEntityType
}

export type PostLastActivityEntity = Post | PostReactionParticipant

export enum PostLastActivityEntityType {
  Reaction = 'Reaction',
  Reply = 'Reply',
}

export enum PostListFilterByEnum {
  boolean1 = 'boolean1',
  boolean2 = 'boolean2',
  boolean3 = 'boolean3',
  boolean4 = 'boolean4',
  boolean5 = 'boolean5',
  createdAt = 'createdAt',
  date1 = 'date1',
  date2 = 'date2',
  date3 = 'date3',
  date4 = 'date4',
  date5 = 'date5',
  number1 = 'number1',
  number2 = 'number2',
  number3 = 'number3',
  number4 = 'number4',
  number5 = 'number5',
  publishedAt = 'publishedAt',
  status = 'status',
  updatedAt = 'updatedAt',
}

export type PostListFilterByInput = {
  key?: InputMaybe<PostListFilterByEnum>
  keyString?: InputMaybe<Scalars['String']>
  operator?: InputMaybe<PostListFilterByOperator>
  value: Scalars['String']
}

export enum PostListFilterByOperator {
  contains = 'contains',
  endsWith = 'endsWith',
  equals = 'equals',
  gt = 'gt',
  gte = 'gte',
  hasValue = 'hasValue',
  in = 'in',
  lt = 'lt',
  lte = 'lte',
  nin = 'nin',
  not = 'not',
  startsWith = 'startsWith',
}

export enum PostListOrderByEnum {
  boolean1 = 'boolean1',
  boolean2 = 'boolean2',
  boolean3 = 'boolean3',
  boolean4 = 'boolean4',
  boolean5 = 'boolean5',
  createdAt = 'createdAt',
  date1 = 'date1',
  date2 = 'date2',
  date3 = 'date3',
  date4 = 'date4',
  date5 = 'date5',
  lastActivityAt = 'lastActivityAt',
  number1 = 'number1',
  number2 = 'number2',
  number3 = 'number3',
  number4 = 'number4',
  number5 = 'number5',
  publishedAt = 'publishedAt',
  reactionsCount = 'reactionsCount',
  repliesCount = 'repliesCount',
  text1 = 'text1',
  text2 = 'text2',
  text3 = 'text3',
  text4 = 'text4',
  text5 = 'text5',
  totalRepliesCount = 'totalRepliesCount',
  updatedAt = 'updatedAt',
}

export type PostMappingField = {
  key: Scalars['String']
  type: PostMappingTypeEnum
  value: Scalars['String']
}

export type PostMappingFieldInput = {
  key: Scalars['String']
  type: PostMappingTypeEnum
  value: Scalars['String']
}

export enum PostMappingTypeEnum {
  boolean = 'boolean',
  date = 'date',
  html = 'html',
  image = 'image',
  number = 'number',
  numberArray = 'numberArray',
  text = 'text',
  textArray = 'textArray',
}

export type PostReactionDetail = {
  count: Scalars['Int']
  participants?: Maybe<PaginatedPostReactionParticipant>
  reacted: Scalars['Boolean']
  reaction: Scalars['String']
}

export type PostReactionDetailParticipantsArgs = {
  limit: Scalars['Int']
}

export type PostReactionParticipant = {
  participant?: Maybe<Member>
  reaction?: Maybe<PostReactionDetail>
}

export type PostReactionParticipantEdge = {
  cursor: Scalars['String']
  node: PostReactionParticipant
}

export type PostSeoDetail = {
  description?: Maybe<Scalars['String']>
  image?: Maybe<Scalars['String']>
  title: Scalars['String']
}

export enum PostStatus {
  ARCHIVED = 'ARCHIVED',
  BLOCKED = 'BLOCKED',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  /** @deprecated Use DRAFT instead */
  DRAFTED = 'DRAFTED',
  PUBLISHED = 'PUBLISHED',
}

export type PostTopReplier = {
  member?: Maybe<Member>
  repliesCount: Scalars['Int']
}

export type PostType = {
  actions?: Maybe<Array<PostTypeAction>>
  /** @deprecated Use allowedReactions instead. */
  allowedEmojis?: Maybe<Array<Scalars['String']>>
  allowedReactions?: Maybe<Array<Scalars['String']>>
  archived: Scalars['Boolean']
  authMemberProps?: Maybe<PostTypeAuthMemberProps>
  context: PostTypeContext
  createdAt: Scalars['DateTime']
  customReactions?: Maybe<Array<CustomReaction>>
  description?: Maybe<Scalars['String']>
  excludedNativeShortcuts?: Maybe<Array<Scalars['String']>>
  /** @deprecated Use forbiddenReactions instead. */
  forbiddenEmojis?: Maybe<Array<Scalars['String']>>
  forbiddenReactions?: Maybe<Array<Scalars['String']>>
  icon?: Maybe<Media>
  iconId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  languageTemplate?: Maybe<Scalars['String']>
  layout: Scalars['String']
  /** @deprecated This field is going to be deprecated in favor of "postFields" */
  mappings?: Maybe<Array<PostTypeMapping>>
  name: Scalars['String']
  nativeFieldsTemplates?: Maybe<NativeFieldsTemplates>
  /** @deprecated There are no negative reactions anymore. */
  negativeReactions?: Maybe<Array<Scalars['String']>>
  pluralName: Scalars['String']
  /** @deprecated There are no positive reactions anymore. */
  positiveReactions?: Maybe<Array<Scalars['String']>>
  postFields?: Maybe<CustomFieldsSchema>
  /** Has been replaced by allowedReactions, but some may still use it */
  primaryReactionType?: Maybe<ReactionType>
  recommendationsSettings?: Maybe<PostTypeRecommendationSettings>
  shortContentTemplate?: Maybe<Scalars['String']>
  singleChoiceReactions?: Maybe<Array<Scalars['String']>>
  slate: Slate
  slug: Scalars['String']
  titleTemplate?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  validReplyTypes?: Maybe<Array<PostType>>
}

export type PostTypeAction = {
  props?: Maybe<Scalars['String']>
  shortcutKey: Scalars['String']
}

export type PostTypeAuthMemberProps = {
  availableSpaces?: Maybe<Array<Space>>
  context: PermissionContext
  permissions?: Maybe<Array<ActionPermissions>>
  scopes?: Maybe<Array<Scalars['String']>>
}

export enum PostTypeContext {
  post = 'post',
  reply = 'reply',
}

export type PostTypeEdge = {
  cursor: Scalars['String']
  node: PostType
}

export type PostTypeMapping = {
  default?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  field?: Maybe<PostFieldsEnum>
  isMainContent?: Maybe<Scalars['Boolean']>
  isSearchable?: Maybe<Scalars['Boolean']>
  key: Scalars['String']
  required?: Maybe<Scalars['Boolean']>
  title?: Maybe<Scalars['String']>
  type: PostMappingTypeEnum
}

export type PostTypeRecommendationSettings = {
  fields: Array<Scalars['String']>
  sourceSelf?: Maybe<Scalars['Boolean']>
  sourceSpaces?: Maybe<Array<Scalars['String']>>
}

export type PostTypeRecommendationSettingsInput = {
  fields: Array<Scalars['String']>
  sourceSelf?: InputMaybe<Scalars['Boolean']>
  sourceSpaces?: InputMaybe<Array<Scalars['String']>>
}

export enum PrimaryScopes {
  CreateContent = 'CreateContent',
  DeleteAuthMember = 'DeleteAuthMember',
  DeleteContent = 'DeleteContent',
  DeleteMember = 'DeleteMember',
  DeleteNetwork = 'DeleteNetwork',
  FindAuthMember = 'FindAuthMember',
  FindContent = 'FindContent',
  FindNetwork = 'FindNetwork',
  FullAccess = 'FullAccess',
  InviteMember = 'InviteMember',
  JoinNetwork = 'JoinNetwork',
  UpdateAuthMember = 'UpdateAuthMember',
  UpdateBilling = 'UpdateBilling',
  UpdateContent = 'UpdateContent',
  UpdateMember = 'UpdateMember',
  UpdateModeration = 'UpdateModeration',
  UpdateNetwork = 'UpdateNetwork',
  UpdateNetworkTemplate = 'UpdateNetworkTemplate',
  UpdateReport = 'UpdateReport',
  ViewAuthMember = 'ViewAuthMember',
  ViewContent = 'ViewContent',
  ViewMember = 'ViewMember',
  ViewNetwork = 'ViewNetwork',
  ViewReport = 'ViewReport',
}

/** Input for creating a private message. */
export type PrivateMessageInput = {
  memberIds?: InputMaybe<Array<Scalars['String']>>
}

export enum PrivateMessagingIncomingContact {
  Anyone = 'Anyone',
  Staff = 'Staff',
}

export enum PrivateMessagingOutgoingContact {
  Anyone = 'Anyone',
  Staff = 'Staff',
}

export type PrivateMessagingSettings = {
  maxGroupSize?: Maybe<Scalars['Int']>
  /** @deprecated Will be removed with the release of the new inbox */
  membersCanTurnOffPrivateMessaging?: Maybe<Scalars['Boolean']>
  /** @deprecated Use whoCanMembersContact instead */
  membersCanUsePrivateMessaging?: Maybe<Scalars['Boolean']>
  privateMessagingEnabled: Scalars['Boolean']
  whoCanCreateGroups?: Maybe<GroupChatCreationPermission>
  whoCanMembersContact?: Maybe<PrivateMessagingOutgoingContact>
}

export type PrivateMessagingSettingsInput = {
  membersCanTurnOffPrivateMessaging?: InputMaybe<Scalars['Boolean']>
  membersCanUsePrivateMessaging?: InputMaybe<Scalars['Boolean']>
  privateMessagingEnabled: Scalars['Boolean']
  whoCanCreateGroups?: InputMaybe<GroupChatCreationPermission>
  whoCanMembersContact?: InputMaybe<PrivateMessagingOutgoingContact>
}

export type PromoteChatAdminsInput = {
  /** List of member ids to promote to admin. These members must already be a part of the group chat. */
  memberIds: Array<Scalars['String']>
}

export type PromotedAdminsMetadata = {
  promotedParticipants: Array<ChatParticipant>
  type: ChatLogType
}

export type Publisher = {
  id: Scalars['ID']
  member?: Maybe<Member>
  networkId: Scalars['ID']
  notifyImplicitSubscriptions?: Maybe<Scalars['Boolean']>
  post?: Maybe<Post>
  space?: Maybe<Space>
  type: PublisherType
}

export type PublisherEdge = {
  cursor: Scalars['String']
  node: Publisher
}

export enum PublisherType {
  Custom = 'Custom',
  Event = 'Event',
  Member = 'Member',
  Post = 'Post',
  Space = 'Space',
}

export type PurgeMediasInput = {
  mediaIds: Array<Scalars['String']>
}

export type Query = {
  accessGroup: AccessGroup
  accessGroups: Array<AccessGroup>
  activityLogs: Array<ReportRecord>
  analytics: Array<AnalyticsResponse>
  apiRateLimitStats: Array<ApiRateLimitStat>
  apiUsages: Array<DailyApiUsage>
  app: App
  apps: PaginatedApp
  authMember: Member
  authMemberAppInstallation: AppInstallation
  authMemberAppInstallations: PaginatedAppInstallation
  /** Autocomplete physical location suggestions from Google Maps. */
  autocompletePhysicalLocations: AutocompletePhysicalLocationResult
  availableDynamicBlocks: Array<DynamicBlock>
  billingProducts: BillingProducts
  /** Get the calendar invite for an event. */
  calendarInvite: Scalars['String']
  /** Get structured calendar invite data for generating add-to-calendar links. */
  calendarInviteData: CalendarInviteData
  /** Get chat by id */
  chat: Chat
  /**
   * Resolves a space slug to the corresponding chat id
   * @deprecated This query is only to enable redirections during deprecation phase. The query will be removed when the deprecation period is over.
   */
  chatIdFromSlug: ChatIdFromSlug
  /** Get participants for a chat. This will return participants of the chat up to a limit of 20, sorted by join date. To fetch more, use the participantByCursor query. */
  chatParticipants: ChatParticipantList
  /** Get all participants for a chat */
  chatParticipantsByCursor: ChatParticipantList
  /** Get participants by ids */
  chatParticipantsByIds: Array<ChatParticipant>
  /** Get chats before or after a given message or timestamp. `messageId` takes precedence and if provided, `timestamp` will be ignored. */
  chats: ChatList
  /** Get chats using a query cursor. You may adjust the `limit` per each query, but the `direction` cannot be modified and is encoded in the cursor. */
  chatsByCursor: ChatList
  /** @deprecated This query will be replaced by domainAvailability */
  checkDomainAvailability: DomainAvailability
  /** @deprecated This query will be replaced by emailAvailability */
  checkEmailAvailability: EmailAvailability
  /** @deprecated This query will be replaced by invitationLinkValidity */
  checkInvitationLinkValidity: MemberInvitationLink
  /** @deprecated This query will be replaced by memberInvitationValidity */
  checkMemberInvitationValidity: MemberInvitation
  /** Check if current user can send message to the specified members. */
  checkMembersContactability: MembersContactabilityStatus
  /** @deprecated This query will be replaced by newDomainStatus */
  checkNewDomainStatus: DomainTransferStatus
  /** @deprecated This query will be replaced by passwordComplexity */
  checkPasswordComplexity: PasswordComplexity
  /** @deprecated This query will be replaced by usernameAvailability */
  checkUsernameAvailability: UsernameAvailability
  collection: Collection
  collections: Array<Collection>
  domainAvailability: DomainAvailability
  /** Get draft polls by IDs. Useful for fetching poll details when composing a post that is not persisted just yet. Only author of the poll can access the draft polls. */
  draftPollsForEntityType: Array<Poll>
  draftPosts: PaginatedPost
  draftPostsCount: Scalars['Float']
  dynamicBlock: DynamicBlock
  dynamicBlockByKey: DynamicBlock
  dynamicBlocks: PaginatedDynamicBlock
  emailAvailability: EmailAvailability
  emailLogs: PaginatedEmailLog
  embed: Embed
  event: Event
  /** This is an unstable query and may change or be removed in the future. */
  eventAnalytics: AnalyticsResponse
  /** Get recurrences for a specific event detail. */
  eventRecurrences: PaginatedEventRecurrence
  eventRegistrations: PaginatedEventRegistration
  events: PaginatedEvent
  exploreSpaces: PaginatedSpace
  exportMemberRequest: Export
  exportMemberRequests: PaginatedExport
  externalSearch: Array<ExternalSearchResult>
  extraProperties: Array<ExtraProperty>
  feed: PaginatedPost
  /** Filter members with pagination. The difference from search is that you don't provide a query. Therefore there is no relevance score and the result is instead ordered using the orderBy input or defaults to join date. */
  filterMembers: PaginatedMember
  /** Filter posts with pagination. The difference from search is that you don't provide a query. Therefore there is no relevance score and the result is instead ordered using the orderBy input or defaults to publish date. */
  filterPosts: PaginatedPost
  /** Filter spaces with pagination. The difference from search is that you don't provide a query. Therefore there is no relevance score and the result is instead ordered using the orderBy input or defaults to creation date. */
  filterSpaces: PaginatedSpace
  /** Find an existing chat between current user and the specified member */
  findChatWithMember: Chat
  /** Generate a static map URL for a location. */
  generateStaticMapUrl: StaticMaps
  /** @deprecated This query will be replaced by app */
  getAppById: App
  /** @deprecated This query will be replaced by app */
  getAppBySlug: App
  getAppNetworkSettings: Scalars['String']
  getAppSpaceSettings: Scalars['String']
  /** @deprecated This query will be replaced by apps */
  getApps: PaginatedApp
  /** @deprecated This query will be replaced by authMember */
  getAuthMember: Member
  /** @deprecated This query will be replaced by embed */
  getEmbed: Embed
  /** @deprecated This query will be replaced by feed */
  getFeed: PaginatedPost
  /** @deprecated This query will be replaced by collection */
  getGroup: Collection
  /** @deprecated This query will be replaced by collections */
  getGroups: Array<Collection>
  /** @deprecated This query will be replaced by media */
  getMedia: Media
  /** @deprecated This query will be replaced by member */
  getMember: Member
  /** @deprecated Use authMemberAppInstallations instead */
  getMemberAppInstallations: PaginatedAppInstallation
  /** @deprecated This query will be replaced by memberInvitation */
  getMemberInvitation: MemberInvitation
  /** @deprecated This query will be replaced by memberInvitationLink */
  getMemberInvitationLink: MemberInvitationLink
  /** @deprecated This query will be replaced by memberInvitations */
  getMemberInvitations: PaginatedMemberInvitation
  /** @deprecated This query will be replaced by memberPosts */
  getMemberPosts: PaginatedPost
  /** @deprecated This query will be replaced by memberSpaces */
  getMemberSpaces: PaginatedSpaceMember
  /** @deprecated This query will be replaced by members */
  getMembers: PaginatedMember
  /** @deprecated This query will be replaced by moderationItem */
  getModerationById: ModerationItem
  /** @deprecated This query will be replaced by moderationItemReporters */
  getModerationReporters: PaginatedModerationItemReporter
  /** @deprecated This query will be replaced by moderationSettings */
  getModerationSetting: ModerationSettings
  /** @deprecated This query will be replaced by moderationItems */
  getModerations: PaginatedModeration
  /** @deprecated This query will be replaced by network */
  getNetwork: Network
  /** @deprecated Use networkAppInstallations instead */
  getNetworkAppInstallations: PaginatedAppInstallation
  /** @deprecated This query will be replaced by networkApps */
  getNetworkApps: Array<App>
  /** @deprecated This query will be replaced by networkPublicInfo */
  getNetworkPublicInfo: NetworkPublicInfo
  /** @deprecated This query will be replaced by networks */
  getNetworks: PaginatedNetwork
  /** @deprecated This query will be replaced by notifications */
  getNotifications: PaginatedNotification
  /** @deprecated This query will be replaced by notificationsCount */
  getNotificationsCount: NotificationsCount
  /** Get detailed information about a place from Google Maps. */
  getPlaceDetails: PlaceDetails
  /** @deprecated This query will be replaced by post */
  getPost: Post
  /** @deprecated We no longer support app installation on space */
  getPostAppInstallations: PaginatedAppInstallation
  /** @deprecated This query will be replaced by postReactionParticipants */
  getPostReactionParticipants: PaginatedPostReactionParticipant
  /** @deprecated This query will be replaced by posts */
  getPosts: PaginatedPost
  /** @deprecated This query will be replaced by replies */
  getReplies: PaginatedPost
  /** @deprecated This query is replaced by analytics */
  getReport: Report
  /** @deprecated This query will be replaced by roles */
  getRoles: Array<Role>
  /** @deprecated This query will be replaced by scopes */
  getScopes: Scopes
  /** @deprecated This query will be replaced by space */
  getSpace: Space
  /** @deprecated We no longer support app installation on space */
  getSpaceAppInstallations: PaginatedAppInstallation
  /** @deprecated This query will be replaced by spaceMembers */
  getSpaceMembers: PaginatedSpaceMember
  /** @deprecated This query will be replaced by memberSpaceMembershipRequest */
  getSpaceMembershipRequestForMember: Array<SpaceJoinRequest>
  /** @deprecated This query will be replaced by spaceMembershipRequests */
  getSpaceMembershipRequests: Array<SpaceJoinRequest>
  /** @deprecated This query will be replaced by spacePinnedPosts */
  getSpacePinnedPosts: Array<Post>
  /** @deprecated This query is replaced by analytics */
  getSpaceReport: Report
  /** @deprecated This query will be replaced by spaceRoles */
  getSpaceRoles: Array<SpaceRole>
  /** @deprecated This query will be replaced by ssoMemberships */
  getSsoMemberships: Array<SsoMembership>
  /** @deprecated This query will be replaced by supportNetworkTokens */
  getSupportNetworkTokens: SupportLimitedAuthToken
  /** @deprecated This query will be replaced by tokens */
  getTokens: AuthToken
  /** @deprecated Use the global gateway instead */
  globalApp: App
  /** @deprecated Use the global gateway instead */
  globalAppCollaborators: Array<AppCollaborator>
  /** @deprecated Use the global gateway instead */
  globalAppPublications: Array<AppPublication>
  /** @deprecated Use the global gateway instead */
  globalAppSettings: AppSetting
  /** @deprecated Use the global gateway instead */
  globalApps: PaginatedApp
  /** @deprecated Use the global gateway instead */
  globalEmbed: Embed
  /** @deprecated Use the global gateway instead */
  globalEventTypes: Array<EventType>
  /** @deprecated Use the global gateway instead */
  globalMedia: Media
  /** @deprecated Use the global gateway instead */
  globalNetworks: PaginatedNetwork
  /** @deprecated Use the global gateway instead */
  globalToken: GlobalToken
  homepage?: Maybe<Page>
  /** @deprecated This query will be replaced by impersonateLoginToNetwork mutation */
  impersonateLoginToNetwork: AuthInfoWithOtp
  invitationLinkValidity: MemberInvitationLink
  /** @deprecated This query is replaced by analytics */
  leaderboard: Array<Member>
  /** @deprecated This query is replaced by analytics */
  leaderboardWithScores: Array<LeaderboardItem>
  limitedToken: AppToken
  /** @deprecated This query will be replaced by loginNetwork mutation */
  loginNetwork: AuthToken
  /** @deprecated This query will be replaced by loginNetworkWithPassword mutation */
  loginNetworkWithPassword: AuthToken
  /** @deprecated This query will be replaced by supportSsoUrl */
  loginSupportWithSso: SupportSsoUrl
  loginSupportWithSsoCode: SupportAuthToken
  /** @deprecated This query will be replaced by ssoUrl */
  loginWithSso: SsoUrl
  /** @deprecated This query will be replaced by loginWithSsoCode mutation */
  loginWithSsoCode: AuthToken
  massActionRequest: MassActionRequest
  massActionRequestInProgress: MassActionRequest
  media: Media
  member: Member
  memberEventRegistrations: Array<MemberEventRegistration>
  memberInvitation: MemberInvitation
  memberInvitationLink: MemberInvitationLink
  memberInvitationValidity: MemberInvitation
  memberInvitations: PaginatedMemberInvitation
  memberPosts: PaginatedPost
  /** @deprecated This query is no longer valid. */
  memberScore: Report
  memberSpaceMembershipRequest: Array<SpaceJoinRequest>
  memberSpaces: PaginatedSpaceMember
  members: PaginatedMember
  membersByIds: Array<Member>
  /** Get messages in chat before or after a certain message, along with a cursor. The cursor can be used to fetch more messages using `messagesByCursor` query */
  messages: MessageList
  /** Get a list of messages from a chat using a cursor. The direction of the query depends on the original query where the cursor was acquired. */
  messagesByCursor: MessageList
  migrationSampleFile: Scalars['String']
  moderationItem: ModerationItem
  moderationItemReporters: PaginatedModerationItemReporter
  moderationItems: PaginatedModeration
  moderationSettings: ModerationSettings
  network: Network
  networkAppInstallations: PaginatedAppInstallation
  networkApps: Array<App>
  networkPublicInfo: NetworkPublicInfo
  /** @deprecated This query is unstable and may be removed in the future */
  networkSessionSettings: SessionSettings
  networks: PaginatedNetwork
  networksMembers: PaginatedPluralMember
  newDomainStatus: DomainTransferStatus
  notifications: PaginatedNotification
  notificationsCount: NotificationsCount
  oAuthCode: OAuthCode
  oAuthTokens: OAuthTokens
  oidcs: Array<Oidc>
  otp: Scalars['String']
  page: Page
  pageCustomResponses: PaginatedPageCustomResponse
  passwordComplexity: PasswordComplexity
  permission: Permission
  permissions: Array<Permission>
  /** Tracks latest activity on the current user session. Can only be called once per 5 minutes. */
  pingSession: Action
  /** Get a single poll by ID. Access is granted based on poll ownership, user role, and parent entity context. */
  poll: Poll
  post: Post
  postModerationItems: PaginatedModeration
  postReactionParticipants: PaginatedPostReactionParticipant
  postType: PostType
  postTypes: PaginatedPostType
  posts: PaginatedPost
  postsByIds: Array<Post>
  /**
   * Create or get a private message space inside your community which will be visible to recipient only after first message.
   * @deprecated This query is deprecated. Use the new chat API instead.
   */
  privateMessage: Space
  probeDomain: DomainProbeResult
  /** Get the publisher settings for the given publisher. */
  publisherSettings: Publisher
  /** Recommend members based on positive and negative resource IDs */
  recommendMembers: Array<Member>
  /** Recommend posts based on positive and negative resource IDs */
  recommendPosts: Array<Post>
  /** Recommend spaces based on positive and negative resource IDs */
  recommendSpaces: Array<Space>
  redirect: Redirect
  replies: PaginatedPost
  /** @deprecated This query is replaced by analytics */
  report: Report
  roles: Array<Role>
  scopes: Scopes
  /** @deprecated Use searchMembers, searchSpaces, or searchPosts instead */
  search: SearchResult
  /** Search for events with pagination. The search will sort the result based on the relevance score to the input query. */
  searchEvents: PaginatedEvent
  /** Search for members with pagination. The search will sort the result based on the relevance score to the input query. */
  searchMembers: PaginatedMember
  searchMembersForSpaceInvitation: Array<MemberForSpaceInvitation>
  /** Search for participants */
  searchParticipants: Array<ChatParticipant>
  /** Search for posts with pagination. The search will sort the result based on the relevance score to the input query. */
  searchPosts: PaginatedPost
  /** Search for spaces with pagination. The search will sort the result based on the relevance score to the input query. */
  searchSpaces: PaginatedSpace
  /** Paginates over the sitemap items of the site, the items can correspond to SEO indexed content or SEO indexed spaces */
  sitemap: PaginatedSitemap
  space: Space
  spaceContentModule: SpaceContentModule
  spaceContentModules: Array<SpaceContentModule>
  spaceJoinRequests: PaginatedSpaceJoinRequest
  spaceMember: SpaceMember
  spaceMembers: PaginatedSpaceMember
  spaceMembershipRequests: Array<SpaceJoinRequest>
  spacePinnedPosts: Array<Post>
  spacePostType: SpacePostType
  spacePostTypes: PaginatedSpacePostType
  spaceRoles: Array<SpaceRole>
  spaces: PaginatedSpace
  spacesByIds: Array<Space>
  spacesBySlugs: Array<Space>
  ssoMemberships: Array<SsoMembership>
  ssoUrl: SsoUrl
  ssos: Array<Sso>
  /** Get the subscriber settings for the auth member. */
  subscriberSettings: Subscriber
  subscriptionInformation: SubscriptionInformation
  /** Get the subscriptions for the auth member. */
  subscriptions: PaginatedNotificationSubscriptions
  supportNetworkTokens: SupportLimitedAuthToken
  supportSsoUrl: SupportSsoUrl
  systemSpaces: Array<Space>
  tagPosts: PaginatedPost
  tags: PaginatedTag
  template: Template
  templateRequest: TemplateRequest
  templates: PaginatedTemplate
  tokens: AuthToken
  translateMarkup: Array<Scalars['String']>
  /** This query will only count the unread conversations in the most recent conversations (currently limited to 100 conversations). Any unread conversation after the threshold will be ignored. This criteria is subject to change without advance notice. */
  unreadChatsCount: UnreadChatsCount
  /** Get number of unread messages for the member per specified chat. */
  unreadMessageCounts: UnreadMessageCountsPerChat
  usernameAvailability: UsernameAvailability
  /** Get info for all networks where the member is an admin */
  workspaces: Array<NetworkPublicInfo>
}

export type QueryAccessGroupArgs = {
  id: Scalars['ID']
}

export type QueryActivityLogsArgs = {
  query: Scalars['String']
}

export type QueryAnalyticsArgs = {
  queries: Array<Scalars['String']>
}

export type QueryAppArgs = {
  clientId?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['ID']>
  redirectUri?: InputMaybe<Scalars['String']>
  slug?: InputMaybe<Scalars['String']>
}

export type QueryAppsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  standing?: InputMaybe<StoreItemStanding>
  status?: InputMaybe<StoreItemStatus>
}

export type QueryAuthMemberAppInstallationArgs = {
  appId: Scalars['String']
}

export type QueryAuthMemberAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryAutocompletePhysicalLocationsArgs = {
  input: AutocompletePhysicalLocationInput
}

export type QueryAvailableDynamicBlocksArgs = {
  context?: InputMaybe<PermissionContext>
  size?: InputMaybe<DynamicBlockSize>
}

export type QueryCalendarInviteArgs = {
  eventId: Scalars['ID']
}

export type QueryCalendarInviteDataArgs = {
  eventId: Scalars['ID']
}

export type QueryChatArgs = {
  id: Scalars['String']
}

export type QueryChatIdFromSlugArgs = {
  slug: Scalars['String']
}

export type QueryChatParticipantsArgs = {
  chatId: Scalars['String']
  limit: Scalars['Int']
}

export type QueryChatParticipantsByCursorArgs = {
  chatId: Scalars['String']
  cursor: Scalars['String']
  limit: Scalars['Int']
}

export type QueryChatParticipantsByIdsArgs = {
  chatId: Scalars['String']
  participantIds: Array<Scalars['String']>
}

export type QueryChatsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>
  direction?: InputMaybe<QueryDirection>
  limit: Scalars['Int']
  messageId?: InputMaybe<Scalars['String']>
  timestamp?: InputMaybe<Scalars['Int']>
}

export type QueryChatsByCursorArgs = {
  cursor: Scalars['String']
  limit: Scalars['Int']
}

export type QueryCheckDomainAvailabilityArgs = {
  input: DomainAvailabilityInput
}

export type QueryCheckEmailAvailabilityArgs = {
  email: Scalars['String']
}

export type QueryCheckInvitationLinkValidityArgs = {
  invitationLinkId: Scalars['String']
}

export type QueryCheckMemberInvitationValidityArgs = {
  token: Scalars['String']
}

export type QueryCheckMembersContactabilityArgs = {
  memberIds: Array<Scalars['String']>
}

export type QueryCheckNewDomainStatusArgs = {
  domain: Scalars['String']
}

export type QueryCheckPasswordComplexityArgs = {
  password: Scalars['String']
}

export type QueryCheckUsernameAvailabilityArgs = {
  username: Scalars['String']
}

export type QueryCollectionArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryCollectionsArgs = {
  orderBy?: InputMaybe<CollectionListOrderByEnum>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryDomainAvailabilityArgs = {
  input: DomainAvailabilityInput
}

export type QueryDraftPollsForEntityTypeArgs = {
  parentEntityType: PollEntityType
  pollIds: Array<Scalars['String']>
}

export type QueryDraftPostsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit?: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  scheduled?: InputMaybe<Scalars['Boolean']>
  spaceIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryDraftPostsCountArgs = {
  scheduled?: InputMaybe<Scalars['Boolean']>
  spaceIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryDynamicBlockArgs = {
  blockId: Scalars['ID']
}

export type QueryDynamicBlockByKeyArgs = {
  appId: Scalars['ID']
  key: Scalars['String']
}

export type QueryDynamicBlocksArgs = {
  after?: InputMaybe<Scalars['String']>
  appIds?: InputMaybe<Array<Scalars['ID']>>
  before?: InputMaybe<Scalars['String']>
  contexts?: InputMaybe<Array<PermissionContext>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryEmailAvailabilityArgs = {
  email: Scalars['String']
}

export type QueryEmailLogsArgs = {
  after?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  recipient?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  statuses?: InputMaybe<Array<EmailStatus>>
  types?: InputMaybe<Array<EmailType>>
}

export type QueryEmbedArgs = {
  input: EmbedInput
}

export type QueryEventArgs = {
  id: Scalars['ID']
}

export type QueryEventAnalyticsArgs = {
  eventRecurrenceIds?: InputMaybe<Array<Scalars['String']>>
  limit?: InputMaybe<Scalars['Float']>
  metric?: InputMaybe<EventMetric>
  offset?: InputMaybe<Scalars['Float']>
}

export type QueryEventRecurrencesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<EventRecurrenceOrderByEnum>
  recurrenceId: Scalars['ID']
  reverse?: InputMaybe<Scalars['Boolean']>
  startTime?: InputMaybe<EventDateFilterInput>
}

export type QueryEventRegistrationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  eventId: Scalars['ID']
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  statuses?: InputMaybe<Array<EventRegistrationStatus>>
}

export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  createdById?: InputMaybe<Scalars['ID']>
  endTime?: InputMaybe<EventDateFilterInput>
  eventIds?: InputMaybe<Array<Scalars['ID']>>
  hostIds?: InputMaybe<Array<Scalars['ID']>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<EventListOrderByEnum>
  query?: InputMaybe<Scalars['String']>
  recurrenceMode?: InputMaybe<GetEventsRecurrenceMode>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceIds?: InputMaybe<Array<Scalars['ID']>>
  startTime?: InputMaybe<EventDateFilterInput>
  status?: InputMaybe<EventStatus>
  tagIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryExploreSpacesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  collectionId?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryExportMemberRequestArgs = {
  id: Scalars['ID']
}

export type QueryExportMemberRequestsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<ExportListOrderByEnum>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  statuses?: InputMaybe<Array<ExportStatus>>
}

export type QueryExternalSearchArgs = {
  query: Scalars['String']
}

export type QueryExtraPropertiesArgs = {
  entityId?: InputMaybe<Scalars['String']>
  entityType: ExtraPropertyEntityType
  keys?: InputMaybe<Array<Scalars['String']>>
}

export type QueryFeedArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filterBy?: InputMaybe<Array<PostListFilterByInput>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  onlyMemberSpaces?: InputMaybe<Scalars['Boolean']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  orderByString?: InputMaybe<Scalars['String']>
  postTypeIds?: InputMaybe<Array<Scalars['String']>>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryFilterMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  filters?: InputMaybe<FiltersInput>
  limit: Scalars['Int']
  orderBy?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryFilterPostsArgs = {
  after?: InputMaybe<Scalars['String']>
  filters?: InputMaybe<FiltersInput>
  limit: Scalars['Int']
  orderBy?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryFilterSpacesArgs = {
  after?: InputMaybe<Scalars['String']>
  filters?: InputMaybe<FiltersInput>
  limit: Scalars['Int']
  orderBy?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryFindChatWithMemberArgs = {
  recipientId: Scalars['String']
}

export type QueryGenerateStaticMapUrlArgs = {
  input: StaticMapInput
}

export type QueryGetAppByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetAppBySlugArgs = {
  slug: Scalars['String']
}

export type QueryGetAppNetworkSettingsArgs = {
  appId: Scalars['ID']
}

export type QueryGetAppSpaceSettingsArgs = {
  appId: Scalars['ID']
  spaceId: Scalars['ID']
}

export type QueryGetAppsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<StoreItemStatus>
}

export type QueryGetEmbedArgs = {
  input: EmbedInput
}

export type QueryGetFeedArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filterBy?: InputMaybe<Array<PostListFilterByInput>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  onlyMemberSpaces?: InputMaybe<Scalars['Boolean']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  postTypeIds?: InputMaybe<Array<Scalars['String']>>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetGroupArgs = {
  groupId?: InputMaybe<Scalars['ID']>
}

export type QueryGetMediaArgs = {
  mediaId: Scalars['ID']
}

export type QueryGetMemberArgs = {
  memberId?: InputMaybe<Scalars['ID']>
  username?: InputMaybe<Scalars['String']>
}

export type QueryGetMemberAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryGetMemberInvitationArgs = {
  id: Scalars['ID']
}

export type QueryGetMemberInvitationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['String']>>
  status?: InputMaybe<MemberInvitationStatus>
}

export type QueryGetMemberPostsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  memberId: Scalars['ID']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetMemberSpacesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  groupId?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  memberId: Scalars['ID']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryGetMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['ID']>>
  status?: InputMaybe<Array<MemberStatusInput>>
}

export type QueryGetModerationByIdArgs = {
  moderationId: Scalars['ID']
}

export type QueryGetModerationReportersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  moderationId: Scalars['String']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetModerationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  entityId?: InputMaybe<Scalars['String']>
  entityType?: InputMaybe<ModerationEntityType>
  flaggedBy?: InputMaybe<FlaggedType>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['String']>
  status?: InputMaybe<ModerationStatus>
}

export type QueryGetNetworkAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryGetNetworkAppsArgs = {
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryGetNetworksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  verb?: InputMaybe<NotificationVerb>
}

export type QueryGetPlaceDetailsArgs = {
  input: PlaceDetailsInput
}

export type QueryGetPostArgs = {
  postId: Scalars['ID']
}

export type QueryGetPostAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  postId: Scalars['ID']
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryGetPostReactionParticipantsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  postId: Scalars['ID']
  reaction: Scalars['ID']
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetPostsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  excludePins?: InputMaybe<Scalars['Boolean']>
  filterBy?: InputMaybe<Array<PostListFilterByInput>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  postTypeIds?: InputMaybe<Array<Scalars['String']>>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryGetRepliesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  excludePins?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  postId: Scalars['ID']
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetReportArgs = {
  input: ReportInput
}

export type QueryGetScopesArgs = {
  contexts?: InputMaybe<Array<PermissionsContextInput>>
}

export type QueryGetSpaceArgs = {
  spaceId?: InputMaybe<Scalars['ID']>
  spaceSlug?: InputMaybe<Scalars['ID']>
}

export type QueryGetSpaceAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId: Scalars['ID']
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryGetSpaceMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['ID']>>
  spaceId: Scalars['ID']
}

export type QueryGetSpaceMembershipRequestForMemberArgs = {
  status?: InputMaybe<SpaceJoinRequestStatus>
}

export type QueryGetSpaceMembershipRequestsArgs = {
  spaceId: Scalars['ID']
  status?: InputMaybe<SpaceJoinRequestStatus>
}

export type QueryGetSpacePinnedPostsArgs = {
  spaceId: Scalars['ID']
}

export type QueryGetSpaceReportArgs = {
  input: ReportInput
  spaceId: Scalars['String']
}

export type QueryGetSpaceRolesArgs = {
  spaceId?: InputMaybe<Scalars['ID']>
}

export type QueryGetSsoMembershipsArgs = {
  memberId: Scalars['String']
}

export type QueryGetSupportNetworkTokensArgs = {
  input: CreateLimitedSupportTokenInput
}

export type QueryGetTokensArgs = {
  networkDomain?: InputMaybe<Scalars['String']>
  networkId?: InputMaybe<Scalars['ID']>
  otp?: InputMaybe<Scalars['String']>
  refreshToken?: InputMaybe<Scalars['String']>
}

export type QueryGlobalAppArgs = {
  id?: InputMaybe<Scalars['ID']>
  slug?: InputMaybe<Scalars['String']>
}

export type QueryGlobalAppCollaboratorsArgs = {
  appId: Scalars['String']
}

export type QueryGlobalAppPublicationsArgs = {
  appId: Scalars['ID']
}

export type QueryGlobalAppSettingsArgs = {
  context: PermissionContext
  entityId?: InputMaybe<Scalars['ID']>
  networkId: Scalars['ID']
}

export type QueryGlobalAppsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  standing?: InputMaybe<StoreItemStanding>
  status?: InputMaybe<StoreItemStatus>
}

export type QueryGlobalEmbedArgs = {
  input: EmbedInput
}

export type QueryGlobalMediaArgs = {
  id: Scalars['ID']
}

export type QueryGlobalNetworksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleType?: InputMaybe<RoleType>
}

export type QueryGlobalTokenArgs = {
  input: GlobalTokenInput
}

export type QueryHomepageArgs = {
  type?: InputMaybe<HomeSpaceType>
}

export type QueryImpersonateLoginToNetworkArgs = {
  input: ImpersonateLoginToNetworkInput
}

export type QueryInvitationLinkValidityArgs = {
  id: Scalars['String']
}

export type QueryLeaderboardArgs = {
  input: ReportInput
}

export type QueryLeaderboardWithScoresArgs = {
  includeAuthMember: Scalars['Boolean']
  input: ReportInput
}

export type QueryLimitedTokenArgs = {
  context?: InputMaybe<PermissionContext>
  entityId?: InputMaybe<Scalars['String']>
  impersonateMemberId?: InputMaybe<Scalars['String']>
  networkId: Scalars['String']
}

export type QueryLoginNetworkArgs = {
  input: LoginNetworkWithPasswordInput
}

export type QueryLoginNetworkWithPasswordArgs = {
  input: LoginNetworkWithPasswordInput
}

export type QueryLoginSupportWithSsoArgs = {
  input?: InputMaybe<SupportSsoUrlInput>
}

export type QueryLoginSupportWithSsoCodeArgs = {
  input: LoginSupportWithSsoCodeInput
}

export type QueryLoginWithSsoArgs = {
  input: SsoUrlInput
}

export type QueryLoginWithSsoCodeArgs = {
  input: LoginWithSsoCodeInput
}

export type QueryMassActionRequestArgs = {
  id: Scalars['String']
}

export type QueryMediaArgs = {
  id: Scalars['ID']
}

export type QueryMemberArgs = {
  externalId?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['ID']>
  username?: InputMaybe<Scalars['String']>
}

export type QueryMemberEventRegistrationsArgs = {
  eventIds: Array<Scalars['ID']>
}

export type QueryMemberInvitationArgs = {
  id: Scalars['ID']
}

export type QueryMemberInvitationValidityArgs = {
  token: Scalars['String']
}

export type QueryMemberInvitationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filterBy?: InputMaybe<Array<MemberInvitationFilterByInput>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['String']>>
  status?: InputMaybe<MemberInvitationStatus>
}

export type QueryMemberPostsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  hasParent?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
  memberId: Scalars['ID']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryMemberScoreArgs = {
  input: ReportInput
  spaceId?: InputMaybe<Scalars['String']>
}

export type QueryMemberSpaceMembershipRequestArgs = {
  status?: InputMaybe<SpaceJoinRequestStatus>
}

export type QueryMemberSpacesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  collectionId?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  memberId: Scalars['ID']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filterBy?: InputMaybe<Array<MemberListFilterByInput>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Scalars['String']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['ID']>>
  status?: InputMaybe<Array<MemberStatusInput>>
}

export type QueryMembersByIdsArgs = {
  ids: Array<Scalars['String']>
}

export type QueryMessagesArgs = {
  addressSignature: Scalars['String']
  chatId: Scalars['String']
  direction: QueryDirection
  inclusive?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
  messageId: Scalars['String']
  pageId: Scalars['String']
}

export type QueryMessagesByCursorArgs = {
  chatId: Scalars['String']
  cursor: Scalars['String']
  limit: Scalars['Int']
}

export type QueryMigrationSampleFileArgs = {
  type?: InputMaybe<PermissionContext>
}

export type QueryModerationItemArgs = {
  id: Scalars['ID']
}

export type QueryModerationItemReportersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  moderationId: Scalars['String']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryModerationItemsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  entityId?: InputMaybe<Scalars['String']>
  entityType?: InputMaybe<ModerationEntityType>
  flaggedBy?: InputMaybe<FlaggedType>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reportCategories?: InputMaybe<Array<ReportCategory>>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['String']>
  status?: InputMaybe<ModerationStatus>
}

export type QueryNetworkAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryNetworkAppsArgs = {
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryNetworksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryNetworksMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleType?: InputMaybe<RoleType>
  status?: InputMaybe<Array<MemberStatus>>
}

export type QueryNewDomainStatusArgs = {
  domain: Scalars['String']
}

export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  verb?: InputMaybe<NotificationVerb>
}

export type QueryOAuthCodeArgs = {
  input: OAuthCodeInput
}

export type QueryOAuthTokensArgs = {
  input: OAuthTokenInput
}

export type QueryPageArgs = {
  path: Scalars['String']
}

export type QueryPageCustomResponsesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  creatorType?: InputMaybe<CreatorType>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryPasswordComplexityArgs = {
  password: Scalars['String']
}

export type QueryPermissionArgs = {
  id: Scalars['ID']
}

export type QueryPollArgs = {
  id: Scalars['ID']
}

export type QueryPostArgs = {
  id: Scalars['ID']
}

export type QueryPostModerationItemsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  entityId?: InputMaybe<Scalars['String']>
  flaggedBy?: InputMaybe<FlaggedType>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reportCategories?: InputMaybe<Array<ReportCategory>>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['String']>
  status?: InputMaybe<ModerationStatus>
}

export type QueryPostReactionParticipantsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  postId: Scalars['ID']
  reaction: Scalars['ID']
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryPostTypeArgs = {
  id: Scalars['ID']
}

export type QueryPostTypesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  context?: InputMaybe<PostTypeContext>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryPostsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  excludePins?: InputMaybe<Scalars['Boolean']>
  filterBy?: InputMaybe<Array<PostListFilterByInput>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  orderByString?: InputMaybe<Scalars['String']>
  postTypeIds?: InputMaybe<Array<Scalars['String']>>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryPostsByIdsArgs = {
  ids: Array<Scalars['ID']>
  statuses?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryPrivateMessageArgs = {
  input: PrivateMessageInput
}

export type QueryProbeDomainArgs = {
  domain: Scalars['String']
}

export type QueryPublisherSettingsArgs = {
  publisherId: Scalars['String']
}

export type QueryRecommendMembersArgs = {
  filters?: InputMaybe<FiltersInput>
  limit: Scalars['Float']
  negativeResourceIds?: InputMaybe<Array<Scalars['String']>>
  positiveResourceIds: Array<Scalars['String']>
}

export type QueryRecommendPostsArgs = {
  filters?: InputMaybe<FiltersInput>
  limit: Scalars['Float']
  negativeResourceIds?: InputMaybe<Array<Scalars['String']>>
  positiveResourceIds: Array<Scalars['String']>
}

export type QueryRecommendSpacesArgs = {
  filters?: InputMaybe<FiltersInput>
  limit: Scalars['Float']
  negativeResourceIds?: InputMaybe<Array<Scalars['String']>>
  positiveResourceIds: Array<Scalars['String']>
}

export type QueryRedirectArgs = {
  url: Scalars['String']
}

export type QueryRepliesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  excludePins?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  postId: Scalars['ID']
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryReportArgs = {
  input: ReportInput
  spaceId?: InputMaybe<Scalars['String']>
}

export type QueryRolesArgs = {
  orderBy?: InputMaybe<RoleListOrderByEnum>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryScopesArgs = {
  contexts?: InputMaybe<Array<PermissionsContextInput>>
}

export type QuerySearchArgs = {
  input: SearchInput
}

export type QuerySearchEventsArgs = {
  after?: InputMaybe<Scalars['String']>
  filters?: InputMaybe<FiltersInput>
  limit: Scalars['Int']
  query: Scalars['String']
  searchConfig?: InputMaybe<SearchConfigInput>
}

export type QuerySearchMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  filters?: InputMaybe<FiltersInput>
  limit: Scalars['Int']
  query: Scalars['String']
  searchConfig?: InputMaybe<SearchConfigInput>
}

export type QuerySearchMembersForSpaceInvitationArgs = {
  input: SearchMembersForSpaceInvitationInput
}

export type QuerySearchParticipantsArgs = {
  chatId: Scalars['String']
  term: Scalars['String']
}

export type QuerySearchPostsArgs = {
  after?: InputMaybe<Scalars['String']>
  filters?: InputMaybe<FiltersInput>
  limit: Scalars['Int']
  query: Scalars['String']
  searchConfig?: InputMaybe<SearchConfigInput>
}

export type QuerySearchSpacesArgs = {
  after?: InputMaybe<Scalars['String']>
  filters?: InputMaybe<FiltersInput>
  limit: Scalars['Int']
  query: Scalars['String']
  searchConfig?: InputMaybe<SearchConfigInput>
}

export type QuerySitemapArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  indexableOnly?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
  reverse?: InputMaybe<Scalars['Boolean']>
  spacePath?: InputMaybe<Scalars['ID']>
}

export type QuerySpaceArgs = {
  id?: InputMaybe<Scalars['ID']>
  path?: InputMaybe<Scalars['String']>
  slug?: InputMaybe<Scalars['ID']>
}

export type QuerySpaceContentModuleArgs = {
  contentModuleType: ContentModuleType
  spaceId: Scalars['ID']
}

export type QuerySpaceContentModulesArgs = {
  spaceId: Scalars['ID']
}

export type QuerySpaceJoinRequestsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  memberId?: InputMaybe<Scalars['ID']>
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['ID']>
  status?: InputMaybe<SpaceJoinRequestStatus>
}

export type QuerySpaceMemberArgs = {
  memberId: Scalars['ID']
  spaceId: Scalars['ID']
}

export type QuerySpaceMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<SpaceMemberListOrderByEnum>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['ID']>>
  spaceId: Scalars['ID']
}

export type QuerySpaceMembershipRequestsArgs = {
  spaceId: Scalars['ID']
  status?: InputMaybe<SpaceJoinRequestStatus>
}

export type QuerySpacePinnedPostsArgs = {
  spaceId: Scalars['ID']
}

export type QuerySpacePostTypeArgs = {
  postTypeId: Scalars['ID']
  spaceId: Scalars['ID']
}

export type QuerySpacePostTypesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  context?: InputMaybe<PostTypeContext>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId: Scalars['ID']
}

export type QuerySpaceRolesArgs = {
  orderBy?: InputMaybe<SpaceRoleListOrderByEnum>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['ID']>
}

export type QuerySpacesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  collectionId?: InputMaybe<Scalars['String']>
  exploreOnly?: InputMaybe<Scalars['Boolean']>
  filterBy?: InputMaybe<Array<EntityListFilterByInput>>
  limit: Scalars['Int']
  memberId?: InputMaybe<Scalars['ID']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<SpaceListOrderByEnum>
  orderByString?: InputMaybe<Scalars['String']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  type?: InputMaybe<Array<SpaceType>>
}

export type QuerySpacesByIdsArgs = {
  ids: Array<Scalars['ID']>
}

export type QuerySpacesBySlugsArgs = {
  slugs: Array<Scalars['String']>
}

export type QuerySsoMembershipsArgs = {
  memberId: Scalars['String']
}

export type QuerySsoUrlArgs = {
  input: SsoUrlInput
}

export type QuerySsosArgs = {
  status?: InputMaybe<SsoStatus>
}

export type QuerySubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  publisherType?: InputMaybe<PublisherType>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QuerySupportNetworkTokensArgs = {
  networkId: Scalars['String']
}

export type QuerySupportSsoUrlArgs = {
  input?: InputMaybe<SupportSsoUrlInput>
}

export type QueryTagPostsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['ID']>
  tagId?: InputMaybe<Scalars['ID']>
  tagSlug?: InputMaybe<Scalars['String']>
}

export type QueryTagsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  ids?: InputMaybe<Array<Scalars['ID']>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<TagsOrderByEnum>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['ID']>
}

export type QueryTemplateArgs = {
  id: Scalars['String']
}

export type QueryTemplateRequestArgs = {
  id: Scalars['String']
}

export type QueryTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  categories?: InputMaybe<Array<Scalars['String']>>
  entityTypes?: InputMaybe<Array<TemplateEntityType>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<StoreItemStatus>
}

export type QueryTokensArgs = {
  networkDomain?: InputMaybe<Scalars['String']>
  networkId?: InputMaybe<Scalars['ID']>
  otp?: InputMaybe<Scalars['String']>
  refreshToken?: InputMaybe<Scalars['String']>
  ssoToken?: InputMaybe<Scalars['String']>
}

export type QueryTranslateMarkupArgs = {
  format?: InputMaybe<TranslationMarkupFormat>
  input?: InputMaybe<Array<TranslationMarkupInput>>
  markups?: InputMaybe<Array<Scalars['String']>>
}

export type QueryUnreadChatsCountArgs = {
  archived?: InputMaybe<Scalars['Boolean']>
}

export type QueryUnreadMessageCountsArgs = {
  chatIds: Array<Scalars['String']>
}

export type QueryUsernameAvailabilityArgs = {
  username: Scalars['String']
}

export enum QueryDirection {
  After = 'After',
  Before = 'Before',
}

/** RangeInput class is used to filter fields of type date or number. It allows specifying a range with greater than, greater than or equal, less than, and less than or equal conditions. */
export type RangeInput = {
  /** Greater than condition for date or number fields (value should be a JSON string) */
  gt?: InputMaybe<Scalars['String']>
  /** Greater than or equal condition for date or number fields (value should be a JSON string) */
  gte?: InputMaybe<Scalars['String']>
  /** Less than condition for date or number fields (value should be a JSON string) */
  lt?: InputMaybe<Scalars['String']>
  /** Less than or equal condition for date or number fields (value should be a JSON string) */
  lte?: InputMaybe<Scalars['String']>
}

export type ReOrderSchemaFieldInput = {
  index: Scalars['Int']
  key: Scalars['String']
}

export enum ReactionType {
  EMOJI_BASE = 'EMOJI_BASE',
  LIKE_BASE = 'LIKE_BASE',
  VOTE_BASE = 'VOTE_BASE',
}

export enum RecurringEventFrequency {
  daily = 'daily',
  monthly = 'monthly',
  once = 'once',
  weekly = 'weekly',
  yearly = 'yearly',
}

export enum RecurringEventRegistrationMode {
  allUpcomingEvents = 'allUpcomingEvents',
  thisEventOnly = 'thisEventOnly',
}

export enum RecurringEventUpdateMode {
  allEvents = 'allEvents',
  thisAndFutureEvents = 'thisAndFutureEvents',
  thisEventOnly = 'thisEventOnly',
}

export type Redirect = {
  resolvedUrl: Scalars['String']
  url: Scalars['String']
}

/** Input for registering for an event. */
export type RegisterForEventInput = {
  /** The mode to register for the event. If not provided, defaults to thisEventOnly. */
  recurringEventRegistrationMode?: InputMaybe<RecurringEventRegistrationMode>
}

export enum RelationTypeOptions {
  Media = 'Media',
  Member = 'Member',
  Post = 'Post',
  Space = 'Space',
  Tag = 'Tag',
}

export type RemoveMembersFromGroupInput = {
  memberIds: Array<Scalars['String']>
}

export type RemovedParticipantsMetadata = {
  removedParticipants: Array<ChatParticipant>
  type: ChatLogType
}

export type ReorderBadgeInput = {
  /** The id of the badge that will be directly before the moved badge. If not provided, the badge will be moved to the beginning of the list */
  previousBadgeId?: InputMaybe<Scalars['String']>
}

export type ReorderBadgesInput = {
  /** The new order of the badges in the network. This must contain all active badges in the network */
  badgeOrderIds: Array<Scalars['String']>
}

export type Report = {
  data?: Maybe<Array<ReportData>>
  description?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['DateTime']>
  previousValue?: Maybe<Scalars['String']>
  slug: Scalars['String']
  startDate?: Maybe<Scalars['DateTime']>
  title: Scalars['String']
  tooltip?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['String']>
}

export enum ReportCategory {
  HARASSMENT = 'HARASSMENT',
  MISINFORMATION = 'MISINFORMATION',
  NUDITY = 'NUDITY',
  OTHER = 'OTHER',
  SPAM = 'SPAM',
  SUICIDE = 'SUICIDE',
  TERRORISM = 'TERRORISM',
  VIOLENCE = 'VIOLENCE',
}

export type ReportData = {
  description?: Maybe<Scalars['String']>
  key: Scalars['String']
  previousValue?: Maybe<ReportDataValue>
  type: ReportDataType
  value: ReportDataValue
}

export enum ReportDataType {
  chartData = 'chartData',
  entityReport = 'entityReport',
  intValue = 'intValue',
  stringValue = 'stringValue',
}

export type ReportDataValue = ChartData | EntityReport | IntValue | StringValue

export type ReportEntities = {
  actor?: Maybe<Member>
  app?: Maybe<App>
  event?: Maybe<Event>
  member?: Maybe<Member>
  person?: Maybe<Member>
  post?: Maybe<Post>
  space?: Maybe<Space>
  tag?: Maybe<Tag>
}

export type ReportInput = {
  endDate?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  slug: ReportSlug
  sort?: InputMaybe<ColumnSortInput>
  startDate?: InputMaybe<Scalars['String']>
  timeFrame?: InputMaybe<ReportTimeFrame>
  timeZone: Scalars['String']
}

export type ReportPayload = {
  key: Scalars['String']
  value: Scalars['String']
}

export type ReportRecord = {
  entities: ReportEntities
  payload: Array<ReportPayload>
}

export enum ReportSlug {
  activeMembers = 'activeMembers',
  averageDailyActiveMembers = 'averageDailyActiveMembers',
  highlights = 'highlights',
  memberScore = 'memberScore',
  newMembersOverTime = 'newMembersOverTime',
  newPosts = 'newPosts',
  newReactions = 'newReactions',
  newReplies = 'newReplies',
  popularDaysOfWeek = 'popularDaysOfWeek',
  popularHoursOfDay = 'popularHoursOfDay',
  postsVSreplies = 'postsVSreplies',
  topMembers = 'topMembers',
  topPosts = 'topPosts',
  topSpaces = 'topSpaces',
  totalMembers = 'totalMembers',
  totalPosts = 'totalPosts',
  totalReactions = 'totalReactions',
  totalReplies = 'totalReplies',
  totalVisitors = 'totalVisitors',
  trendingTags = 'trendingTags',
}

export enum ReportTimeFrame {
  allTime = 'allTime',
  lastCalendarQuarter = 'lastCalendarQuarter',
  lastCalendarYear = 'lastCalendarYear',
  lastMonth = 'lastMonth',
  lastNinetyDays = 'lastNinetyDays',
  lastSevenDays = 'lastSevenDays',
  lastThirtyDays = 'lastThirtyDays',
  lastTwelveMonth = 'lastTwelveMonth',
  lastWeek = 'lastWeek',
  today = 'today',
  yesterday = 'yesterday',
}

export type ReportableEntity = Event | Member | Post | Space | Tag

export enum ReportableEntityType {
  event = 'event',
  member = 'member',
  post = 'post',
  space = 'space',
}

export type RequestGlobalTokenInput = {
  captchaToken?: InputMaybe<Scalars['String']>
  email: Scalars['String']
}

export type ResetPasswordInput = {
  email: Scalars['String']
}

export enum RichTextTypeOptions {
  html = 'html',
  markup = 'markup',
}

export type Role = {
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  scopes: Array<Scalars['String']>
  type?: Maybe<RoleType>
  visible: Scalars['Boolean']
}

export enum RoleListOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT',
}

export enum RoleType {
  admin = 'admin',
  guest = 'guest',
  member = 'member',
  moderator = 'moderator',
}

export type Scopes = {
  contextAwareScopes: Array<ContextScopes>
  scopes: Array<Scalars['String']>
}

/** SearchConfigInput class is used to configure the search. */
export type SearchConfigInput = {
  /** Enable full text search */
  fullTextEnabled: Scalars['Boolean']
  /** Fusion kind */
  fusionKind: SearchFusionKind
  /** Fusion score threshold */
  fusionScoreThreshold: Scalars['Float']
  /** Enable vector embed search */
  vectorEmbedEnabled: Scalars['Boolean']
  /** Vector embed score threshold */
  vectorEmbedScoreThreshold: Scalars['Float']
  /** Enable vector text search */
  vectorTextEnabled: Scalars['Boolean']
  /** Vector text score threshold */
  vectorTextScoreThreshold: Scalars['Float']
}

export type SearchEntity = {
  by?: Maybe<By>
  content?: Maybe<Scalars['String']>
  created?: Maybe<Scalars['DateTime']>
  entity?: Maybe<SearchObjectEntity>
  entityId?: Maybe<Scalars['String']>
  entityType: SearchEntityType
  id: Scalars['ID']
  in?: Maybe<In>
  media?: Maybe<Media>
  subtitle?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  title: Scalars['String']
  url?: Maybe<Scalars['String']>
}

export type SearchEntityGroup = {
  entityType: SearchEntityType
  hits: Array<SearchEntity>
}

export enum SearchEntityType {
  External = 'External',
  member = 'member',
  post = 'post',
  space = 'space',
}

export enum SearchFusionKind {
  dbsf = 'dbsf',
  rrf = 'rrf',
}

export type SearchInput = {
  filters?: InputMaybe<Array<DeprecatedFiltersInput>>
  includeExternal?: InputMaybe<Scalars['Boolean']>
  query: Scalars['String']
}

export type SearchMembersForSpaceInvitationInput = {
  query: Scalars['String']
  spaceId: Scalars['ID']
}

export type SearchNetworkSettings = {
  askAiAvailability: AskAiAvailability
  /** @deprecated Use askAiAvailability instead */
  askAiEnabled: Scalars['Boolean']
  availableSearchSources: AvailableSearchSources
  /** Space IDs for official resources that appears in a separate section at the top of search results and has higher priority in Ask AI feature */
  officialResourcesSpaceIds: Array<Scalars['String']>
}

export type SearchObjectEntity = Member | Post | Space

export type SearchResult = {
  hits: Array<SearchEntityGroup>
  totalCount: Scalars['Float']
}

export type SendMessageToChatInput = {
  /** IDs of attached files. */
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  content: Scalars['String']
  /** IDs of embedded links. */
  embedIds?: InputMaybe<Array<Scalars['String']>>
  /** IDs of attached images. */
  imageIds?: InputMaybe<Array<Scalars['String']>>
  nonce?: InputMaybe<Scalars['String']>
}

export type SendMessageToMemberInput = {
  message: SendMessageToChatInput
  recipientId: Scalars['String']
}

export type SessionSettings = {
  sessionIdleTimeout: Scalars['String']
  sessionLifetime: Scalars['String']
}

export type SessionSettingsInput = {
  sessionIdleTimeout?: InputMaybe<Scalars['String']>
  sessionLifetime?: InputMaybe<Scalars['String']>
}

export type Settings = {
  captcha?: Maybe<CaptchaSettings>
  contentTranslation?: Maybe<ContentTranslationSettings>
  emailDigestEnabled: Scalars['Boolean']
  emailDigestLayoutId: Scalars['String']
  emailDigestRecentPostsFilter: EmailDigestRecentPostsFilter
  emailEnabled: Scalars['Boolean']
  emailFrom?: Maybe<Scalars['String']>
  emailNotificationEnabled: Scalars['Boolean']
  fileSizeLimit: Scalars['Float']
  fileTypesLimit: Array<Scalars['String']>
  imageSizeLimit: Scalars['Float']
  imageTypesLimit: Array<Scalars['String']>
  memberPermissions?: Maybe<MembersPermissionSettings>
  /** @deprecated This field will be replaced by privateMessaging.membersCanTurnOffPrivateMessaging */
  membersCanTurnOffPrivateMessaging?: Maybe<Scalars['Boolean']>
  /** @deprecated This field will be replaced by privateMessaging.membersCanUsePrivateMessaging */
  membersCanUsePrivateMessaging?: Maybe<Scalars['Boolean']>
  privateMessaging?: Maybe<PrivateMessagingSettings>
  /** @deprecated This field will be replaced by privateMessaging.privateMessagingEnabled */
  privateMessagingEnabled?: Maybe<Scalars['Boolean']>
  session?: Maybe<SessionSettings>
  xFrameEmbedding?: Maybe<XFrameEmbeddingSettings>
}

export enum ShortContentFormat {
  Html = 'Html',
  Text = 'Text',
}

export type Shortcut = {
  app?: Maybe<App>
  appId: Scalars['ID']
  description?: Maybe<Scalars['String']>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  key: Scalars['String']
  name: Scalars['String']
}

export type SignedUrl = {
  fields: Scalars['String']
  mediaDownloadUrl: Scalars['String']
  mediaId: Scalars['ID']
  mediaUrl: Scalars['String']
  signedUrl: Scalars['String']
  urls?: Maybe<MediaUrls>
}

export type Sitemap = {
  /** The id of the sitemap item */
  id: Scalars['ID']
  lastModifiedAt: Scalars['DateTime']
  url: Scalars['String']
}

export type SitemapEdge = {
  cursor: Scalars['String']
  node: Sitemap
}

export type Slate = {
  blocks: Array<Block>
  id?: Maybe<Scalars['String']>
  restrictions?: Maybe<SlateRestrictions>
  rootBlock: Scalars['String']
}

export type SlateInput = {
  blocks: Array<BlockInput>
  rootBlock: Scalars['String']
}

export type SlateRestrictions = {
  lockedChildrenBlocks?: Maybe<Array<Scalars['String']>>
  nonEditableBlocks?: Maybe<Array<Scalars['String']>>
  nonRemovableBlocks?: Maybe<Array<Scalars['String']>>
}

export type SlateUpdatesInput = {
  addedBlocks?: InputMaybe<Array<BlockInput>>
  removedBlocks?: InputMaybe<Array<Scalars['String']>>
  rootBlock?: InputMaybe<Scalars['String']>
  updatedBlocks?: InputMaybe<Array<UpdateBlockInput>>
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type Space = {
  address: SpaceAddress
  authMemberProps?: Maybe<SpaceAuthMemberProps>
  banner?: Maybe<Media>
  bannerId?: Maybe<Scalars['ID']>
  collection?: Maybe<Collection>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<Member>
  createdById: Scalars['ID']
  customOrderingIndexInGroup: Scalars['Float']
  customSeoDetail?: Maybe<CustomSeoDetail>
  description?: Maybe<Scalars['String']>
  externalId?: Maybe<Scalars['ID']>
  externalUrl?: Maybe<Scalars['String']>
  groupId?: Maybe<Scalars['ID']>
  hidden?: Maybe<Scalars['Boolean']>
  highlightedTagIds: Array<Scalars['ID']>
  highlightedTags?: Maybe<Array<Tag>>
  id: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  /** @deprecated We no longer support app installation on space */
  installedApps?: Maybe<PaginatedAppInstallation>
  inviteOnly?: Maybe<Scalars['Boolean']>
  isHomepage?: Maybe<Scalars['Boolean']>
  isNewUserHomepage?: Maybe<Scalars['Boolean']>
  isReturningUserHomepage?: Maybe<Scalars['Boolean']>
  key: Scalars['String']
  layout: Scalars['String']
  members?: Maybe<PaginatedSpaceMember>
  membersCount: Scalars['Int']
  name: Scalars['String']
  network?: Maybe<Network>
  networkId: Scalars['ID']
  nonAdminsCanInvite?: Maybe<Scalars['Boolean']>
  pinnedPosts?: Maybe<Array<Post>>
  posts?: Maybe<PaginatedPost>
  postsCount?: Maybe<Scalars['Int']>
  private?: Maybe<Scalars['Boolean']>
  relativeUrl?: Maybe<Scalars['String']>
  roles?: Maybe<Array<SpaceRole>>
  seoDetail?: Maybe<SpaceSeoDetail>
  shortcuts?: Maybe<Array<Shortcut>>
  slate?: Maybe<Slate>
  slug: Scalars['String']
  subscribersCount?: Maybe<Scalars['Int']>
  /** @deprecated Space tag filters is a retired concept and is no longer used. */
  tagFilter?: Maybe<TagFilter>
  /** @deprecated This field is deprecated. Use `tags` query instead. */
  tags?: Maybe<PaginatedTag>
  type: SpaceType
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
  /** @deprecated This field is deprecated and will be removed in the next major version. */
  whoCanPost?: Maybe<Array<Scalars['ID']>>
  /** @deprecated This field is deprecated and will be removed in the next major version. */
  whoCanReact?: Maybe<Array<Scalars['ID']>>
  /** @deprecated This field is deprecated and will be removed in the next major version. */
  whoCanReply?: Maybe<Array<Scalars['ID']>>
}

export type SpaceInstalledAppsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<AppInstallationStatus>
}

export type SpaceMembersArgs = {
  limit: Scalars['Int']
}

export type SpacePostsArgs = {
  excludePins?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
}

export type SpaceTagsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<TagListOrderByEnum>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type SpaceAddress = {
  editable: Scalars['Boolean']
  exact: Scalars['Boolean']
  path: Scalars['String']
}

export type SpaceAddressInput = {
  editable?: InputMaybe<Scalars['Boolean']>
  exact: Scalars['Boolean']
  path: Scalars['String']
}

export type SpaceAuthMemberProps = {
  availableContentModules?: Maybe<Array<ContentModuleType>>
  availablePostTypes?: Maybe<Array<PostType>>
  context: PermissionContext
  lastReadAt?: Maybe<Scalars['DateTime']>
  membershipStatus?: Maybe<SpaceMembershipStatus>
  permissions?: Maybe<Array<ActionPermissions>>
  scopes?: Maybe<Array<Scalars['String']>>
  spaceMember?: Maybe<SpaceMember>
  subscribed?: Maybe<Scalars['Boolean']>
  unreadPostsCount?: Maybe<Scalars['Int']>
}

export type SpaceContentModule = {
  contentModuleType: ContentModuleType
  space?: Maybe<Space>
  spaceId: Scalars['ID']
  whoCanCreate?: Maybe<Array<Scalars['String']>>
}

export type SpaceContentModuleEdge = {
  cursor: Scalars['String']
  node: SpaceContentModule
}

export type SpaceEdge = {
  cursor: Scalars['String']
  node: Space
}

export type SpaceJoinRequest = {
  id: Scalars['ID']
  member?: Maybe<Member>
  spaceId: Scalars['ID']
  status: SpaceJoinRequestStatus
}

export type SpaceJoinRequestEdge = {
  cursor: Scalars['String']
  node: SpaceJoinRequest
}

export enum SpaceJoinRequestStatus {
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
}

export enum SpaceListOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  CUSTOM_ORDERING_INDEX = 'CUSTOM_ORDERING_INDEX',
  UPDATED_AT = 'UPDATED_AT',
}

export type SpaceMember = {
  member?: Maybe<Member>
  role?: Maybe<SpaceRole>
  space?: Maybe<Space>
}

export enum SpaceMemberAffiliation {
  Joined = 'Joined',
  NotJoined = 'NotJoined',
  RequestedToJoin = 'RequestedToJoin',
  UnableToJoin = 'UnableToJoin',
}

export type SpaceMemberEdge = {
  cursor: Scalars['String']
  node: SpaceMember
}

export enum SpaceMemberListOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT',
}

export enum SpaceMembershipStatus {
  Archived = 'Archived',
  Closed = 'Closed',
  joined = 'joined',
  notJoined = 'notJoined',
  requested = 'requested',
}

export type SpacePostType = {
  postType?: Maybe<PostType>
  postTypeId: Scalars['ID']
  space?: Maybe<Space>
  spaceId: Scalars['ID']
  whoCanPost?: Maybe<Array<Scalars['ID']>>
  whoCanReact?: Maybe<Array<Scalars['ID']>>
  whoCanReply?: Maybe<Array<Scalars['ID']>>
}

export type SpacePostTypeEdge = {
  cursor: Scalars['String']
  node: SpacePostType
}

export type SpaceRole = {
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  network?: Maybe<Network>
  scopes: Array<Scalars['String']>
  type?: Maybe<SpaceRoleType>
}

export enum SpaceRoleListOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT',
}

export enum SpaceRoleType {
  admin = 'admin',
  member = 'member',
}

export type SpaceSeoDetail = {
  description?: Maybe<Scalars['String']>
  image?: Maybe<Media>
  title: Scalars['String']
}

export type SpaceSeoDetailInput = {
  description?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  title: Scalars['String']
}

export enum SpaceType {
  Broadcast = 'Broadcast',
  Entity = 'Entity',
  Group = 'Group',
  Page = 'Page',
  PrivateMessage = 'PrivateMessage',
}

export type Sso = {
  allowSignUp?: Maybe<Scalars['Boolean']>
  authorizationUrl?: Maybe<Scalars['String']>
  buttonText?: Maybe<Scalars['String']>
  clientId?: Maybe<Scalars['String']>
  clientSecret?: Maybe<Scalars['String']>
  defaultRelayState?: Maybe<Scalars['String']>
  idpUrl?: Maybe<Scalars['String']>
  logoutUrl?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  profileSyncTtlSeconds?: Maybe<Scalars['Int']>
  provider?: Maybe<SsoProvider>
  scopes?: Maybe<Array<Scalars['String']>>
  settingsUrl?: Maybe<Scalars['String']>
  signUpUrl?: Maybe<Scalars['String']>
  status: SsoStatus
  tokenUrl?: Maybe<Scalars['String']>
  type: SsoType
  userProfileUrl?: Maybe<Scalars['String']>
}

export type SsoMembership = {
  id: Scalars['String']
  memberId: Scalars['String']
  ssoType: SsoType
}

export enum SsoProvider {
  auth0 = 'auth0',
  custom = 'custom',
  memberful = 'memberful',
  okta = 'okta',
  outseta = 'outseta',
  wordpress = 'wordpress',
}

export enum SsoStatus {
  disable = 'disable',
  enable = 'enable',
}

export enum SsoType {
  Apple = 'Apple',
  Discord = 'Discord',
  Saml = 'Saml',
  Slack = 'Slack',
  facebook = 'facebook',
  google = 'google',
  jwt = 'jwt',
  linkedin = 'linkedin',
  oauth2 = 'oauth2',
}

export type SsoUrl = {
  url: Scalars['String']
}

export type SsoUrlInput = {
  callbackUrl?: InputMaybe<Scalars['String']>
  invitationLinkId?: InputMaybe<Scalars['String']>
  invitationToken?: InputMaybe<Scalars['String']>
  redirectUri?: InputMaybe<Scalars['String']>
  type: SsoType
}

export enum StaffReason {
  NetworkStaffRole = 'NetworkStaffRole',
  SamlSso = 'SamlSso',
  SpaceStaffRole = 'SpaceStaffRole',
}

export type StaticMapInput = {
  /** The height of the image in pixels */
  height?: InputMaybe<Scalars['Int']>
  /** The location coordinates */
  location?: InputMaybe<LocationCoordinatesInput>
  /** The place ID of the location */
  placeId?: InputMaybe<Scalars['String']>
  /** The scale value for higher resolution displays */
  scale?: InputMaybe<Scalars['Int']>
  /** The width of the image in pixels */
  width?: InputMaybe<Scalars['Int']>
  /** The zoom level (0-21) */
  zoom?: InputMaybe<Scalars['Int']>
}

/** The URLs of the maps for a location. */
export type StaticMaps = {
  /** The URL of the dark map for the location. */
  darkUrl?: Maybe<Scalars['String']>
  /** The URL of the light map for the location. */
  lightUrl?: Maybe<Scalars['String']>
}

export type StatusReason = {
  changedAt: Scalars['DateTime']
  changedBy: NetworkStatusChangedBy
  changedById?: Maybe<Scalars['String']>
  reason?: Maybe<NetworkStatusReason>
}

export enum StoreItemStanding {
  OFFICIAL = 'OFFICIAL',
  REGULAR = 'REGULAR',
  VERIFIED = 'VERIFIED',
}

export enum StoreItemStatus {
  DELETED = 'DELETED',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export type StringValue = {
  string: Scalars['String']
}

export type Subscriber = {
  emailDigestEnabled: Scalars['Boolean']
  emailDigestSendFrequency: EmailDigestFrequency
  emailDigestWeeklySendDay: DayOfWeek
  /** @deprecated Use instantEmailTriggers instead. */
  emailSubscriptionEnabled?: Maybe<Scalars['Boolean']>
  fcmDeviceTokens: Array<Scalars['String']>
  id: Scalars['ID']
  /** Array of instant email triggers that the subscriber will receive. Similar to notification triggers, these can include various events that prompt an immediate email. If this array is empty, the subscriber will not receive any instant emails. */
  instantEmailTriggers: Array<NotificationTrigger>
  /** @deprecated Use instantEmailTriggers instead. */
  mentionEmailEnabled?: Maybe<Scalars['Boolean']>
  /** @deprecated Use notificationTriggers instead. */
  mentionSubscriptionEnabled?: Maybe<Scalars['Boolean']>
  /** @deprecated Use instantEmailTriggers instead. */
  messageEmailEnabled?: Maybe<Scalars['Boolean']>
  networkId: Scalars['String']
  /** Array of notification triggers that the subscriber will receive. If this array is empty, the subscriber will not receive any notifications. */
  notificationTriggers: Array<NotificationTrigger>
  /** @deprecated Use instantEmailTriggers instead. */
  reactionEmailEnabled?: Maybe<Scalars['Boolean']>
  /** @deprecated Use notificationTriggers instead. */
  reactionSubscriptionEnabled?: Maybe<Scalars['Boolean']>
}

export type SubscriberEdge = {
  cursor: Scalars['String']
  node: Subscriber
}

export type Subscription = {
  ask: Scalars['String']
  network: Network
  post: Post
  space: Space
}

export type SubscriptionAskArgs = {
  maxTokens?: InputMaybe<Scalars['Int']>
  question: Scalars['String']
  searchConfig?: InputMaybe<SearchConfigInput>
  temperature?: InputMaybe<Scalars['Float']>
  topP?: InputMaybe<Scalars['Float']>
}

export type SubscriptionCheckoutSession = {
  url: Scalars['String']
}

export type SubscriptionInformation = {
  addons?: Maybe<Array<AddonInformation>>
  currentProduct?: Maybe<BillingProduct>
  isManual: Scalars['Boolean']
  planId?: Maybe<Scalars['String']>
  planName?: Maybe<Scalars['String']>
  planPriceId?: Maybe<Scalars['String']>
  planPriceInterval?: Maybe<BillingPriceInterval>
}

export type SupportAuthToken = {
  accessToken: Scalars['String']
  refreshToken: Scalars['String']
}

export type SupportLimitedAuthToken = {
  accessToken: Scalars['String']
  member: Member
}

export type SupportSsoUrl = {
  url: Scalars['String']
}

export type SupportSsoUrlInput = {
  callbackUrl?: InputMaybe<Scalars['String']>
}

export type Tag = {
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  slug: Scalars['String']
  /** @deprecated Tags are network-level objects. spaceId is no longer required to identify them. */
  spaceId?: Maybe<Scalars['String']>
  title: Scalars['String']
}

export type TagEdge = {
  cursor: Scalars['String']
  node: Tag
}

export type TagFilter = {
  filterType: TagFilterType
  filters: Array<Scalars['String']>
}

export enum TagFilterType {
  BLACKLIST = 'BLACKLIST',
  WHITELIST = 'WHITELIST',
}

export enum TagListOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
  UPDATED_AT = 'UPDATED_AT',
}

export enum TagsOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
  UPDATED_AT = 'UPDATED_AT',
}

export type Template = {
  about?: Maybe<Scalars['String']>
  appIds: Array<Scalars['String']>
  apps?: Maybe<Array<App>>
  authorName?: Maybe<Scalars['String']>
  authorUrl?: Maybe<Scalars['String']>
  banner?: Maybe<Media>
  bannerId?: Maybe<Scalars['ID']>
  categories: Array<Scalars['String']>
  comingSoon: Scalars['Boolean']
  contentTypes?: Maybe<Array<ContentTypeTemplate>>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<Member>
  createdById?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  embedIds: Array<Scalars['ID']>
  embeds?: Maybe<Array<Embed>>
  entity?: Maybe<TemplateEntity>
  entityId?: Maybe<Scalars['String']>
  entityProperties: Scalars['String']
  entityType: TemplateEntityType
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  hubContent?: Maybe<HubContent>
  hubContentId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  imageIds: Array<Scalars['ID']>
  images?: Maybe<Array<Media>>
  installed?: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  network?: Maybe<Network>
  networkId: Scalars['ID']
  onFreePlan?: Maybe<Scalars['Boolean']>
  previewHtml?: Maybe<Scalars['String']>
  privacyPolicyUrl?: Maybe<Scalars['String']>
  requiredTemplateIds: Array<Scalars['String']>
  /** @deprecated Use contentTypes instead */
  requiredTemplates?: Maybe<Array<Template>>
  slate?: Maybe<Slate>
  slug: Scalars['String']
  standing: StoreItemStanding
  status: StoreItemStatus
  syncedAt?: Maybe<Scalars['DateTime']>
  termsOfServiceUrl?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  updatedBy?: Maybe<Member>
  updatedById?: Maybe<Scalars['ID']>
}

export type TemplateCreatedEntity = Space

export type TemplateEdge = {
  cursor: Scalars['String']
  node: Template
}

export type TemplateEntity =
  | Network
  | Post
  | PostType
  | Space
  | SpacePostType
  | Tag

export enum TemplateEntityType {
  Collection = 'Collection',
  Network = 'Network',
  Post = 'Post',
  PostType = 'PostType',
  Space = 'Space',
  SpaceContentModule = 'SpaceContentModule',
  SpacePostType = 'SpacePostType',
  Tag = 'Tag',
}

export type TemplateFieldMapping = {
  from: Scalars['String']
  to: Scalars['String']
}

export type TemplateFieldMappingInput = {
  from: Scalars['String']
  to: Scalars['String']
}

export type TemplateRequest = {
  createdAt: Scalars['DateTime']
  createdById: Scalars['String']
  createdEntity?: Maybe<TemplateCreatedEntity>
  createdEntityAt?: Maybe<Scalars['DateTime']>
  createdEntityId?: Maybe<Scalars['String']>
  createdEntityType: TemplateEntityType
  id: Scalars['String']
  networkId?: Maybe<Scalars['String']>
  processedPercentage: Scalars['Float']
  status: TemplateRequestStatus
  templateId: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export enum TemplateRequestStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Succeeded = 'Succeeded',
}

export type TemplatesMapping = {
  fields?: Maybe<Array<TemplateFieldMapping>>
  from?: Maybe<Scalars['String']>
  to?: Maybe<Scalars['String']>
}

export type TemplatesMappingInput = {
  fields?: InputMaybe<Array<TemplateFieldMappingInput>>
  from: Scalars['String']
  to: Scalars['String']
}

export type TestAppWebhookInput = {
  webhookUrl: Scalars['String']
}

export enum TextTypeOptions {
  fullText = 'fullText',
  shortText = 'shortText',
}

export type Theme = {
  name: Scalars['String']
  status: ThemeStatus
  tokens: ThemeTokens
}

export type ThemeColor = {
  key: Scalars['String']
  weights: Array<ThemeToken>
}

export type ThemeColorToken = {
  key: Scalars['String']
  value: Scalars['String']
}

export type ThemeColorTokens = {
  dark?: Maybe<Array<ThemeColorToken>>
  light?: Maybe<Array<ThemeColorToken>>
}

export type ThemeColors = {
  dark?: Maybe<Array<ThemeColor>>
  light?: Maybe<Array<ThemeColor>>
}

export enum ThemeStatus {
  draft = 'draft',
  published = 'published',
}

export type ThemeToken = {
  key: Scalars['String']
  value: Scalars['String']
}

export type ThemeTokens = {
  breakpoints?: Maybe<Array<ThemeToken>>
  colors?: Maybe<Array<ThemeToken>>
  fontSizes?: Maybe<Array<ThemeToken>>
  fontWeights?: Maybe<Array<ThemeToken>>
  opacity?: Maybe<Array<ThemeToken>>
  shadows?: Maybe<Array<ThemeToken>>
  sizes?: Maybe<Array<ThemeToken>>
  textStyles?: Maybe<Array<ThemeToken>>
  zIndices?: Maybe<Array<ThemeToken>>
}

export type Themes = {
  active: Theme
  drafts?: Maybe<Array<Theme>>
  published: Array<Theme>
}

export type Toast = {
  description?: Maybe<Scalars['String']>
  duration?: Maybe<Scalars['Float']>
  status?: Maybe<ToastStatus>
  title?: Maybe<Scalars['String']>
}

export enum ToastStatus {
  Error = 'Error',
  Info = 'Info',
  Neutral = 'Neutral',
  Success = 'Success',
  Warning = 'Warning',
}

export type TopNavigation = {
  alignment: TopNavigationAlignment
  enabled: Scalars['Boolean']
  items: Array<NavigationItem>
}

export enum TopNavigationAlignment {
  CENTER = 'CENTER',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export type TransferGroupChatOwnershipInput = {
  /** The member id of the new owner. */
  newOwnerId: Scalars['String']
  /** Whether to keep the old owner as an admin. Defaults to true. */
  stayAdmin?: InputMaybe<Scalars['Boolean']>
}

export type TransferNetworkOwnershipInput = {
  newOwnerId: Scalars['String']
}

export type TransferredOwnershipMetadata = {
  newOwner: ChatParticipant
  type: ChatLogType
}

export enum TranslationMarkupFormat {
  HTML = 'HTML',
  TEXT = 'TEXT',
}

export type TranslationMarkupInput = {
  format: TranslationMarkupFormat
  markup: Scalars['String']
}

export enum UnauthorizedReason {
  ACCESS = 'ACCESS',
  PLAN = 'PLAN',
}

export type UnreadChatsCount = {
  /** The ID of the member requested the counts */
  memberId: Scalars['String']
  /** The IDs of the chats which the member has received new messages in. */
  unreadChatIds: Array<Scalars['String']>
  /** The number of chats which the member has received new messages in. */
  unreadChatsCount: Scalars['Int']
}

export type UnreadMessageCountsPerChat = {
  counts: Array<UnreadMessagesCount>
}

export type UnreadMessagesCount = {
  /** The ID of the chat */
  chatId: Scalars['String']
  /** Number of unread message in the chat for current user */
  count: Scalars['Int']
  /** List of unread mentions in the chat for current user */
  unreadMentions: Array<MessageAddress>
}

export enum UnsubscribeTokenContext {
  ALL = 'ALL',
  MEMBER = 'MEMBER',
  MENTIONS = 'MENTIONS',
  POST = 'POST',
  REACTIONS = 'REACTIONS',
  SPACE = 'SPACE',
}

export type UnsubscribeWithTokenInput = {
  context: UnsubscribeTokenContext
  entityId?: InputMaybe<Scalars['String']>
  token: Scalars['String']
}

export type UpdateAccessGroupInput = {
  description?: InputMaybe<Scalars['String']>
  entityId?: InputMaybe<Scalars['ID']>
  entityType?: InputMaybe<AccessGroupEntityType>
  info?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}

export type UpdateAppCustomCodes = {
  body?: InputMaybe<Scalars['String']>
  head?: InputMaybe<Scalars['String']>
}

export type UpdateAppInput = {
  about?: InputMaybe<Scalars['String']>
  authorName?: InputMaybe<Scalars['String']>
  authorUrl?: InputMaybe<Scalars['String']>
  bannerId?: InputMaybe<Scalars['String']>
  comingSoon?: InputMaybe<Scalars['Boolean']>
  customCodes?: InputMaybe<UpdateAppCustomCodes>
  description?: InputMaybe<Scalars['String']>
  docsUrl?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  onFreePlan?: InputMaybe<Scalars['Boolean']>
  privacyPolicyUrl?: InputMaybe<Scalars['String']>
  requiredPermissions?: InputMaybe<Array<PrimaryScopes>>
  slug?: InputMaybe<Scalars['String']>
  termsOfServiceUrl?: InputMaybe<Scalars['String']>
  webhookSubscriptions?: InputMaybe<Array<Scalars['String']>>
  webhookUrl?: InputMaybe<Scalars['String']>
}

export type UpdateAppInstallationInput = {
  permissions?: InputMaybe<Array<PrimaryScopes>>
  templatesMappings?: InputMaybe<AppInstallationTemplatesMappingsInput>
}

/** Update the available search sources. posts are always enabled. */
export type UpdateAvailableSearchSourcesInput = {
  /** Setting to false disables searching on members. */
  members: Scalars['Boolean']
  /** Setting to false disables searching on spaces. */
  spaces: Scalars['Boolean']
}

export type UpdateBadgeInput = {
  active: Scalars['Boolean']
  backgroundColor?: InputMaybe<Scalars['String']>
  daysUntilExpired?: InputMaybe<Scalars['Float']>
  imageId?: InputMaybe<Scalars['ID']>
  longDescription?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  settings?: InputMaybe<Array<BadgeSettingsInput>>
  shortDescription: Scalars['String']
  text?: InputMaybe<Scalars['String']>
  textColor?: InputMaybe<Scalars['String']>
}

export type UpdateBlockInput = {
  children?: InputMaybe<Scalars['String']>
  extraProps?: InputMaybe<Scalars['String']>
  id: Scalars['String']
  output?: InputMaybe<Scalars['String']>
  props?: InputMaybe<Scalars['String']>
}

export type UpdateCollectionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>
  description?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['DateTime']>
}

export type UpdateCustomFieldSchemaInput = {
  default?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  externalKeys?: InputMaybe<Array<Scalars['String']>>
  items?: InputMaybe<BaseCustomFieldSchemaInput>
  key: Scalars['String']
  name?: InputMaybe<Scalars['String']>
  properties?: InputMaybe<Array<BaseCustomFieldSchemaInput>>
  readPrivacy?: InputMaybe<CustomFieldPrivacyInput>
  required?: InputMaybe<Scalars['Boolean']>
  settings?: InputMaybe<Array<CustomFieldSettingsInput>>
  validators?: InputMaybe<Array<CustomFieldValidatorInput>>
  writePrivacy?: InputMaybe<CustomFieldPrivacyInput>
}

export type UpdateCustomSsoInput = {
  allowSignUp?: InputMaybe<Scalars['Boolean']>
  authorizationUrl?: InputMaybe<Scalars['String']>
  buttonText?: InputMaybe<Scalars['String']>
  clientId?: InputMaybe<Scalars['String']>
  clientSecret?: InputMaybe<Scalars['String']>
  idpUrl?: InputMaybe<Scalars['String']>
  logoutUrl?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  profileSyncTtlSeconds?: InputMaybe<Scalars['Int']>
  provider?: InputMaybe<SsoProvider>
  scopes?: InputMaybe<Array<Scalars['String']>>
  settingsUrl?: InputMaybe<Scalars['String']>
  status?: InputMaybe<SsoStatus>
  tokenUrl?: InputMaybe<Scalars['String']>
  type: CustomSsoType
  userProfileUrl?: InputMaybe<Scalars['String']>
}

/** Input for updating an existing event. */
export type UpdateEventInput = {
  /** IDs of files to attach to the event. */
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  /** The maximum number of attendees allowed for the event. */
  capacity?: InputMaybe<Scalars['Int']>
  /** The main content/description of the event. */
  content?: InputMaybe<Scalars['String']>
  /** Custom SEO details for the event. */
  customSeoDetail?: InputMaybe<CustomSeoDetailInput>
  /** The end date and time of the event. */
  endTime?: InputMaybe<Scalars['DateTime']>
  /** IDs of members who will be hosts of the event. */
  hostIds?: InputMaybe<Array<Scalars['String']>>
  /** Notification settings for the event. */
  notificationSettings?: InputMaybe<EventNotificationSettingsInput>
  /** Physical locations where the event takes place. */
  physicalLocations?: InputMaybe<Array<CreatePhysicalLocationInput>>
  /** IDs of polls to associate with the event. */
  pollIds?: InputMaybe<Array<Scalars['String']>>
  /** The recurrence configuration for the event. */
  recurrenceConfig?: InputMaybe<EventRecurrenceConfigInput>
  /** The mode to update the event recurrence. */
  recurringEventUpdateMode?: InputMaybe<RecurringEventUpdateMode>
  /** The URL slug for the event. If not provided, it will be generated from the title. */
  slug?: InputMaybe<Scalars['String']>
  /** The start date and time of the event. */
  startTime?: InputMaybe<Scalars['DateTime']>
  /** IDs of tags to associate with the event. */
  tagIds?: InputMaybe<Array<Scalars['String']>>
  /** The ID of the thumbnail image for the event. */
  thumbnailId?: InputMaybe<Scalars['String']>
  /** The IANA timezone for the event times (e.g., "America/New_York", "UTC"). */
  timeZone?: InputMaybe<Scalars['String']>
  /** The title of the event. */
  title?: InputMaybe<Scalars['String']>
  /** Virtual locations where the event takes place online. */
  virtualLocations?: InputMaybe<Array<CreateVirtualLocationInput>>
}

export type UpdateFileInput = {
  name?: InputMaybe<Scalars['String']>
}

export type UpdateFooter = {
  urls: Array<UpdateFooterUrl>
}

export type UpdateFooterUrl = {
  title: Scalars['String']
  url: Scalars['String']
}

export type UpdateGroupChatInput = {
  /** Image id of the group avatar */
  avatarId?: InputMaybe<Scalars['String']>
  /** The new name of the group chat */
  name?: InputMaybe<Scalars['String']>
}

export type UpdateHighlightedTags = {
  highlightedTags: Array<CreateHighlightedTag>
}

export type UpdateImageInput = {
  cropHeight?: InputMaybe<Scalars['Int']>
  cropWidth?: InputMaybe<Scalars['Int']>
  cropX?: InputMaybe<Scalars['Int']>
  cropY?: InputMaybe<Scalars['Int']>
  cropZoom?: InputMaybe<Scalars['Float']>
  name?: InputMaybe<Scalars['String']>
}

export type UpdateJwtSsoInput = {
  authorizationUrl?: InputMaybe<Scalars['String']>
  buttonText?: InputMaybe<Scalars['String']>
  logoutUrl?: InputMaybe<Scalars['String']>
  settingsUrl?: InputMaybe<Scalars['String']>
  signUpUrl?: InputMaybe<Scalars['String']>
  status: SsoStatus
}

export type UpdateMediaNetworkSettingsInput = {
  alternateUploadDestination?: InputMaybe<Scalars['String']>
  fileSizeLimit?: InputMaybe<Scalars['Float']>
  fileTypesLimit?: InputMaybe<Array<Scalars['String']>>
  imageSizeLimit?: InputMaybe<Scalars['Float']>
  imageTypesLimit?: InputMaybe<Array<Scalars['String']>>
}

export type UpdateMemberAttributesInput = {
  locale?: InputMaybe<Scalars['String']>
}

export type UpdateMemberInput = {
  attributes?: InputMaybe<UpdateMemberAttributesInput>
  bannerId?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  currentPassword?: InputMaybe<Scalars['String']>
  displayName?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  externalId?: InputMaybe<Scalars['String']>
  externalUrl?: InputMaybe<Scalars['String']>
  fields?: InputMaybe<Array<CustomFieldInput>>
  flagged?: InputMaybe<Scalars['Boolean']>
  locale?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  newPassword?: InputMaybe<Scalars['String']>
  profilePictureId?: InputMaybe<Scalars['String']>
  roleId?: InputMaybe<Scalars['ID']>
  settings?: InputMaybe<MemberSettingsInput>
  tagline?: InputMaybe<Scalars['String']>
  timeZone?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['DateTime']>
  username?: InputMaybe<Scalars['String']>
}

export type UpdateMemberInvitationInput = {
  roleId: Scalars['ID']
}

export type UpdateModerationItemInput = {
  changeStatusReason?: InputMaybe<Scalars['String']>
  /** Operation mode when accepting a moderation report. Effects vary based on reported entity type (e.g. post removal, member suspension, etc.). */
  opMode?: InputMaybe<ModerationOpMode>
  sendNotification?: InputMaybe<Scalars['Boolean']>
  status: ModerationStatus
}

export type UpdateModerationSettingsInput = {
  akismet?: InputMaybe<Scalars['Boolean']>
  blackListPostTypeIds?: InputMaybe<Array<Scalars['String']>>
  blackListSpaceIds?: InputMaybe<Array<Scalars['String']>>
  customBlacklist?: InputMaybe<Array<Scalars['String']>>
  enableBlacklisting?: InputMaybe<Scalars['Boolean']>
  member?: InputMaybe<ModerationMemberSettingsInput>
  oopSpam?: InputMaybe<Scalars['Boolean']>
  preventPublish?: InputMaybe<Scalars['Boolean']>
  useDefaultBlacklisting?: InputMaybe<Scalars['Boolean']>
}

export type UpdateNavigationItem = {
  link?: InputMaybe<Scalars['String']>
  openInNewWindow?: InputMaybe<Scalars['Boolean']>
  text: Scalars['String']
  type: NavigationItemType
}

export type UpdateNetworkInput = {
  aliases?: InputMaybe<Array<Scalars['String']>>
  billingEmail?: InputMaybe<Scalars['String']>
  brandColor?: InputMaybe<Scalars['String']>
  companyName?: InputMaybe<Scalars['String']>
  customSeoDetail?: InputMaybe<CustomSeoDetailInput>
  defaultSpaceIds?: InputMaybe<Array<Scalars['ID']>>
  description?: InputMaybe<Scalars['String']>
  domain?: InputMaybe<Scalars['String']>
  entrancePage?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['String']>
  footer?: InputMaybe<UpdateFooter>
  gclid?: InputMaybe<Scalars['String']>
  hideDefaultAuthenticationForm?: InputMaybe<Scalars['Boolean']>
  imageIds?: InputMaybe<NetworkImagesInput>
  incidentEmails?: InputMaybe<Array<Scalars['String']>>
  industry?: InputMaybe<NetworkIndustryType>
  landingPages?: InputMaybe<UpdateNetworkSettingsInput>
  locale?: InputMaybe<Scalars['String']>
  logoId?: InputMaybe<Scalars['String']>
  membership?: InputMaybe<NetworkMembership>
  name?: InputMaybe<Scalars['String']>
  navigationSlates?: InputMaybe<NavigationSlateUpdatesInput>
  newDomain?: InputMaybe<Scalars['String']>
  passwordComplexity?: InputMaybe<NetworkPasswordComplexity>
  primaryMembers?: InputMaybe<NetworkPrimaryMembersType>
  privacyPolicyUrl?: InputMaybe<Scalars['String']>
  referralLink?: InputMaybe<Scalars['String']>
  referralProgramEnabled?: InputMaybe<Scalars['Boolean']>
  referrer?: InputMaybe<Scalars['String']>
  releaseChannel?: InputMaybe<NetworkReleaseChannelType>
  settings?: InputMaybe<NetworkSettingsInput>
  termsOfServiceUrl?: InputMaybe<Scalars['String']>
  themes?: InputMaybe<UpdateThemes>
  timeframe?: InputMaybe<NetworkTimeframeType>
  topNavigation?: InputMaybe<UpdateTopNavigation>
  tribeBranding?: InputMaybe<Scalars['Boolean']>
  utmCampaign?: InputMaybe<Scalars['String']>
  utmContent?: InputMaybe<Scalars['String']>
  utmMedium?: InputMaybe<Scalars['String']>
  utmSource?: InputMaybe<Scalars['String']>
  utmTerm?: InputMaybe<Scalars['String']>
  visibility?: InputMaybe<NetworkVisibility>
  whoCanInviteIds?: InputMaybe<Array<Scalars['String']>>
}

export type UpdateNetworkSettingsInput = {
  landingPageForGuest?: InputMaybe<NetworkLandingPage>
  landingPageForMember?: InputMaybe<NetworkLandingPage>
  landingPageForNewMember?: InputMaybe<NetworkLandingPage>
}

export type UpdateNetworkStatusInput = {
  status: NetworkStatus
  statusLocked?: InputMaybe<Scalars['Boolean']>
}

export type UpdateNewDomainInput = {
  domain: Scalars['String']
}

export type UpdateNotificationNetworkSettingsInput = {
  emailDigestEnabled?: InputMaybe<Scalars['Boolean']>
  emailDigestLayoutId?: InputMaybe<Scalars['String']>
  emailDigestRecentPostsFilter?: InputMaybe<EmailDigestRecentPostsFilterInput>
  emailEnabled?: InputMaybe<Scalars['Boolean']>
  emailFrom?: InputMaybe<Scalars['String']>
  emailNotificationEnabled?: InputMaybe<Scalars['Boolean']>
}

export type UpdateOidcInput = {
  /** The URL to the JWKS endpoint (jwks_uri). Takes precedence over JWT secret if provided. */
  jwksUri?: InputMaybe<Scalars['String']>
  /** The secret used to sign the JWT. If jwksUri is provided, this will be ignored. */
  jwtSecret?: InputMaybe<Scalars['String']>
  validIssuers?: InputMaybe<Array<Scalars['String']>>
}

export type UpdatePasswordWithTokenInput = {
  newPassword: Scalars['String']
  token: Scalars['String']
}

export type UpdatePermissionInput = {
  description?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  scopes?: InputMaybe<Array<Scalars['String']>>
}

export type UpdatePollInput = {
  /** The time when the poll closes for voting. Set to null to remove close date. */
  closesAt?: InputMaybe<Scalars['DateTime']>
  /** The number of votes each participant can cast. */
  maxSelections?: InputMaybe<Scalars['Int']>
  /** The time when the poll opens for voting. */
  opensAt?: InputMaybe<Scalars['DateTime']>
  options?: InputMaybe<Array<PollOptionInput>>
  title?: InputMaybe<Scalars['String']>
}

export type UpdatePostInput = {
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  createdAt?: InputMaybe<Scalars['DateTime']>
  /** The custom seo detail of this post */
  customSeoDetail?: InputMaybe<CustomSeoDetailInput>
  externalId?: InputMaybe<Scalars['String']>
  externalUrl?: InputMaybe<Scalars['String']>
  /** Whether the post is locked */
  locked?: InputMaybe<Scalars['Boolean']>
  mappingFields?: InputMaybe<Array<PostMappingFieldInput>>
  ownerId?: InputMaybe<Scalars['ID']>
  /** The id of all the polls associated with this post. */
  pollIds?: InputMaybe<Array<Scalars['String']>>
  /**
   * This will publish the post immediately. If false, the post will stay a draft. Will not unpublish an already published post.
   *       This is only usable by admins and moderators.
   */
  publish?: Scalars['Boolean']
  publishedAt?: InputMaybe<Scalars['DateTime']>
  /**
   * This will schedule the post to be published at the given date and time. This only applies to posts in draft status.
   *       This is only usable by admins and moderators.
   */
  scheduledFor?: InputMaybe<Scalars['DateTime']>
  seoDetail?: InputMaybe<UpdatePostSeoDetailInput>
  /** The slug of the post creating the human readable part of its URL */
  slug?: InputMaybe<Scalars['String']>
  tagNames?: InputMaybe<Array<Scalars['String']>>
  updatedAt?: InputMaybe<Scalars['DateTime']>
}

export type UpdatePostSeoDetailInput = {
  description?: InputMaybe<Scalars['String']>
  image?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type UpdatePostTypeInput = {
  allowedReactions?: InputMaybe<Array<Scalars['String']>>
  customReactions?: InputMaybe<Array<CustomReactionInput>>
  description?: InputMaybe<Scalars['String']>
  excludedNativeShortcuts?: InputMaybe<Array<Scalars['String']>>
  forbiddenReactions?: InputMaybe<Array<Scalars['String']>>
  iconId?: InputMaybe<Scalars['ID']>
  languageTemplate?: InputMaybe<Scalars['String']>
  layout?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  nativeFieldsTemplates?: InputMaybe<NativeFieldsTemplatesInput>
  pluralName?: InputMaybe<Scalars['String']>
  postFields?: InputMaybe<CustomFieldsSchemaInput>
  primaryReactionType?: InputMaybe<ReactionType>
  recommendationsSettings?: InputMaybe<PostTypeRecommendationSettingsInput>
  selfRepliable?: InputMaybe<Scalars['Boolean']>
  shortContentTemplate?: InputMaybe<Scalars['String']>
  singleChoiceReactions?: InputMaybe<Array<Scalars['String']>>
  slate?: InputMaybe<SlateUpdatesInput>
  titleTemplate?: InputMaybe<Scalars['String']>
  validReplyTypesIds?: InputMaybe<Array<Scalars['String']>>
}

/** Input type for updating a publisher settings */
export type UpdatePublisherInput = {
  /** By enabling this, all implicit subscriptions will receive notifications from this publisher. If members subscribe/unsubscribe explicitly, they will receive/silent notifications regardless of this setting. */
  notifyImplicitSubscriptions: Scalars['Boolean']
}

export type UpdateSearchNetworkSettingsInput = {
  askAiAvailability?: InputMaybe<AskAiAvailability>
  askAiEnabled?: InputMaybe<Scalars['Boolean']>
  availableSearchSources?: InputMaybe<UpdateAvailableSearchSourcesInput>
  /** Space IDs for official resources that appears in a separate section at the top of search results and has higher priority in Ask AI feature */
  officialResourcesSpaceIds?: InputMaybe<Array<Scalars['String']>>
}

export type UpdateSpaceContentModuleInput = {
  contentModuleType: ContentModuleType
  whoCanCreate?: InputMaybe<Array<Scalars['String']>>
}

export type UpdateSpaceInput = {
  address?: InputMaybe<SpaceAddressInput>
  bannerId?: InputMaybe<Scalars['String']>
  collectionId?: InputMaybe<Scalars['ID']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  customSeoDetail?: InputMaybe<CustomSeoDetailInput>
  description?: InputMaybe<Scalars['String']>
  externalId?: InputMaybe<Scalars['String']>
  externalUrl?: InputMaybe<Scalars['String']>
  hidden?: InputMaybe<Scalars['Boolean']>
  imageId?: InputMaybe<Scalars['String']>
  inviteOnly?: InputMaybe<Scalars['Boolean']>
  layout?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  nonAdminsCanInvite?: InputMaybe<Scalars['Boolean']>
  private?: InputMaybe<Scalars['Boolean']>
  seoDetail?: InputMaybe<UpdateSpaceSeoDetailInput>
  slate?: InputMaybe<SlateUpdatesInput>
  slug?: InputMaybe<Scalars['String']>
  type?: InputMaybe<SpaceType>
  updatedAt?: InputMaybe<Scalars['DateTime']>
  whoCanPost?: InputMaybe<Array<Scalars['ID']>>
  whoCanReact?: InputMaybe<Array<Scalars['ID']>>
  whoCanReply?: InputMaybe<Array<Scalars['ID']>>
  withRoles?: InputMaybe<Scalars['Boolean']>
}

export type UpdateSpaceMemberRoleInput = {
  roleId: Scalars['String']
}

export type UpdateSpacePostTypeInput = {
  postTypeId: Scalars['ID']
  whoCanPost?: InputMaybe<Array<Scalars['ID']>>
  whoCanReact?: InputMaybe<Array<Scalars['ID']>>
  whoCanReply?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateSpaceSeoDetailInput = {
  description?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type UpdateSubscriberInput = {
  emailDigestEnabled?: InputMaybe<Scalars['Boolean']>
  emailDigestSendFrequency?: InputMaybe<EmailDigestFrequency>
  emailDigestWeeklySendDay?: InputMaybe<DayOfWeek>
  /** If enabled, the subscriber will receive email notifications. */
  emailSubscriptionEnabled?: InputMaybe<Scalars['Boolean']>
  /** For each FCM devices token, the subscriber will receive push notifications. */
  fcmDeviceTokens?: InputMaybe<Array<Scalars['String']>>
  /** Array of instant email triggers that the subscriber will receive. Similar to notification triggers, these can include various events that prompt an immediate email. If this array is empty, the subscriber will not receive any instant emails. */
  instantEmailTriggers?: InputMaybe<Array<NotificationTrigger>>
  /** If enabled, the subscriber will receive emails if they are mentioned in a post or reply. */
  mentionEmailEnabled?: InputMaybe<Scalars['Boolean']>
  /** If enabled, the subscriber will receive notifications if they are mentioned in a post or reply. */
  mentionSubscriptionEnabled?: InputMaybe<Scalars['Boolean']>
  /** If enabled, the subscriber will receive emails if they receive a message. */
  messageEmailEnabled?: InputMaybe<Scalars['Boolean']>
  /** Array of notification triggers that the subscriber will receive. If this array is empty, the subscriber will not receive any notifications. */
  notificationTriggers?: InputMaybe<Array<NotificationTrigger>>
  /** If enabled, the subscriber will receive emails if someone reacts to their post or reply. */
  reactionEmailEnabled?: InputMaybe<Scalars['Boolean']>
  /** If enabled, the subscriber will receive notifications if someone reacts to their post or reply. */
  reactionSubscriptionEnabled?: InputMaybe<Scalars['Boolean']>
}

export type UpdateTagInput = {
  description?: InputMaybe<Scalars['String']>
  slug?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type UpdateTemplateInput = {
  about?: InputMaybe<Scalars['String']>
  appIds?: InputMaybe<Array<Scalars['String']>>
  authorName?: InputMaybe<Scalars['String']>
  authorUrl?: InputMaybe<Scalars['String']>
  bannerId?: InputMaybe<Scalars['String']>
  categories?: InputMaybe<Array<Scalars['String']>>
  comingSoon?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  entityProperties?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['String']>
  hubContentId?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  onFreePlan?: InputMaybe<Scalars['Boolean']>
  previewHtml?: InputMaybe<Scalars['String']>
  privacyPolicyUrl?: InputMaybe<Scalars['String']>
  slate?: InputMaybe<SlateUpdatesInput>
  slug?: InputMaybe<Scalars['String']>
  termsOfServiceUrl?: InputMaybe<Scalars['String']>
}

export type UpdateTheme = {
  name: Scalars['String']
  status: ThemeStatus
  tokens: UpdateThemeTokens
}

export type UpdateThemeColor = {
  key: Scalars['String']
  weights: Array<UpdateThemeToken>
}

export type UpdateThemeColorToken = {
  key: Scalars['String']
  value: Scalars['String']
}

export type UpdateThemeColorTokens = {
  dark?: InputMaybe<Array<UpdateThemeColorToken>>
  light?: InputMaybe<Array<UpdateThemeColorToken>>
}

export type UpdateThemeColors = {
  dark?: InputMaybe<Array<UpdateThemeColor>>
  light?: InputMaybe<Array<UpdateThemeColor>>
}

export type UpdateThemeToken = {
  key: Scalars['String']
  value: Scalars['String']
}

export type UpdateThemeTokens = {
  breakpoints?: InputMaybe<Array<UpdateThemeToken>>
  colors?: InputMaybe<Array<UpdateThemeToken>>
  fontSizes?: InputMaybe<Array<UpdateThemeToken>>
  fontWeights?: InputMaybe<Array<UpdateThemeToken>>
  opacity?: InputMaybe<Array<UpdateThemeToken>>
  shadows?: InputMaybe<Array<UpdateThemeToken>>
  sizes?: InputMaybe<Array<UpdateThemeToken>>
  textStyles?: InputMaybe<Array<UpdateThemeToken>>
  zIndices?: InputMaybe<Array<UpdateThemeToken>>
}

export type UpdateThemes = {
  active: UpdateTheme
  drafts: Array<UpdateTheme>
  published: Array<UpdateTheme>
}

export type UpdateTopNavigation = {
  alignment: TopNavigationAlignment
  enabled: Scalars['Boolean']
  items: Array<UpdateNavigationItem>
}

export type UploadedMigrations = {
  migrationId: Scalars['String']
  results: Array<MigrationFileResult>
}

export type UpsertExtraPropertyInput = {
  entityId?: InputMaybe<Scalars['String']>
  entityType: ExtraPropertyEntityType
  key: Scalars['String']
  value: Scalars['String']
}

export type UpsertPageCustomResponse = {
  body?: InputMaybe<Scalars['String']>
  headers?: InputMaybe<Array<PageCustomResponseHeaderInput>>
  httpCode: Scalars['Int']
}

export type UpsertTheme = {
  active?: InputMaybe<Scalars['Boolean']>
  colorTokens?: InputMaybe<UpdateThemeColorTokens>
  colors?: InputMaybe<UpdateThemeColors>
  id: Scalars['String']
  name?: InputMaybe<Scalars['String']>
  typography?: InputMaybe<Array<UpdateThemeToken>>
}

export type UsernameAvailability = {
  available: Scalars['Boolean']
}

export type ValuePermissions = {
  isAuthorized: IsAuthorized
  value: Scalars['String']
}

/** ValuesCountInput class is used to filter fields of type array. It allows specifying conditions based on the count of values in the array. */
export type ValuesCountInput = {
  /** Greater than condition for the count of values in the array */
  gt?: InputMaybe<Scalars['Float']>
  /** Greater than or equal condition for the count of values in the array */
  gte?: InputMaybe<Scalars['Float']>
  /** Less than condition for the count of values in the array */
  lt?: InputMaybe<Scalars['Float']>
  /** Less than or equal condition for the count of values in the array */
  lte?: InputMaybe<Scalars['Float']>
}

export type VerifyMemberInput = {
  memberId: Scalars['String']
  verificationCode?: InputMaybe<Scalars['String']>
}

/** A virtual location where an event takes place online. */
export type VirtualLocation = {
  /** The unique identifier of the virtual location. */
  id: Scalars['ID']
  /** The provider of the virtual meeting (e.g., Zoom, Google Meet, Microsoft Teams). */
  provider: Scalars['String']
  /** The URL of the virtual meeting. */
  url: Scalars['String']
}

export type Vote = {
  createdAt: Scalars['String']
  id: Scalars['ID']
  memberId: Scalars['String']
  networkId: Scalars['String']
  pollId: Scalars['String']
  selectionIds: Array<Scalars['Int']>
  updatedAt: Scalars['String']
}

export type VoteInput = {
  /** The ID of the poll to vote on */
  pollId: Scalars['String']
  /** The IDs of the selected options */
  selectionIds: Array<Scalars['Int']>
  /** JWT vote token that authorizes this vote */
  voteToken: Scalars['String']
}

export type XFrameEmbeddingSettings = {
  /** Only used if status is enabledForSpecificDomains */
  allowedDomains?: Maybe<Array<Scalars['String']>>
  status: XFrameEmbeddingStatus
}

export type XFrameEmbeddingSettingsInput = {
  /** Only used if status is enabledForSpecificDomains */
  allowedDomains?: InputMaybe<Array<Scalars['String']>>
  status: XFrameEmbeddingStatus
}

export enum XFrameEmbeddingStatus {
  disabled = 'disabled',
  enabledForAll = 'enabledForAll',
  enabledForSpecificDomains = 'enabledForSpecificDomains',
}

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    By: ['Member'],
    In: ['Space'],
    Media: ['Emoji', 'File', 'Glyph', 'Image'],
    MessageMetadata: [
      'AddedParticipantsMetadata',
      'CreatedGroupMetadata',
      'DemotedAdminsMetadata',
      'EditedGroupMetadata',
      'LeftGroupMetadata',
      'PromotedAdminsMetadata',
      'RemovedParticipantsMetadata',
      'TransferredOwnershipMetadata',
    ],
    ModerationItemEntity: ['Member', 'Post'],
    PageEntity: ['Collection', 'Event', 'Member', 'Post'],
    PostLastActivityEntity: ['Post', 'PostReactionParticipant'],
    ReportDataValue: ['ChartData', 'EntityReport', 'IntValue', 'StringValue'],
    ReportableEntity: ['Event', 'Member', 'Post', 'Space', 'Tag'],
    SearchObjectEntity: ['Member', 'Post', 'Space'],
    TemplateCreatedEntity: ['Space'],
    TemplateEntity: [
      'Network',
      'Post',
      'PostType',
      'Space',
      'SpacePostType',
      'Tag',
    ],
  },
}
export default result
